{
  "common": {
    "save": "Speichern",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "add": "Hinzufügen",
    "search": "Suchen",
    "loading": "Lädt...",
    "error": "Fehler",
    "success": "Erfolg",
    "back": "Zurück",
    "next": "Weiter",
    "previous": "Zurück",
    "close": "Schließen",
    "appName": "{brand}",
    "searchPlaceholder": "Suchen...",
    "connectionReconnecting": "Verbindung wird wiederhergestellt...",
    "connectionLostClickRetry": "Verbindung verloren. Klicken zum Wiederholen.",
    "connectionOffline": "Offline",
    "searchExpandedPlaceholder": "Funktionen oder Docs durchsuchen...",
    "searchPromptEmpty": "Tippen, um Funktionen oder verwandte Dokumente zu durchsuchen",
    "searchSectionApplication": "Anwendung",
    "searchSectionDocumentation": "Dokumentation",
    "searchNoFeatureResults": "Keine Funktionen entsprechen dieser Suche",
    "searchNoDocResults": "Keine Dokumentation entspricht dieser Suche",
    "description": "Beschreibung",
    "preview": "Vorschau",
    "addTag": "Tag hinzufügen...",
    "searchProjects": "Projekte durchsuchen...",
    "searchModels": "Modelle durchsuchen...",
    "all": "Alle",
    "favorites": "Favoriten",
    "searchResource": "{{resource}} suchen...",
    "selectAll": "Alle auswählen",
    "clearAll": "Alle löschen",
    "resetToDefault": "Auf Standard zurücksetzen",
    "noOptionsAvailable": "Keine Optionen verfügbar",
    "noMoreItems": "Keine weiteren Elemente",
    "clearSearch": "Suche löschen",
    "apply": "Anwenden",
    "clear": "Löschen",
    "yes": "Ja",
    "no": "Nein",
    "notResource": "Nicht {{resource}}",
    "afterDate": "Nach {{date}}",
    "beforeDate": "Vor {{date}}",
    "removeFilter": "Filter {{label}} entfernen",
    "removeFilterWithColon": "Filter entfernen: {{label}}",
    "showResource": "{{resource}} anzeigen",
    "hideResource": "{{resource}} ausblenden",
    "saveChanges": "Änderungen speichern",
    "processing": "Wird verarbeitet...",
    "copy": "Kopieren",
    "copied": "Kopiert",
    "or": "oder",
    "filters": "Filter",
    "searchItem": "{{item}} suchen...",
    "searchItemAria": "{{item}} suchen",
    "searchPrompts": "Prompts suchen...",
    "showItem": "{{item}} anzeigen",
    "hideItem": "{{item}} ausblenden"
  },
  "productDocs": {
    "title": "Product documentation",
    "lead": "Guides for getting started, models, tools, Agent Studio, observability, and administration — served from the same site as the platform.",
    "openNewTab": "Open in new tab",
    "openSameWindow": "Open in this window",
    "hint": "Docs are not shown inside the app shell because some login or edge responses set X-Frame-Options: DENY on pages that are not meant to be embedded. Opening in a new tab or full window keeps clickjacking protection intact and is the recommended way to read documentation."
  },
  "agentStore": {
    "title": "Agenten-Store",
    "subtitle": "Enterprise-KI-Agenten entdecken und bereitstellen",
    "search": "Agenten nach Namen suchen...",
    "manage": "Verwalten",
    "manageTooltip": "Agenten-Store verwalten",
    "loading": "Agenten werden geladen...",
    "all": "Alle",
    "allAgents": "Alle Agenten",
    "allAgentsCount": "Alle Agenten ({{count}})",
    "resultsFound_one": "{{count}} Agent gefunden",
    "resultsFound_other": "{{count}} Agenten gefunden",
    "view": "Ansehen",
    "open": "Öffnen",
    "openApp": "App öffnen",
    "pending": "Ausstehend",
    "subscribe": "Abonnieren",
    "unnamedAgent": "Agent",
    "categoryOther": "Sonstiges",
    "noDescription": "Keine Beschreibung verfügbar",
    "noAgents": "Keine Agenten gefunden",
    "noAgentsInCategory": "Keine Agenten in {{category}} gefunden",
    "tryAdjusting": "Passen Sie Ihre Such- oder Filterkriterien an"
  },
  "catalogFilters": {
    "filters": "Filter",
    "filtersApplied": "Filter ({{count}} aktiv)",
    "clearAll": "Alle zurücksetzen",
    "creator": "Ersteller",
    "allCreators": "Alle Ersteller",
    "searchCreators": "Ersteller suchen...",
    "rating": "Bewertung",
    "allRatings": "Alle Bewertungen",
    "rating5": "5 Sterne",
    "rating4Up": "4 Sterne und mehr",
    "rating3Up": "3 Sterne und mehr",
    "allOf": "Alle {{label}}"
  },
  "nav": {
    "home": "Startseite",
    "ideate": "Decision Intelligence Plattform",
    "solutions": "Lösungen",
    "agentStore": "Agenten-Store",
    "projects": "Projekte",
    "data": "Daten",
    "agentStudio": "Agent Studio",
    "agentWorkflows": "Agenten-Workflows",
    "registry": "Registry",
    "registryUnified": "Registry",
    "aiTransparency": "KI-Transparenz",
    "workflowStore": "Workflow-Store",
    "workflowRegistry": "Workflow-Registry",
    "agentDeployments": "Agenten-Deployments",
    "workflowDeployments": "Workflow-Deployments",
    "workflowStoreBrowse": "Workflows durchsuchen",
    "workflowStoreManage": "Workflow-Store verwalten",
    "workflowStoreAbout": "Workflow-Details",
    "simulations": "Simulationen",
    "evalsSimulations": "Evaluierungen",
    "benchmarks": "Benchmarks",
    "monitoring": "Überwachung",
    "cache": "Cache",
    "agentEvals": "Agent Evals",
    "evalTemplates": "Eval-Vorlagen",
    "environments": "Umgebungen",
    "evaluations": "Auswertungen",
    "agents": "Agenten",
    "models": "Modelle",
    "tools": "Werkzeuge",
    "prompts": "Eingabeaufforderungen",
    "skills": "Skills",
    "knowledge": "Wissen",
    "connections": "Verbindungen",
    "docs": "Dokumentation",
    "admin": "Administration",
    "platformAdmin": "Plattform-Admin",
    "settings": "Einstellungen",
    "chat": "Chat",
    "goToHome": "Zur Startseite",
    "userMenu": "Benutzermenü",
    "account": "Konto",
    "switchRole": "Rolle wechseln",
    "tenant": "Mandant",
    "logout": "Abmelden",
    "help": "Hilfe",
    "helpDocumentation": "Hilfe & Dokumentation",
    "themeDarkModeTitle": "Dunkelmodus",
    "themeLightModeTitle": "Hellmodus",
    "themeSwitchToDarkAria": "Zum Dunkelmodus wechseln",
    "themeSwitchToLightAria": "Zum Hellmodus wechseln",
    "sections": {
      "agentDevelop": "Agent-Entwicklung",
      "observability": "Observability",
      "agentOps": "Agent-Ops",
      "resources": "Ressourcen",
      "admin": "Administration",
      "aiBlueprints": "Blueprints",
      "enterpriseOntology": "Enterprise Ontology"
    },
    "ontologyCanvas": "Ontologie-Canvas",
    "ontoEval": "Onto-Eval",
    "dataModels": "Datenmodelle",
    "kpiLibrary": "KPI-Bibliothek",
    "semanticHub": "Semantik-Hub",
    "migrationsStudio": "Migrations-Studio",
    "dataPipelines": "Datenstudio",
    "pipelineDesigner": "ML-Studio",
    "dataExplorer": "Daten-Explorer",
    "dataObservability": "Daten-Observability",
    "switchToDataflow": "{brand} Ontology Studio",
    "blueprints": "Blaupausen",
    "autopilot": "Entscheidungsintelligenz-Plattform",
    "brandMilkyway": "{brand}",
    "brandPlatform": "{brand} Platform",
    "switchToMilkyway": "{brand}",
    "switchToPlatform": "{brand} Platform"
  },
  "settings": {
    "title": "Einstellungen",
    "description": "Verwalten Sie Ihre Kontoeinstellungen und Präferenzen",
    "profile": "Benutzerprofil",
    "appearance": "Erscheinungsbild",
    "language": "Sprache",
    "languageDescription": "Wählen Sie Ihre bevorzugte Sprache",
    "theme": "Design",
    "light": "Hell",
    "dark": "Dunkel",
    "appearanceHeading": "Erscheinungsbild",
    "appearanceSubtitle": "Passen Sie das Aussehen Ihres Arbeitsbereichs an",
    "colorTheme": "Farbschema",
    "colorThemeDescription": "Wählen Sie eine Farbpalette für die Anwendung",
    "displayModeSection": "Anzeigemodus",
    "displayModeDescription": "Wählen Sie zwischen Hell- und Dunkelmodus",
    "themeDefaultBadge": "Standard",
    "loadingAppearance": "Erscheinungsbild-Einstellungen werden geladen...",
    "notifications": {
      "title": "Benachrichtigungen"
    },
    "integrations": {
      "title": "Integrationen"
    }
  },
  "models": {
    "title": "Modelle",
    "addModel": "Modell hinzufügen",
    "editModel": "Modell bearbeiten",
    "modelName": "Modellname",
    "provider": "Anbieter",
    "baseUrl": "Basis-URL",
    "chat": "Chatten",
    "deleteConfirm": "Möchten Sie dieses Modell wirklich löschen?",
    "noModels": "Keine Modelle gefunden",
    "filterProvider": "Anbieter",
    "filterStatus": "Status",
    "filterCreator": "Ersteller",
    "statusActive": "Aktiv",
    "statusDeprecated": "Veraltet",
    "columnModelName": "Modellname",
    "columnProvider": "Anbieter",
    "columnStatus": "Status",
    "columnAccess": "Zugriff",
    "columnCreatedBy": "Erstellt von",
    "columnCreatedAt": "Erstellt am",
    "columnUpdatedAt": "Aktualisiert am",
    "columnActions": "Aktionen",
    "actionChat": "Chatten",
    "actionTestConnection": "Verbindung testen",
    "actionSetDefault": "Als Standard festlegen",
    "actionRemoveDefault": "Als Standard entfernen",
    "actionManageAccess": "Zugriff verwalten",
    "actionExport": "Exportieren",
    "actionEdit": "Bearbeiten",
    "actionDelete": "Löschen",
    "bulkExportSelected": "Ausgewählte exportieren",
    "bulkDeleteSelected": "Ausgewählte löschen",
    "modelArena": "Modell-Arena",
    "modelArenaTitle": "2 Modelle in der Modell-Arena vergleichen",
    "pricingCatalog": "Preiskatalog",
    "pricingCatalogTitle": "USD-pro-1M-Preisintervalle anzeigen und bearbeiten",
    "deleteModalTitle": "Modell löschen",
    "deleteModalMessage": "Möchten Sie „{{name}}“ wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "bulkDeleteModalTitle": "Ausgewählte Modelle löschen",
    "bulkDeleteModalMessage": "Möchten Sie wirklich {{count}} Modell{{s}} löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "bulkDeleteModalConfirm": "{{count}} Modell{{s}} löschen",
    "loadingModels": "Modelle werden geladen...",
    "favorites": "Favoriten",
    "filterBarTitle": "Filteroptionen",
    "searchPlaceholder": "Modelle durchsuchen...",
    "defaultModelTooltip": "Standardmodell",
    "pricing": {
      "title": "Preiskatalog",
      "description": "USD pro 1 Million Token – sortiert nach günstigstem Input unter sichtbaren Modellen. Verwenden Sie {{endpoint}} zum Anbietervergleich.",
      "descriptionPrefix": "USD pro 1 Million Token – sortiert nach günstigstem Input unter sichtbaren Modellen. Verwenden Sie",
      "descriptionSuffix": "zum Anbietervergleich.",
      "allProviders": "Alle Anbieter",
      "fromInput": "ab ${{price}}/in",
      "fromInputTooltip": "Ab ${{price}} / 1M Input (sichtbare Modelle)",
      "viewMore": "{{count}} weitere anzeigen",
      "searchPlaceholder": "Modelle oder Anbieter suchen…",
      "emptyMessage": "Keine Modelle gefunden.",
      "loadingMessage": "Preiskatalog wird geladen…",
      "loadModelsFailed": "Modelle konnten nicht geladen werden",
      "harvestSuccess": "Preiserfassung abgeschlossen: {{summary}}",
      "harvestFailed": "Preiserfassung fehlgeschlagen",
      "modelsPriced": "{{count}} Modell bewertet",
      "modelsPriced_plural": "{{count}} Modelle bewertet",
      "skippedCount": "{{count}} übersprungen",
      "errorsCount": "{{count}} Fehler",
      "errorsCount_plural": "{{count}} Fehler",
      "viewHistory": "Verlauf anzeigen",
      "noPricing": "Keine Preisangabe",
      "live": "Aktiv",
      "notOpenEnded": "Nicht unbefristet",
      "notOpenEndedTooltip": "Die letzte Zeile ist ein geschlossenes Intervall – stellen Sie sicher, dass ein offenes Intervall für zukünftige Preise existiert.",
      "columns": {
        "model": "Modell",
        "inputRate": "Input-Preis",
        "outputRate": "Output-Preis",
        "interval": "Intervall",
        "source": "Quelle"
      },
      "history": {
        "title": "Preisverlauf",
        "subtitle": "Vollständiger Preisverlauf. Die aktive Katalogzeile steht an erster Stelle; manuelle Intervalle und erfasste Raten können bearbeitet werden (Bearbeitungen werden zu manuellen Überschreibungen). Nur manuelle Intervalle können gelöscht werden.",
        "currentCatalogRate": "Aktuelle Katalograte",
        "liveOpenEnded": "Aktiv (unbefristet)",
        "notOpenEnded": "Nicht unbefristet",
        "notOpenEndedTooltip": "Kein unbefristetes Intervall – neuester geschlossener Zeitraum wird als Fallback angezeigt.",
        "searchPlaceholder": "Quelle, Daten, Raten suchen…",
        "emptyMessage": "Keine Einträge im Preisverlauf entsprechen dieser Suche.",
        "loadingMessage": "Preisverlauf wird geladen…",
        "failedToLoad": "Preisverlauf konnte nicht geladen werden",
        "refresh": "Aktualisieren",
        "addManualInterval": "Manuelles Intervall hinzufügen",
        "activeRate": "Aktive Rate",
        "historical": "Historisch",
        "effectiveFrom": "Gültig ab",
        "effectiveUntil": "Gültig bis",
        "unit": "Einheit",
        "inputRate": "Input-Preis",
        "outputRate": "Output-Preis",
        "source": "Quelle",
        "deleteModalTitle": "Preisintervall löschen",
        "deleteModalMessage": "Sind Sie sicher, dass Sie dieses manuelle Preisintervall löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        "delete": "Löschen",
        "intervalAdded": "Preisintervall hinzugefügt",
        "intervalUpdated": "Preisintervall aktualisiert",
        "intervalDeleted": "Preisintervall gelöscht",
        "failedToAdd": "Preisintervall konnte nicht hinzugefügt werden",
        "failedToUpdate": "Preisintervall konnte nicht aktualisiert werden",
        "failedToDelete": "Preisintervall konnte nicht gelöscht werden",
        "units": {
          "perMinute": "pro Minute",
          "perMillionChars": "pro 1M Zeichen",
          "perMillionTokens": "pro 1M Token"
        }
      },
      "modal": {
        "addTitle": "Preisintervall hinzufügen",
        "editTitle": "Preisintervall bearbeiten",
        "model": "Modell",
        "selectModel": "Modell auswählen...",
        "effectiveFrom": "Gültig ab",
        "effectiveUntil": "Gültig bis",
        "effectiveUntilHelp": "Optional – leer lassen für ein offenes Intervall (derzeit aktive Preise).",
        "unit": "Einheit",
        "unitOptions": {
          "tokens": "Pro 1M Token (LLM / Embeddings)",
          "minute": "Pro Minute (STT / Audio)",
          "chars": "Pro 1M Zeichen (TTS)"
        },
        "fieldLabels": {
          "usdPerMinute": "USD pro Minute",
          "outputPriceOptional": "Output-Preis (optional)",
          "inputPriceOptional": "Input-Preis (optional)",
          "usdPer1MChars": "USD pro 1M Zeichen",
          "inputUsdPer1MTokens": "Input-USD pro 1M Token",
          "outputUsdPer1MTokens": "Output-USD pro 1M Token"
        },
        "validation": {
          "selectModel": "Bitte wählen Sie ein Modell aus",
          "effectiveFromRequired": "Gültig-ab-Datum ist erforderlich",
          "effectiveFromFormat": "Gültig ab muss im Format JJJJ-MM-TT sein",
          "effectiveUntilFormat": "Gültig bis muss im Format JJJJ-MM-TT sein",
          "effectiveUntilAfterFrom": "Gültig bis muss am oder nach dem Gültig-ab-Datum liegen",
          "inputNonNegative": "Input-USD muss eine nicht-negative Zahl sein",
          "outputNonNegative": "Output-USD muss eine nicht-negative Zahl sein"
        },
        "cancel": "Abbrechen",
        "save": "Intervall speichern",
        "add": "Intervall hinzufügen",
        "saving": "Wird gespeichert..."
      }
    },
    "form": {
      "addTitle": "Modell hinzufügen",
      "editTitle": "Modell bearbeiten",
      "loadingQuota": "Kontingent wird geladen...",
      "modelType": "Modelltyp",
      "cannotChangeTypeAfterCreation": "Kann nach der Erstellung nicht geändert werden ({{type}})",
      "provider": "Anbieter",
      "providerTooltip": "Wählen Sie den KI-Anbieter aus. Es werden {{count}} kompatible Anbieter für den ausgewählten Modelltyp angezeigt.",
      "showingEmbeddingProviders": "Es werden {{count}} Anbieter mit Embedding-Unterstützung angezeigt",
      "showingTypeProviders": "Es werden {{count}} {{type}}-Anbieter angezeigt",
      "providerLockedTooltip": "Anbieter kann nach der Erstellung nicht geändert werden.",
      "selectModel": "Modell auswählen",
      "optionalTemplate": "(optionale Vorlage)",
      "discoverFallbackTooltip": "Bevorzugen Sie oben „Erkennen“ für Live-Arbeitsbereichsendpunkte; Vorlagen sind ein Fallback.",
      "availableModelsTooltip": "Wählen Sie aus verfügbaren {{provider}} {{type}}-Modellen ({{count}} verfügbar)",
      "selectAModel": "Modell auswählen",
      "selectATypeModel": "Wählen Sie ein {{type}}-Modell aus",
      "discovered": "erkannt",
      "baseUrl": "Basis-URL",
      "baseUrlTooltip": "Erforderlich für lokale Anbieter wie Ollama oder LM Studio. Für Cloud-Anbieter leer lassen.",
      "apiKeyRef": "API-Schlüssel-Referenz",
      "apiKeyRefTooltip": "Name der Umgebungsvariablen, die den Anbieter-API-Schlüssel enthält (in der Backend-Bereitstellung konfiguriert).",
      "displayName": "Anzeigename",
      "displayNameModelIdSetTooltip": "Modell-ID wird aus dem oben ausgewählten Modell festgelegt.",
      "displayNameAutoGeneratedTooltip": "Modell-ID wird automatisch aus dem Anzeigenamen generiert, wenn kein Modell ausgewählt ist.",
      "fullModelNamePreview": "Vollständige Modellnamenvorschau:",
      "displayNamePlaceholder": "z. B. Chat-Vervollständigung",
      "apiVersion": "API-Version",
      "apiVersionTooltip": "Vom Gateway erforderliche API-Version",
      "paramProfile": "Parameterprofil",
      "defaultParams": "Standardparameter (JSON)",
      "defaultParamsTooltip": "Optionales JSON-Objekt mit Standardparametern, die bei jeder Anfrage an das Modell gesendet werden (z. B. temperature, max_tokens).",
      "testSuccess": "✓ Verbindungstest erfolgreich",
      "testFailed": "✗ Verbindungstest fehlgeschlagen",
      "modelResponse": "Modellantwort:",
      "testing": "Wird getestet...",
      "testConnection": "Verbindung testen",
      "testConnectionTitle": "Verbindung vor dem Speichern testen",
      "addModel": "Modell hinzufügen",
      "adding": "Wird hinzugefügt...",
      "saving": "Wird gespeichert...",
      "quotaExceeded": "Modellkontingent überschritten",
      "noChangesToSave": "Keine Änderungen zu speichern",
      "selectProvider": "Anbieter auswählen"
    },
    "tags": {
      "llm": "Text",
      "image": "Bild",
      "embedding": "Embedding",
      "audio": "Audio",
      "video": "Video",
      "reranker": "Reranker",
      "tts": "Text-zu-Sprache",
      "stt": "Sprache-zu-Text"
    },
    "tagDescriptions": {
      "llm": "Textmodelle generieren Sprachantworten für Chat- und Vervollständigungsaufgaben",
      "image": "Bildmodelle generieren, bearbeiten oder analysieren visuelle Inhalte",
      "embedding": "Embedding-Modelle wandeln Text in Vektoreinbettungen für semantische Suche und Abruf um",
      "audio": "Audiomodelle verarbeiten und generieren Ton und Musik",
      "video": "Videomodelle generieren und bearbeiten Videoinhalte",
      "reranker": "Reranking-Modelle bewerten und ordnen Dokumente nach Relevanz für eine Abfrage",
      "tts": "Sprachmodelle generieren gesprochenes Audio aus Text – nicht für Chat oder Textvervollständigung",
      "stt": "Transkriptionsmodelle konvertieren Audio in Text – nicht für Chat oder Textvervollständigung"
    },
    "emptyState": {
      "permissionDenied": "Sie haben keine Berechtigung zum Anzeigen von Modellen. Wenden Sie sich an Ihren Administrator.",
      "noResultsSearch": "Keine Modelle gefunden, die Ihrer Suche entsprechen.",
      "default": "Keine Modelle gefunden. Erstellen Sie Ihr erstes Modell, um zu beginnen."
    }
  },
  "chat": {
    "title": "Chat",
    "placeholder": "Geben Sie Ihre Nachricht ein...",
    "send": "Senden",
    "modelNotSelected": "Kein Modell ausgewählt",
    "modelNotFound": "Modell nicht gefunden",
    "failedToLoad": "Modell konnte nicht geladen werden",
    "failedToSend": "Nachricht konnte nicht gesendet werden",
    "ollamaNotRunning": "Kann nicht mit Ollama verbinden. Stellen Sie sicher, dass Ollama läuft: ollama serve",
    "modelNotFoundOllama": "Modell nicht gefunden oder Ollama läuft nicht. Bitte überprüfen Sie Ihre Ollama-Installation.",
    "modelArena": {
      "title": "Modell-Arena",
      "vs": "VS",
      "selectModel": "Modell auswählen",
      "startConversation": "Gespräch starten",
      "processing": "Wird verarbeitet...",
      "recording": "Aufnahme läuft...",
      "record": "Aufnehmen",
      "stop": "Stoppen",
      "or": "oder",
      "uploadAudio": "Audio hochladen",
      "query": "Abfrage",
      "documents": "Dokumente (eines pro Zeile, mind. 2)",
      "compare": "Vergleichen",
      "enterInput": "Eingabe...",
      "noImageOrText": "Kein Bild oder Text zurückgegeben",
      "noVideoReturned": "Kein Video zurückgegeben",
      "copied": "Kopiert",
      "copy": "Kopieren",
      "copyResponse": "Antwort kopieren",
      "startRecording": "Aufnahme starten",
      "stopRecording": "Aufnahme stoppen",
      "cannotChangeModel": "Das Modell kann nach dem Chatstart nicht mehr geändert werden",
      "cannotChangeType": "Der Modelltyp kann nach dem Chatstart nicht mehr geändert werden",
      "noModelsAvailable": "Keine Modelle verfügbar",
      "addAnotherModel": "Ein weiteres Modell zum Vergleich hinzufügen",
      "onlyOneModelAvailable": "Es ist nur ein Modell verfügbar. Die Modell-Arena benötigt zwei verschiedene Modelle.",
      "sameModelSelected": "Sie haben auf beiden Seiten dasselbe Modell ausgewählt. Bitte wählen Sie ein anderes Modell.",
      "startBeforeRating": "Starten Sie ein Gespräch, bevor Sie diese Sitzung bewerten",
      "restoreView": "Geteilte Ansicht wiederherstellen",
      "expandLeft": "Linkes Panel erweitern",
      "expandRight": "Rechtes Panel erweitern",
      "selectModel2": "Modell auswählen...",
      "searchModels": "Modelle suchen...",
      "syncedToBoth": "{{placeholder}} (auf beide synchronisiert)",
      "placeholders": {
        "searchQuery": "Suchanfrage eingeben...",
        "rerankDocs": "Dokument 1 Text...\nDokument 2 Text...\nDokument 3 Text...",
        "tts": "Text zum Synthetisieren eingeben...",
        "image": "Zu generierendes Bild beschreiben...",
        "video": "Zu generierendes Video beschreiben... (kann einige Minuten dauern)"
      },
      "types": {
        "llm": "Text",
        "image": "Bild",
        "audio": "Audio",
        "video": "Video",
        "reranker": "Rerank",
        "tts": "Sprache",
        "stt": "Transkription"
      },
      "typeDescriptions": {
        "llm": "Textmodelle generieren Sprachantworten für Chat und Vervollständigung",
        "image": "Bildmodelle erzeugen oder bearbeiten Bilder aus Textprompts",
        "audio": "Audiomodelle verarbeiten oder erzeugen nicht-sprachliche Audioinhalte",
        "video": "Videomodelle erzeugen oder analysieren Videoinhalte",
        "reranker": "Rerank-Modelle ordnen abgerufene Dokumente für bessere RAG-Relevanz neu",
        "tts": "Sprachmodelle erzeugen gesprochenes Audio aus Text",
        "stt": "Transkriptionsmodelle wandeln Audio in Text um"
      }
    },
    "newChat": "Neuer Chat",
    "newSession": "Neuer Chat",
    "endOfSessions": "Ende der Sitzungen",
    "noSessionsYet": "Noch keine Modell-Arena-Sitzungen",
    "startNewConversation": "Neues Gespräch starten",
    "startConversation": "Gespräch starten",
    "startConversationWithModel": "Gespräch mit diesem Modell starten",
    "configuration": "Konfiguration",
    "collapseConfig": "Einklappen",
    "expandConfig": "Konfiguration",
    "backToModels": "Zurück zu Modellen",
    "refreshSessions": "Sitzungen aktualisieren",
    "activeSessionEmpty": "Aktive Sitzung ist leer",
    "newModelArena": "Neue Modell-Arena",
    "loadingDot": "Wird geladen...",
    "loadingMore": "Weitere laden...",
    "sessionRenamed": "Sitzung umbenannt",
    "failedToRename": "Sitzung umbenennen fehlgeschlagen",
    "sessionDeleted": "Sitzung erfolgreich gelöscht",
    "failedToDelete": "Sitzung löschen fehlgeschlagen",
    "deleteSession": "Modell-Arena-Sitzung löschen",
    "deleteSessionConfirm": "Möchten Sie diese Modell-Arena-Sitzung wirklich löschen? Dabei werden auch beide Einzelmodell-Sitzungen gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    "rename": "Umbenennen",
    "delete": "Löschen",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "selectPrompt": "Prompt auswählen...",
    "searchPrompts": "Prompts suchen...",
    "selectSkills": "Skills auswählen...",
    "searchSkills": "Skills suchen...",
    "version": "Version",
    "rateSession": "Sitzung bewerten",
    "rateThisSession": "Diese Sitzung bewerten",
    "updateFeedback": "Feedback aktualisieren",
    "helpful": "Hilfreich",
    "notHelpful": "Nicht hilfreich",
    "rated": "Bewertet {{value}}/10",
    "feedbackProvided": "Feedback gegeben",
    "startBeforeRating": "Starten Sie eine Unterhaltung, bevor Sie diese Sitzung bewerten",
    "selectHelpful": "Bitte wählen Sie Hilfreich oder Nicht hilfreich vor dem Absenden",
    "failedToSaveComparisonFeedback": "Vergleichsfeedback konnte nicht gespeichert werden",
    "feedbackSubmitted": "Feedback erfolgreich gesendet",
    "failedToSubmitSessionFeedback": "Sitzungsfeedback konnte nicht gesendet werden",
    "promptTemplate": "Prompt-Vorlage",
    "skills": "Fähigkeiten",
    "model": "Modell",
    "sttModel": "Sprache-zu-Text (Anhänge)",
    "knowledge": "Wissen",
    "tools": "Werkzeuge",
    "settings": "Einstellungen"
  },
  "admin": {
    "title": "Administration",
    "users": "Benutzer",
    "roles": "Rollen",
    "pending": "Ausstehend",
    "active": "Aktiv"
  },
  "solutions": {
    "title": "Lösungen",
    "subtitle": "Repos und Code entdecken und teilen — mit Schnellzugriff auf QA, UAT und Produktion.",
    "addSolution": "Lösung hinzufügen",
    "dialogTitle": "Lösung hinzufügen",
    "editDialogTitle": "Lösung bearbeiten",
    "submit": "Zum Katalog hinzufügen",
    "submitEdit": "Änderungen speichern",
    "empty": "Noch keine Lösungen. Erstellen Sie die erste, damit Ihr Team Umgebungen schneller findet.",
    "openGithub": "GitHub-Repository öffnen",
    "editSolution": "Lösung bearbeiten",
    "deleteSolution": "Lösung löschen",
    "deleteSelected": "Auswahl löschen",
    "openEditor": "Editor öffnen",
    "sourceGithub": "GitHub-URL",
    "sourceCode": "Code-Dateien",
    "codeHint": "Nach dem Anlegen öffnet sich der Code-Editor zum Bearbeiten der Dateien.",
    "shortcutHint": "Tipp: Strg/⌘ + Enter sendet das Formular.",
    "toast": {
      "created": "Lösung wurde zum Katalog hinzugefügt.",
      "updated": "Lösung aktualisiert.",
      "deleted": "Lösung gelöscht.",
      "bulkDeleted": "{{deleted}} Lösung(en) gelöscht. {{skipped}} übersprungen.",
      "conflict": "Diese Lösung wurde woanders geändert. Bitte Seite neu laden, um die aktuelle Version zu sehen."
    },
    "fields": {
      "name": "Name der Lösung",
      "description": "Beschreibung",
      "githubUrl": "GitHub-Repository-URL",
      "sourceType": "Quelltyp",
      "tags": "Tags",
      "owner": "Besitzer"
    },
    "placeholders": {
      "description": "Kurzbeschreibung (2–3 Zeilen)"
    },
    "validation": {
      "nameRequired": "Name ist erforderlich.",
      "nameTooLong": "Der Name darf höchstens {{max}} Zeichen haben.",
      "descriptionTooLong": "Die Beschreibung darf höchstens {{max}} Zeichen haben.",
      "githubRequired": "GitHub-URL ist erforderlich.",
      "githubInvalid": "Geben Sie eine gültige https-GitHub-Repository-URL ein.",
      "urlInvalid": "Muss eine gültige http(s)-URL sein."
    },
    "confirmDeleteTitle": "Lösung löschen",
    "confirmDeleteMessage": "Möchten Sie „{{name}}“ wirklich löschen? Die Lösung und alle Dateien werden dauerhaft entfernt.",
    "confirmBulkDeleteTitle": "Ausgewählte Lösungen löschen",
    "confirmBulkDeleteMessage": "Möchten Sie wirklich {{count}} Lösung(en) löschen? Die Lösungen und alle Dateien werden dauerhaft entfernt.",
    "editor": {
      "explorer": "Explorer",
      "newFile": "Neue Datei",
      "noFiles": "Noch keine Dateien.",
      "addFirstFile": "Datei hinzufügen",
      "selectFile": "Wählen Sie im Explorer eine Datei zum Bearbeiten.",
      "noFileSelected": "Keine Datei ausgewählt",
      "saveChanges": "Änderungen speichern",
      "saved": "Gespeichert",
      "unsavedChanges": "Ungespeicherte Änderungen",
      "deleteFile": "Datei löschen",
      "confirmDelete": "„{{file}}“ löschen? Dies kann nicht rückgängig gemacht werden.",
      "delete": "Löschen",
      "fileExists": "Eine Datei mit diesem Pfad existiert bereits.",
      "notFound": "Lösung nicht gefunden.",
      "backToList": "Zurück zu Lösungen",
      "settings": "Einstellungen",
      "metadataTitle": "Lösungseinstellungen",
      "metadataSaved": "Einstellungen gespeichert."
    }
  },
  "tenant": {
    "switch": "Mandant wechseln",
    "subdomain": "Subdomain:"
  },
  "home": {
    "tabs": {
      "overview": "Übersicht",
      "agents": "Agenten",
      "workflows": "Workflows",
      "evals": "Auswertungen",
      "sessions": "Sitzungen",
      "cost": "Kosten",
      "platform": "Plattform"
    },
    "dateRangeAriaLabel": "Dashboard-Zeitraum",
    "sectionInfoAriaLabel": "Abschnittsinfo",
    "viewLabel": "{{label}} anzeigen",
    "loading": "Dashboard wird geladen...",
    "loadFailed": "Daten konnten nicht geladen werden",
    "retry": "Erneut versuchen",
    "noDataAvailable": "Keine Daten verfügbar",
    "noData": "Keine Daten",
    "quickActions": {
      "createAgent": "Agent erstellen",
      "newWorkflow": "Neuer Workflow",
      "runEval": "Auswertung starten",
      "aiAgentBuilder": "KI-Agent-Builder",
      "aiWorkflowsBuilder": "KI-Workflow-Builder",
      "agentStore": "Agent Store",
      "tools": "Tools"
    },
    "activity": {
      "title": "Letzte Aktivität",
      "export": "Exportieren",
      "filterAll": "Alle",
      "filterUpdate": "Aktualisierung",
      "filterCreate": "Erstellung",
      "filterDelete": "Löschung",
      "noActivityFound": "Keine Aktivität gefunden",
      "actionCreate": "ERSTELLT",
      "actionUpdate": "AKTUALISIERT",
      "actionDelete": "GELÖSCHT",
      "actionRead": "GELESEN",
      "resourceIdTitle": "Ressourcen-ID",
      "viewAll": "Alle anzeigen"
    },
    "overview": {
      "kpi": {
        "totalAgents": "Agenten gesamt",
        "totalAgentsHintDefault": "Im ausgewählten Zeitraum erstellt",
        "totalAgentsHintAllTenants": "Im ausgewählten Zeitraum erstellt · alle Mandanten · ohne archivierte",
        "totalAgentsHintStudio": "Im ausgewählten Zeitraum erstellt · gleicher Umfang wie Agent Studio",
        "totalWorkflows": "Workflows gesamt",
        "activeUsers": "Aktive Benutzer",
        "activeDeployments": "Aktive Bereitstellungen",
        "activeDeploymentsHint": "Im ausgewählten Zeitraum erstellte aktive Bereitstellungen",
        "sessions": "Sitzungen",
        "evalRuns": "Auswertungsläufe",
        "toolCalls": "Tool-Aufrufe",
        "archivedDelta": "archiviert",
        "totalProjects": "Projekte gesamt",
        "activeProjects": "Aktive Projekte",
        "modelsAvailable": "Verfügbare Modelle",
        "toolsAvailable": "Verfügbare Tools",
        "activeConnections": "Aktive Verbindungen",
        "pendingApprovals": "Ausstehende Genehmigungen",
        "actionNeeded": "Handlung erforderlich"
      },
      "funnel": {
        "active": "Aktiv",
        "deployments": "Bereitstellungen"
      },
      "series": {
        "agentsCreated": "Erstellte Agenten",
        "projects": "Projekte",
        "sessions": "Sitzungen",
        "workflows": "Workflows",
        "evals": "Auswertungen",
        "medianRuntime": "Mittlere Laufzeit (ms)",
        "retryRate": "Wiederholungsrate %",
        "slaBreaches": "SLA-Verstöße"
      },
      "platformTrendTitle": "Plattformtrend",
      "platformTrendSubtitle": "Wachstum und Aktivität der Plattform-Entitäten im Zeitverlauf",
      "loadingPlatformTrend": "Plattformtrend wird geladen...",
      "loadingActivity": "Aktivität wird geladen...",
      "quickActionsTitle": "Schnellaktionen",
      "adoptionHealthTitle": "Akzeptanz & Zustand",
      "adoptionFunnelTitle": "Akzeptanztrichter",
      "adoptionFunnelSubtitle": "Projektverlauf von der Einrichtung bis zur aktiven Nutzung",
      "adoptionFunnelInfo": "Zeigt, wie Projekte von der Erstellung über die aktive Bereitstellung bis zur Sitzungsnutzung fortschreiten. Jeder Balken zeigt die Anzahl der Projekte, die diese Stufe erreicht haben.",
      "topRiskSignalTitle": "Wichtigstes Risikosignal",
      "topRiskSignalSubtitle": "Kritischstes Plattformrisiko und Zustandswarnungen",
      "topRiskSignalInfo": "Hebt das aktuell kritischste Plattformrisiko hervor, basierend auf Workflow-Fehlerraten und Sitzungsaktivitätstrends. Das Diagramm zeigt die Anzahl der SLA-Verstöße.",
      "riskSeverityWarn": "Warnung",
      "noActiveRiskSignal": "Kein aktives Risikosignal",
      "metricFallback": "Metrik",
      "workflowHealthTitle": "Workflow-Zustand",
      "workflowHealthSubtitle": "Leistungs- und Zuverlässigkeitskennzahlen für Ausführungen",
      "workflowHealthInfo": "Verfolgt den Zustand von Workflow-Ausführungen. Die mittlere Laufzeit zeigt die Verarbeitungsgeschwindigkeit, die Wiederholungsrate weist auf Zuverlässigkeitsprobleme hin, und SLA-Verstöße kennzeichnen fehlgeschlagene oder abgelaufene Ausführungen.",
      "actionableHighlightsTitle": "Umsetzbare Erkenntnisse",
      "actionableHighlightsSubtitle": "Top-Entitäten nach Aktivität und Empfehlungen",
      "actionableHighlightsInfo": "Top-Projekte nach Sitzungsaktivität und Auswertungsabdeckung.\n\nGesundheitsstatus:\n• Gut: > 0 Sitzungen, > 0 Auswertungen\n• Warnung: > 0 Sitzungen, 0 Auswertungen\n• Schlecht: 0 Sitzungen\n\nJede Zeile zeigt Sitzungsanzahl, Auswertungsläufe und eine empfohlene Maßnahme zur Verbesserung der Plattformakzeptanz oder -qualität.",
      "noHighlightsYet": "Noch keine Highlights",
      "table": {
        "entity": "Entität",
        "type": "Typ",
        "sessions": "Sitzungen",
        "evalRuns": "Auswertungsläufe",
        "failurePercent": "Fehlerquote %",
        "health": "Zustand",
        "recommendedAction": "Empfohlene Maßnahme"
      }
    },
    "na": "n. v.",
    "agents": {
      "kpi": {
        "draft": "Entwurf",
        "published": "Veröffentlicht",
        "registered": "Registriert",
        "deployed": "Bereitgestellt",
        "storeListings": "Store-Einträge"
      },
      "sections": {
        "byEnvironment": "Agenten nach Umgebung",
        "byStatus": "Agentenstatus",
        "registryStatus": "Registrierungsstatus",
        "deploymentPipeline": "Bereitstellungspipeline",
        "byProjectsTitle": "Agenten nach Projekten",
        "byProjectsSubtitle": "Verteilung der Agenten auf Projekte"
      },
      "barName": "Agenten"
    },
    "workflows": {
      "kpi": {
        "executions": "Ausführungen",
        "successRate": "Erfolgsquote",
        "activeSchedules": "Aktive Zeitpläne"
      },
      "sections": {
        "executionStatus": "Ausführungsstatus",
        "triggerSource": "Auslösequelle",
        "executionVolumeTitle": "Ausführungsvolumen",
        "executionVolumeSubtitle": "Gesamtzahl der Workflow-Ausführungen im ausgewählten Zeitraum",
        "successRateTrendTitle": "Trend der Erfolgsquote",
        "successRateTrendSubtitle": "Prozentsatz erfolgreicher Ausführungen im Zeitverlauf",
        "scheduleOverview": "Zeitplanübersicht",
        "recentExecutions": "Letzte Ausführungen"
      },
      "noRecentExecutions": "Keine aktuellen Ausführungen",
      "series": {
        "executions": "Ausführungen",
        "successPercent": "Erfolg %"
      },
      "statusActive": "Aktiv",
      "statusPaused": "Pausiert",
      "everySeconds": "Alle {{seconds}}s",
      "table": {
        "workflow": "Workflow",
        "type": "Typ",
        "schedule": "Zeitplan",
        "status": "Status",
        "nextRun": "Nächste Ausführung",
        "trigger": "Auslöser",
        "duration": "Dauer",
        "started": "Gestartet"
      }
    },
    "evals": {
      "kpi": {
        "totalEvalSessions": "Auswertungssitzungen gesamt",
        "totalEvalSessionsHint": "Im ausgewählten Zeitraum erstellte Sitzungen (berücksichtigt den Datumsfilter).",
        "avgEvalQualityScore": "Durchschn. Bewertungsqualität",
        "avgEvalQualityScoreHint": "Durchschnittlicher Zusammenfassungswert über die Auswertungssitzungen im ausgewählten Zeitraum.",
        "passRate": "Erfolgsquote",
        "passRateHint": "Anteil der Zusammenfassungsmetriken mit ≥70 % im ausgewählten Zeitraum."
      },
      "zones": {
        "poor": "Schwach",
        "fair": "Mittel",
        "good": "Gut"
      },
      "sections": {
        "averageScoreTitle": "Durchschnittliche Bewertungsqualität",
        "sessionsByStatus": "Sitzungen nach Status",
        "sessionsTrendTitle": "Trend der Auswertungssitzungen",
        "sessionsTrendSubtitle": "Volumen der Auswertungssitzungen im Zeitverlauf",
        "frameworkDistribution": "Framework-Verteilung",
        "topEvaluatedAgents": "Am häufigsten ausgewertete Agenten"
      },
      "series": {
        "evalSessions": "Auswertungssitzungen"
      },
      "table": {
        "agent": "Agent",
        "evalSessions": "Auswertungssitzungen",
        "latestScore": "Letzter Wert",
        "framework": "Framework"
      }
    },
    "sessions": {
      "kpi": {
        "activeSessionsInPeriod": "Aktive Sitzungen (Zeitraum)",
        "activeSessionsHint": "Sitzungen mit mindestens einer Nachricht oder Runde im ausgewählten Zeitfenster.",
        "avgTurnsPerSession": "Ø Runden / Sitzung",
        "avgTurnsHint": "Durchschnittliche Anzahl der Gesprächsrunden pro Sitzung unter den im Zeitfenster aktiven Sitzungen.",
        "messages": "Nachrichten",
        "avgLatency": "Ø Latenz",
        "avgCostPerCall": "Ø Kosten / Aufruf",
        "avgCostPerCallHint": "Entspricht dem Kosten-Tab (LLM-Protokolle + Nutzungsereignisse)."
      },
      "sections": {
        "byEnvironment": "Sitzungen nach Umgebung",
        "byEnvironmentSubtitle": "Verteilung aktiver Sitzungen auf verschiedene Umgebungen.",
        "visibilityDistribution": "Sichtbarkeitsverteilung",
        "visibilityDistributionSubtitle": "Aufschlüsselung der Sitzungen nach Sichtbarkeitsstufe.",
        "sessionTrendTitle": "Sitzungstrend",
        "sessionTrendSubtitle": "Tägliche Sitzungsanzahl im ausgewählten Zeitraum.",
        "messagesTrendTitle": "Nachrichtentrend",
        "messagesTrendSubtitle": "Tägliches Nachrichtenvolumen über alle Sitzungen.",
        "tokenUsageTitle": "Token-Nutzung",
        "tokenUsageSubtitle": "Gleiche Tagessummen wie im Kosten-Tab (LLM-Protokolle + Nutzungsereignisse).",
        "latencyTrendTitle": "Latenztrend",
        "latencyTrendSubtitle": "Durchschnittliche und perzentile Antwortlatenzen im Zeitverlauf.",
        "topAgentsBySessions": "Top-Agenten nach Sitzungen"
      },
      "series": {
        "tokens": "Tokens",
        "avgLatency": "Ø Latenz",
        "p90Latency": "P90-Latenz",
        "p95Latency": "P95-Latenz",
        "p99Latency": "P99-Latenz"
      },
      "table": {
        "agent": "Agent",
        "sessions": "Sitzungen",
        "messages": "Nachrichten",
        "avgLatency": "Ø Latenz",
        "avgTokens": "Ø Tokens"
      }
    },
    "cost": {
      "kpi": {
        "totalTokens": "Tokens gesamt",
        "inputTokens": "Eingabe-Tokens",
        "outputTokens": "Ausgabe-Tokens",
        "cachedTokens": "Zwischengespeicherte Tokens",
        "estCost": "Gesch. Kosten",
        "llmCalls": "LLM-Aufrufe",
        "avgTokensPerCall": "Ø Tokens/Aufruf",
        "dailyAvgCost": "Ø Tageskosten",
        "peakUsageDate": "Datum der Spitzennutzung",
        "peakTokens": "Spitzen-Tokens",
        "dailyAvgTokens": "Ø Tokens pro Tag",
        "avgCostPerCall": "Ø Kosten/Aufruf"
      },
      "sections": {
        "tokenUsageTrendTitle": "Trend der Token-Nutzung",
        "tokenUsageTrendSubtitle": "Verarbeitetes Token-Volumen im Zeitverlauf",
        "costTrendTitle": "Kostentrend",
        "costTrendSubtitle": "Geschätzte Betriebskosten im Zeitverlauf",
        "tokensByServiceTitle": "Tokens nach Dienst",
        "tokensByServiceSubtitle": "Gesamte Token-Nutzung nach Systemdienst",
        "costByServiceTitle": "Geschätzte Kosten nach Dienst",
        "costByServiceSubtitle": "Aufschlüsselung der finanziellen Auswirkung nach Systemdienst",
        "tokensByConsumerTitle": "Tokens nach Verbraucher",
        "tokensByConsumerSubtitle": "Token-Verbrauch nach API-Verbrauchern",
        "costByConsumerTitle": "Geschätzte Kosten nach Verbraucher",
        "costByConsumerSubtitle": "Kostenaufschlüsselung nach API-Verbrauchern",
        "tokenDistByModelTitle": "Token-Verteilung nach Modell",
        "tokenDistByModelSubtitle": "Anteilige Token-Nutzung nach KI-Modell",
        "costByModelTitle": "Kostenschätzung nach Modell",
        "costByModelSubtitle": "Geschätzte Ausgaben je KI-Modell",
        "tokensByProjectTitle": "Token-Verbrauch nach Projekt",
        "tokensByProjectSubtitle": "Gesamte genutzte Tokens je registriertem Projekt",
        "costByProjectTitle": "Geschätzte Kosten nach Projekt",
        "costByProjectSubtitle": "Finanzielle Aufschlüsselung der KI-Nutzung nach Projekt",
        "tokensByAgentTitle": "Token-Verbrauch nach Agent",
        "tokensByAgentSubtitle": "Token-Nutzung je einzelnem KI-Agent",
        "costByAgentTitle": "Geschätzte Kosten nach Agent",
        "costByAgentSubtitle": "Finanzielle Auswirkung bestimmter KI-Agenten",
        "tokensByWorkflowTitle": "Token-Verbrauch nach Workflow",
        "tokensByWorkflowSubtitle": "Von automatisierten Workflows verarbeitetes Token-Volumen",
        "costByWorkflowTitle": "Geschätzte Kosten nach Workflow",
        "costByWorkflowSubtitle": "Kosten für die Ausführung von KI-Workflows",
        "tokensByEnvironmentTitle": "Token-Verbrauch nach Umgebung",
        "tokensByEnvironmentSubtitle": "Nutzungskennzahlen nach Bereitstellungsumgebung",
        "costByEnvironmentTitle": "Geschätzte Kosten nach Umgebung",
        "costByEnvironmentSubtitle": "Finanzielle Aufschlüsselung nach Bereitstellungsumgebung",
        "tokensByUsersTitle": "Token-Verbrauch nach Benutzern",
        "tokensByUsersSubtitle": "Von einzelnen Endbenutzern genutztes Token-Volumen",
        "costByUsersTitle": "Geschätzte Kosten nach Benutzern",
        "costByUsersSubtitle": "Betriebskosten bestimmter Benutzer",
        "topCostDriversTitle": "Top-Kostentreiber",
        "topCostDriversSubtitle": "Agenten und Workflows mit dem höchsten Verbrauch, die zu den Plattformkosten beitragen"
      },
      "noDataRange": {
        "projectToken": "Keine Projekt-Token-Daten in diesem Zeitraum.",
        "projectCost": "Keine Projektkostendaten in diesem Zeitraum.",
        "agentToken": "Keine Agent-Token-Daten in diesem Zeitraum.",
        "agentCost": "Keine Agentenkostendaten in diesem Zeitraum.",
        "workflowToken": "Keine Workflow-Token-Daten in diesem Zeitraum.",
        "workflowCost": "Keine Workflow-Kostendaten in diesem Zeitraum.",
        "environmentToken": "Keine Umgebungs-Token-Daten in diesem Zeitraum.",
        "environmentCost": "Keine Umgebungskostendaten in diesem Zeitraum.",
        "userToken": "Keine Benutzer-Token-Daten in diesem Zeitraum.",
        "userCost": "Keine Benutzerkostendaten in diesem Zeitraum."
      },
      "barName": {
        "tokens": "Tokens",
        "usd": "USD",
        "models": "Modelle"
      },
      "table": {
        "driver": "Treiber",
        "type": "Typ",
        "typeAgent": "Agent",
        "typeWorkflow": "Workflow",
        "totalTokens": "Tokens gesamt",
        "inputTokens": "Eingabe-Tokens",
        "outputTokens": "Ausgabe-Tokens",
        "estCost": "Gesch. Kosten"
      }
    },
    "platform": {
      "kpi": {
        "totalTenants": "Mandanten gesamt",
        "totalUsers": "Benutzer gesamt",
        "rejectedUsers": "Abgelehnte Benutzer"
      },
      "sections": {
        "userGrowthTitle": "Nutzerwachstum",
        "usersByRoleTitle": "Benutzer nach Rolle",
        "approvalDecisionsTitle": "Genehmigungsentscheidungen",
        "userStatusDistributionTitle": "Verteilung des Benutzerstatus",
        "auditActivityTitle": "Prüfaktivität",
        "tenantOverviewTitle": "Mandantenübersicht"
      },
      "series": {
        "newUsers": "Neue Benutzer",
        "approved": "Genehmigt",
        "rejected": "Abgelehnt"
      },
      "table": {
        "tenant": "Mandant",
        "users": "Benutzer",
        "projects": "Projekte",
        "agents": "Agenten",
        "created": "Erstellt"
      }
    }
  },
  "blueprints": {
    "common": {
      "all": "Alle",
      "cancel": "Abbrechen",
      "deepThinkingDesc": "Gründliche Analyse",
      "deepThinkingLabel": "Tiefes Nachdenken",
      "delete": "Löschen",
      "deleteBlueprintMessage": "„{{name}}“ entfernen? Dies kann nicht rückgängig gemacht werden.",
      "deleteBlueprintTitle": "Blueprint löschen?",
      "dismiss": "Verwerfen",
      "expressModeDesc": "Schnelle, direkte Generierung",
      "expressModeLabel": "Express-Modus",
      "loading": "Blueprints werden geladen...",
      "modeDeep": "Tief",
      "modeFast": "Schnell",
      "noProjectsFound": "Keine Projekte gefunden. Bitte erstellen Sie ein Projekt und wählen Sie es aus, um fortzufahren.",
      "noProjectsFoundBusinessUser": "Ihrem Konto sind keine Projekte zugewiesen. Wenden Sie sich an Ihren Administrator, damit Sie einem Projekt hinzugefügt werden, bevor Sie fortfahren können.",
      "noSystemBlueprints": "Keine System-Blueprints.",
      "proceed": "Weiter",
      "removeAttachedFile": "Angehängte Datei entfernen",
      "scopeLibrary": "Benutzerdefiniert",
      "scopeSystem": "System",
      "searchAriaLabel": "Blueprints durchsuchen",
      "searchPlaceholder": "Blueprints durchsuchen…",
      "searchSelectProjectPlaceholder": "Projekt suchen und auswählen...",
      "selectProjectLabel": "Ein Projekt ist erforderlich, um zu beginnen:",
      "selectProjectTitle": "Projekt auswählen",
      "selectThinkingModeTitle": "Denkmodus auswählen",
      "sourceAriaLabel": "Blueprint-Quelle",
      "stopRecording": "Aufnahme stoppen",
      "systemBadge": "System",
      "systemBadgeTitle": "Plattform-Starter — schreibgeschützt",
      "targetAgent": "Agent",
      "targetWorkflow": "Workflow",
      "thinkingModeHeader": "Denkmodus",
      "uploadFile": "Datei hochladen",
      "voiceInput": "Spracheingabe"
    },
    "list": {
      "activeBlueprintsTitle": "Aktive Blueprints",
      "addToSpotlight": "Zum Spotlight hinzufügen",
      "archive": "Archivieren",
      "archiveBlueprintMessage": "„{{name}}“ archivieren? Es wird aus aktiven Listen ausgeblendet.",
      "archiveBlueprintTitle": "Blueprint archivieren?",
      "archivedBlueprintsTitle": "Archivierte Blueprints",
      "backTitle": "Zurück",
      "cardActionsAriaLabel": "Kartenaktionen",
      "catalogScopeTitle": "Umfang des Blueprint-Katalogs",
      "closeAriaLabel": "Schließen",
      "delete": "Löschen",
      "done": "Fertig",
      "edit": "Bearbeiten",
      "errorCount": "{{count}} Fehler",
      "export": "Exportieren",
      "filters": {
        "status": "Status",
        "draft": "Entwurf",
        "pendingReview": "Prüfung ausstehend",
        "pending": "Ausstehend",
        "approved": "Genehmigt",
        "archived": "Archiviert",
        "industry": "Bereich",
        "creator": "Ersteller"
      },
      "filtersTitle": "Filter",
      "fork": "Forken",
      "goBackAriaLabel": "Zurück",
      "importAriaLabel": "Blueprint importieren",
      "importCompleteHeading": "Import abgeschlossen",
      "importErrorSubtitle": "Einige Elemente konnten nicht importiert werden. Details siehe unten.",
      "importFinishedWithErrorsHeading": "Import mit Fehlern abgeschlossen",
      "importSuccessSubtitle": "Ihr Blueprint wurde als Entwurf importiert und ist bereit zur Überprüfung.",
      "importTitle": "Blueprint aus YAML importieren",
      "loadingMore": "Weitere Blueprints werden geladen...",
      "newBlueprint": "Neuer Blueprint",
      "noBlueprintsMatchFilters": "Keine Blueprints entsprechen Ihren Filtern.",
      "noBlueprintsYet": "Noch keine Blueprints.",
      "pageSubtitle": "Prozessspezifikationen für Conversational Workflow und Agent Builder",
      "pageTitle": "Blueprints",
      "refreshAriaLabel": "Liste aktualisieren",
      "refreshTitle": "Aktualisieren",
      "removeFromSpotlight": "Aus Spotlight entfernen",
      "spotlightBadgeTitle": "Spotlight {{rank}} — wird zuerst auf der DIP-Startseite angezeigt (Schnellstart)",
      "spotlightFullTitle": "Spotlight ist voll (max. {{max}}). Entfernen Sie zuerst eines.",
      "statCreated": "Erstellt",
      "statFailed": "Fehlgeschlagen",
      "statSkipped": "Übersprungen",
      "systemCreatorFallback": "System",
      "toasts": {
        "addedToSpotlight": "Blueprint zum DIP-Spotlight hinzugefügt",
        "archiveFailed": "Archivierung fehlgeschlagen",
        "blueprintArchived": "Blueprint archiviert",
        "blueprintDeleted": "Blueprint gelöscht",
        "blueprintExported": "Blueprint exportiert",
        "blueprintForked": "Blueprint geforkt",
        "blueprintImported": "Blueprint importiert",
        "blueprintUnarchived": "Blueprint wiederhergestellt",
        "couldNotAddToSpotlight": "Hinzufügen zum Spotlight nicht möglich",
        "couldNotRemoveFromSpotlight": "Entfernen aus Spotlight nicht möglich",
        "deleteFailed": "Löschen fehlgeschlagen",
        "exportFailed": "Export fehlgeschlagen",
        "forkFailed": "Forken fehlgeschlagen",
        "importCompletedWithErrors": "Import mit Fehlern abgeschlossen",
        "importFailed": "Import fehlgeschlagen",
        "importedWithWarnings": "Blueprint mit {{count}} Warnung(en) importiert",
        "removedFromSpotlight": "Aus DIP-Spotlight entfernt",
        "unarchiveFailed": "Wiederherstellung fehlgeschlagen"
      },
      "typeAgent": "Agent",
      "typeTabsAriaLabel": "Blueprint-Typ",
      "typeWorkflow": "Workflow",
      "unarchive": "Wiederherstellen",
      "unarchiveBlueprintMessage": "„{{name}}“ wieder auf Entwurfsstatus zurücksetzen?",
      "unarchiveBlueprintTitle": "Blueprint wiederherstellen?",
      "warningCount": "{{count}} Warnung(en)"
    }
  },
  "ideate": {
    "aiPrefix": "KI",
    "backToPlatformAriaLabel": "Zurück zur Decision Intelligence Platform",
    "blueprintDeletedToast": "Blueprint gelöscht",
    "blueprintFallback": "Blueprint",
    "blueprintLaunchHeader": "Blueprint-Start",
    "buildWithBlueprint": "Mit einem Blueprint erstellen",
    "buildDirectLabel": "Direkt bauen",
    "buildDirectHint": "Folgefragen überspringen und aus einer vollständigen Spezifikation bauen. Vor dem Anhängen einer Datei einschalten. Aus behält die bisherigen Fragen.",
    "chooseProjectPlaceholder": "Projekt auswählen…",
    "complianceAriaLabel": "Compliance-Anforderungen",
    "complianceLabel": "Compliance",
    "couldNotOpenSharedSession": "Geteilte Sitzung konnte nicht geöffnet werden",
    "deleteFailedToast": "Löschen fehlgeschlagen",
    "deleteSessionMessage": "Möchten Sie diese Sitzung wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
    "deleteSessionTitle": "Sitzung löschen",
    "deployAriaLabel": "{{name}} mit {{brand}} bereitstellen",
    "deployWithDip": "Mit der Decision Intelligence Platform bereitstellen",
    "deployWithDipAriaLabel": "{{name}} mit der Decision Intelligence Platform bereitstellen",
    "deployWithTitle": "Mit {{brand}} bereitstellen",
    "guidedLaunchDesc": "Umfassende Webrecherche, Klärung und LLM-Validierung",
    "guidedLaunchLabel": "Geführter Start",
    "importHeader": "Importieren",
    "importN8nDesc": "Ein vorhandenes n8n-JSON in AI Workflows einbringen",
    "importN8nLabel": "n8n-Workflow importieren",
    "lookingForBlueprints": "Suche nach Blueprints in diesem Bereich…",
    "moreIndustries": "Mehr",
    "noBlueprintsAvailable": "Keine Blueprints verfügbar. Fügen Sie Blueprints hinzu, um es zu versuchen.",
    "noBlueprintsForFilter": "Keine Blueprints für diesen Filter verfügbar.",
    "noBlueprintsForIndustry": "Keine Blueprints für diesen Bereich.",
    "placeholderAgent": "Beschreiben Sie einen zu erstellenden Agenten...",
    "placeholderWorkflow": "Beschreiben Sie einen zu automatisierenden Anwendungsfall...",
    "placeholderWorkflowShort": "Beschreiben Sie einen zu automatisierenden Workflow...",
    "preBuiltBlueprints": "Vorgefertigte Blueprints",
    "quickLaunchDesc": "Recherche überspringen; Blueprint-Richtlinien und KPIs unverändert übernehmen",
    "quickLaunchLabel": "Schnellstart",
    "requireOptTitle": "{{label}} erforderlich",
    "spotlightBadgeTitleShort": "Wird zuerst auf der DIP-Startseite angezeigt (Schnellstart)",
    "spotlightRank": "Spotlight {{rank}}",
    "tagline": "Entdecken. Neu denken. Optimieren. Live gehen",
    "untitledSession": "Unbenannte Sitzung",
    "uploadDocumentOrImage": "Dokument oder Bild hochladen",
    "compliance": {
      "soc2": "SOC 2 / SOX",
      "gdpr": "DSGVO / Datenresidenz",
      "hipaa": "HIPAA",
      "pii": "PII-Maskierung erforderlich"
    }
  },
  "ontology": {
    "canvasTitle": "Ontologie-Canvas",
    "canvasSubtitle": "Durchgängige Datenherkunft von der Quelle bis zur ML-Analyse",
    "dataModelsTitle": "Datenmodelle",
    "dataModelsSubtitle": "Unternehmensweiter Datenmodellkatalog über alle Branchen hinweg",
    "kpiLibraryTitle": "KPI-Bibliothek",
    "kpiLibrarySubtitle": "Definitionen von Geschäfts-KPIs und Kennzahlenkatalog",
    "migrationsStudioTitle": "Migrations-Studio",
    "migrationsStudioSubtitle": "Orchestrieren Sie Discovery bis Cutover mit KI-Migrationsagenten, Validierung und Herkunftsnachweis in einem Arbeitsbereich.",
    "pipelinesTitle": "Data Studio",
    "pipelinesSubtitle": "Migrationsübergaben, Orchestrator-Workflows und KPI-verknüpfte Verarbeitung in einem Katalog",
    "observabilityTitle": "Datenbeobachtbarkeit",
    "observabilitySubtitle": "Überwachung der Pipeline-Gesundheit und Nachverfolgung der Datenaktualität",
    "nodesSelected": "{{count}} Knoten ausgewählt",
    "overview": "Übersicht",
    "lineage": "Herkunft",
    "buildTimeline": "Build-Zeitachse",
    "dataHealth": "Datengesundheit",
    "allFamilies": "Alle Familien",
    "allTypes": "Alle Typen",
    "mustHave": "Erforderlich",
    "goodToHave": "Wünschenswert",
    "totalKpis": "KPIs gesamt",
    "families": "Familien",
    "export": "Als CSV exportieren",
    "exportCard": "Exportieren…",
    "exportCardTitleDataModel": "Datenmodell exportieren",
    "exportCardTitleOntology": "Ontologie exportieren",
    "exportCardTitleKpi": "KPIs exportieren",
    "exportCardSubtitle": "Wählen Sie ein Dateiformat und laden Sie es dann herunter.",
    "exportCardDownload": "Herunterladen",
    "exportCardCancel": "Abbrechen",
    "exportFormatPortableJson": "Portables JSON (Round-Trip über Datenmodell erstellen)",
    "exportFormatPortableYaml": "Portables YAML (gleicher Inhalt wie JSON)",
    "exportFormatDdl": "SQL DDL",
    "exportFormatDrawio": "Draw.io-XML",
    "exportFormatTurtle": "Turtle (.ttl)",
    "exportFormatRdfXml": "RDF/XML",
    "exportFormatJsonLd": "JSON-LD",
    "version": "Version",
    "versions": "Versionen",
    "latest": "neueste",
    "compareVersions": "Vergleichen",
    "neo4jGraph": "Netzwerkgraph",
    "diffAdded": "hinzugefügt",
    "diffRemoved": "entfernt",
    "diffUnchanged": "unverändert",
    "diffNoChanges": "Keine Änderungen",
    "diffSelectTwo": "Wählen Sie zwei unterschiedliche Versionen zum Vergleich aus.",
    "exportFormatCsv": "CSV (Import auf einer anderen Instanz)",
    "exportFormatKpiJson": "JSON-Snapshot (Sicherung/Tools)",
    "exportKpiJsonNote": "CSV entspricht dem KPI-Bibliothek-CSV-Import. JSON ist für Sicherung oder externe Tools; ein JSON-Import ist noch nicht verfügbar.",
    "healthy": "Gesund",
    "degraded": "Beeinträchtigt",
    "critical": "Kritisch",
    "running": "Läuft",
    "completed": "Abgeschlossen",
    "failed": "Fehlgeschlagen",
    "scheduled": "Geplant",
    "published": "Veröffentlicht",
    "draft": "Entwurf",
    "impactAnalysis": "Auswirkungsanalyse",
    "impactActive": "Auswirkung aktiv",
    "viewDataSample": "Datenstichprobe anzeigen",
    "resourceOverview": "Ressourcenübersicht",
    "pipelineDrawerCode": "Code",
    "pipelineDrawerRuns": "Ausführungen",
    "pipelineDrawerMetadata": "Metadaten",
    "pipelineDrawerNoCode": "Für diesen Knoten ist noch kein Transformationscode registriert. Verbinden Sie ein Repository oder veröffentlichen Sie über den Pipeline-Builder.",
    "pipelineDrawerNoPipeline": "Für diesen Knoten wurde keine verknüpfte Datenpipeline gefunden.",
    "pipelineDrawerNoRuns": "Für die verknüpfte Pipeline ist kein Ausführungsverlauf verfügbar.",
    "pipelineDrawerNoMetadata": "Keine zusätzlichen Parameter über das Transformationsskript hinaus.",
    "pipelineLinkedJob": "Verknüpfte Pipeline",
    "pipelineNodeParams": "Parameter",
    "nodeInfoSection": "Knoteninformationen",
    "unknownHealth": "Unbekannt",
    "sourceChip": "Quelle",
    "dataExplorer": "Data Explorer",
    "openInDataExplorerAriaLabel": "Im Data Explorer öffnen",
    "pipelineRunHistoryUnavailable": "Der Ausführungsverlauf der Pipeline ist vom Backend noch nicht verfügbar.",
    "viewSample": "Stichprobe anzeigen",
    "metadataSectionTitle": "Metadaten",
    "kvOwner": "Eigentümer",
    "kvDescription": "Beschreibung",
    "kvPipeline": "Pipeline",
    "kvSchedule": "Zeitplan",
    "kvUpdated": "Aktualisiert",
    "kvType": "Typ",
    "kvLastUpdated": "Zuletzt aktualisiert",
    "category": {
      "data_source": "Datenquelle",
      "data_extract": "Datenextrakt",
      "pipeline_builder_dataset": "Pipeline-Builder-Datensatz",
      "python_transform": "Python-Transformation",
      "python_script_transform": "Python-Skript-Transformation",
      "virtual_table": "Virtuelle Tabelle",
      "fusion_sync": "Fusion-Synchronisierung",
      "fusion_sheet": "Fusion-Tabelle",
      "kpi_node": "KPI-Knoten",
      "ml_model": "ML-Modell"
    },
    "stage": {
      "source": "Quellen",
      "ingestion": "Ingestion",
      "transformation": "Transformation",
      "kpi": "KPI-Ebene",
      "ml_analytics": "ML & Analytik"
    },
    "toolbar": {
      "tools": "Werkzeuge",
      "layout": "Layout",
      "undo": "Rückgängig",
      "redo": "Wiederholen",
      "clean": "Bereinigen",
      "select": "Auswählen",
      "expand": "Erweitern",
      "color": "Farbe",
      "find": "Suchen",
      "remove": "Entfernen",
      "align": "Ausrichten",
      "flow": "Fluss"
    },
    "legend": {
      "categoryLegend": "Kategorielegende",
      "closeLegend": "Legende schließen"
    },
    "studio": {
      "loadingOntologies": "Ontologien werden geladen…",
      "loadingPrevOntologies": "Vorherige Ontologien werden geladen…",
      "loadingMoreOntologies": "Weitere Ontologien werden geladen…",
      "industryFilterLabel": "Branche",
      "allIndustries": "Alle Branchen",
      "domainFilterLabel": "Domäne",
      "allDomains": "Alle Domänen",
      "subdomainFilterLabel": "Unterdomäne",
      "allSubdomains": "Alle Unterdomänen",
      "failedToDeleteOntology": "Löschen der Ontologie fehlgeschlagen",
      "ontologyImportedToast": "Ontologie „{{name}}“ importiert",
      "pageTitle": "Ontologie-Studio",
      "pageSubtitle": "Durchsuchen, importieren oder erstellen Sie OWL/TTL-Ontologien mit KI aus einem Datenmodell. Vom Profiler abgeleitete Ontologien erscheinen hier automatisch, nachdem das Profiling in Migrations-Studio abgeschlossen ist.",
      "evaluateButton": "Bewerten",
      "createOntologyButton": "Ontologie erstellen",
      "ontologiesKpiLabel": "Ontologien",
      "yourOntologiesHeading": "Ihre Ontologien",
      "importTooltipBold": "Importieren",
      "importTooltipRest": "Sie eine OWL/TTL-Datei, um eine neue Ontologie zu registrieren. Vom Profiler-Workflow erzeugte Ontologien werden hier automatisch registriert.",
      "filtersTitle": "Filter",
      "searchPlaceholder": "Ontologien durchsuchen…",
      "clearSearchAriaLabel": "Suche löschen",
      "noOntologiesMatch": "Keine Ontologien entsprechen Ihrer Suche. Erstellen Sie eine Ontologie durch Import von OWL/TTL oder KI-Erstellung aus einem Datenmodell, oder führen Sie den Profiler in Migrations-Studio aus, um eine Ontologie automatisch zu registrieren.",
      "ontologyActionsAriaLabel": "Ontologie-Aktionen für {{name}}",
      "renameMenuItem": "Umbenennen",
      "industryTagsMenuItem": "Branchen-Tags",
      "deleteMenuItem": "Löschen",
      "owlFileBadge": "OWL-Datei",
      "versionsCount": "{{count}} Versionen",
      "classesLabel": "Klassen",
      "individualsLabel": "Individuen",
      "removeFromCatalogTitle": "Aus Katalog entfernen",
      "removeFromCatalogMessage": "„{{name}}“ aus dem Ontologie-Studio entfernen? Die Ontologie wird nur soft-gelöscht (aus dem Katalog entfernt). Direkte Links zum OWL-Viewer können bis zum erneuten Import als fehlend angezeigt werden.",
      "couldNotExportOntology": "Ontologie konnte nicht exportiert werden",
      "industryTagsUpdated": "Branchen-Tags aktualisiert",
      "couldNotUpdateIndustryTags": "Branchen-Tags konnten nicht aktualisiert werden",
      "industryDialogTitle": "Branchen-Tags",
      "industryDialogSubtitle": "Katalogfilter und Badges für {{name}}.",
      "unspecifiedOption": "Nicht angegeben",
      "industryFieldLabel": "Branche",
      "saveButton": "Speichern",
      "savingButton": "Wird gespeichert…",
      "closeAriaLabel": "Schließen",
      "renameDialogTitle": "OWL-Ontologie umbenennen",
      "renameDialogSubtitle": "Anzeigename auf Karten und in Listen (bis zu {{maxLength}} Zeichen).",
      "nameFieldLabel": "Name",
      "nameRequiredError": "Name ist erforderlich",
      "nameMustContainLetterError": "Der Name muss mindestens einen Buchstaben oder eine Zahl enthalten",
      "renameFailedError": "Umbenennen fehlgeschlagen"
    },
    "justNow": "Gerade eben",
    "hoursAgo": "vor {{hours}} Std.",
    "daysAgo": "vor {{days}} Tg.",
    "chooser": {
      "subtitle": "Importieren Sie eine vorhandene OWL/TTL-Datei oder erstellen Sie mit KI eine dichte Ontologie aus einem registrierten Datenmodell und Kompetenzfragen.",
      "buildWithAiTitle": "Ontologie mit KI erstellen",
      "buildWithAiDesc": "Datenmodell auswählen, Kompetenzfragen prüfen, OWL synthetisieren",
      "uploadTitle": "OWL/TTL hochladen",
      "uploadDesc": "Eine vorhandene Ontologiedatei hochladen"
    },
    "import": {
      "title": "OWL/TTL-Ontologie importieren",
      "subtitle": "Laden Sie eine Turtle- (.ttl), OWL-, RDF/XML- oder JSON-LD-Datei hoch, um eine Ontologie zu erstellen.",
      "industryHint": "Wird auf der Katalogkarte gespeichert und zusammen mit Datenmodellen und KPIs zur Filterung verwendet.",
      "nameLabel": "Ontologiename (optional)",
      "namePlaceholder": "Automatisch erkannten Titel aus der Datei überschreiben",
      "nameHint": "Wird auf der Katalogkarte angezeigt. Leer lassen, um den Titel aus der OWL-Datei zu verwenden.",
      "ontologyNameFieldLabel": "Ontologiename",
      "dropPrompt": "TTL/OWL-Datei hierher ziehen oder klicken zum Durchsuchen",
      "filePreviewHeader": "Dateivorschau",
      "importingButton": "Wird importiert...",
      "importButton": "Ontologie importieren",
      "importFailed": "Import fehlgeschlagen"
    },
    "builder": {
      "backToStudioAriaLabel": "Zurück zum Ontologie-Studio",
      "pageTitle": "Ontologie mit KI erstellen",
      "pageSubtitle": "Benennen Sie die Ontologie, wählen Sie ein Datenmodell, prüfen Sie Kompetenzfragen und synthetisieren Sie dann OWL und registrieren Sie es im Katalog. Aktualisierungssicher — öffnen Sie eine Sitzung jederzeit erneut.",
      "loadFailed": "Laden der Datenmodelle fehlgeschlagen",
      "resumeFailed": "Ontologiesitzung konnte nicht fortgesetzt werden",
      "sessionDiscarded": "Sitzung verworfen",
      "discardFailed": "Verwerfen der Sitzung fehlgeschlagen",
      "nameSpecialCharsError": "Der Ontologiename darf nicht nur aus Sonderzeichen bestehen",
      "launchTextTooLong": "Der Starttext darf höchstens {{max}} Zeichen lang sein",
      "domainSpecialCharsError": "Die Domäne darf nicht nur aus Sonderzeichen bestehen",
      "subdomainSpecialCharsError": "Die Unterdomäne darf nicht nur aus Sonderzeichen bestehen",
      "enterNamePrompt": "Geben Sie einen Ontologienamen ein, um fortzufahren",
      "enterDomainPrompt": "Geben Sie eine Domäne ein, um fortzufahren",
      "selectDataModelPrompt": "Wählen Sie ein Datenmodell aus, um fortzufahren",
      "selectOntologyLlmPrompt": "Wählen Sie ein Ontologie-LLM aus, um fortzufahren",
      "startFailed": "Starten des Ontologie-Builders fehlgeschlagen",
      "updateCqFailed": "Aktualisieren der Kompetenzfragen fehlgeschlagen",
      "sendMessageFailed": "Senden der Nachricht fehlgeschlagen",
      "synthesisFailed": "Synthese fehlgeschlagen",
      "registeredToast": "{{name}} registriert",
      "ontologyFallback": "Ontologie",
      "registrationFailed": "Registrierung fehlgeschlagen",
      "dataModelFilterLabel": "Datenmodell",
      "selectDataModelPlaceholder": "Datenmodell auswählen…",
      "noDataModelsRegistered": "Keine registrierten Datenmodelle",
      "modeFilterLabel": "Modus",
      "modeGuided": "Geführt — jede Kompetenzfrage prüfen",
      "modeExpress": "Express — schnellerer Annahmepfad",
      "ontologyLlmFilterLabel": "Ontologie-LLM",
      "selectOntologyLlmPlaceholder": "Ontologie-LLM auswählen…",
      "noChatModelsRegistered": "Keine Chat-Modelle registriert",
      "enrichmentLlmFilterLabel": "Anreicherungs-LLM",
      "selectEnrichmentLlmPlaceholder": "Anreicherungs-LLM auswählen (optional)…",
      "stepSourceTitle": "Quelle",
      "stepSourceDesc": "Benennen Sie die Ontologie und wählen Sie das Datenmodell, das Ihre Konzepte definiert",
      "stepQuestionsTitle": "Fragen",
      "stepQuestionsDesc": "Akzeptieren, verwerfen oder verfeinern Sie Kompetenzfragen auf Basis dieses Modells",
      "stepOntologyTitle": "Ontologie",
      "stepOntologyDesc": "Synthetisieren Sie OWL-Klassen, -Eigenschaften und profilgeprüfte Axiome",
      "stepRegisterTitle": "Registrieren",
      "stepRegisterDesc": "Im Ontologiekatalog für Studio und Agenten veröffentlichen",
      "sourceFormSubtitle": "Benennen Sie die Ontologie und wählen Sie das Datenmodell, um ihre Konzepte zu fundieren.",
      "ontologyNameLabel": "Ontologiename",
      "ontologyNamePlaceholder": "z. B. Patentbereich-Ontologie",
      "domainLabel": "Domäne",
      "domainPlaceholder": "z. B. Gesundheitswesen, geistiges Eigentum",
      "subdomainLabel": "Unterdomäne",
      "subdomainPlaceholder": "z. B. Ansprüche, Patentverfolgung",
      "loadingModels": "Modelle werden geladen…",
      "loadingChatModels": "Chat-Modelle werden geladen…",
      "enrichToggleTitle": "Metadaten vor der OWL-Synthese anreichern",
      "enrichToggleDesc": "Ein LLM verwenden, um Definitionen und Bezeichnungen vor der Klassengenerierung zu erweitern.",
      "startBuildingButton": "Erstellung starten",
      "backToBuilderAriaLabel": "Zurück zu Ontologie mit KI erstellen",
      "ontologyBuilderFallback": "Ontologie-Builder",
      "dataModelFallback": "Datenmodell",
      "chatEmptyLine1": "Ihr Ontologie-Interview beginnt hier.",
      "chatEmptyLine2": "Prüfen Sie vorgeschlagene Kompetenzfragen und akzeptieren Sie, was das Unternehmen beantworten muss.",
      "roleYou": "Sie",
      "roleAssistant": "Assistent",
      "workingStatus": "Wird bearbeitet…",
      "startingSessionStatus": "Sitzung wird gestartet…",
      "synthesizingStatus": "Synthese läuft",
      "chatInputPlaceholder": "Sprechen Sie frei — beschreiben Sie Geschäftsfragen oder: alle akzeptieren · weiter · fortfahren…",
      "expandSidePanel": "Seitenbereich erweitern",
      "collapseSidePanel": "Seitenbereich einklappen",
      "reflectionHeading": "Reflexion & Bewertung",
      "scoreFallback": "Bewertung {{score}}",
      "addMoreQuestionsButton": "Weitere Ontologiefragen hinzufügen",
      "registerLead": "Benennen Sie die Ontologie und veröffentlichen Sie sie im Katalog. Sehen Sie sich den Entwurfsgraphen unten an und bestätigen Sie dann die Profilprüfung vor der Registrierung.",
      "graphReviewNudge": "Tipp: Öffnen Sie oben OntoGraf oder Neo4j, um die Struktur vor der Registrierung zu überprüfen.",
      "industryLabel": "Branche",
      "registerToCatalogButton": "Im Katalog registrieren",
      "resumingSession": "Ontologiesitzung wird fortgesetzt…",
      "launchTitle": "Build an ontology",
      "launchTitleLead": "Geschäftsontologien",
      "launchTitleAccent": "erstellen",
      "launchSubtitle": "Name it, pick a data model, and chat your way to a business ontology.",
      "nameYourOntology": "Name your ontology…",
      "dataModelPill": "Data model",
      "searchDataModels": "Search data models…",
      "pickDataModelHint": "Select a data model to continue",
      "noAiModelHint": "No AI model configured. Set one up in Admin.",
      "noDataModelsYet": "No data models yet",
      "createDataModel": "Create one",
      "settingsAria": "Settings",
      "settingsLocked": "Locked for this ontology",
      "aiModelLabel": "AI model",
      "reviewStyleLabel": "How to review questions",
      "modeReviewEach": "Ask me to review each question",
      "modeFillForMe": "Fill answers for me",
      "enrichDescriptions": "Enrich descriptions",
      "enrichmentModelLabel": "Enrichment model",
      "sameModel": "Same model",
      "openingLine": "Build {{name}} from {{model}}",
      "askQuestionPlaceholder": "Ask a question your ontology should answer…",
      "askChangePlaceholder": "Ask for a change or add another question…",
      "acceptRemaining": "Accept all ({{count}})",
      "buildOntology": "Build ontology",
      "buildReadyLead": "Your questions are ready. Build the ontology from them.",
      "rebuildReadyLead": "Questions changed since the last build. Rebuild to pick them up.",
      "rebuildOntology": "Rebuild ontology",
      "send": "Send",
      "questionsIntro": "Here are {{count}} questions your ontology should answer.",
      "questionsReviewed": "{{count}} questions reviewed · {{accepted}} accepted",
      "accept": "Accept",
      "drop": "Drop",
      "collapse": "Collapse",
      "undoQuestion": "Undo",
      "answerPlaceholder": "What should the answer be?",
      "questionAccepted": "Question accepted",
      "questionDropped": "Question dropped",
      "phaseBuilding": "Building your ontology…",
      "phaseConcepts": "Designing concepts…",
      "phaseLinks": "Linking relationships…",
      "phaseWriting": "Writing the ontology…",
      "phaseQuality": "Checking quality…",
      "buildFailed": "Couldn't build the ontology",
      "buildTakesAWhile": "This usually takes a few minutes. You can keep this tab open.",
      "buildEnginePhase": "The ontology engine is building this. For a large data model it can take 15 minutes or more.",
      "tryAgain": "Try again",
      "ontologyReady": "Ontology ready · {{concepts}} concepts · {{relationships}} relationships",
      "ontologyViewLabel": "Ontology view",
      "viewGraph": "Graph",
      "viewDraftPreview": "Preview",
      "viewOwl": "OWL",
      "earlierVersion": "Earlier version",
      "qualitySkipped": "Quality check was skipped",
      "qualityViolations": "{{count}} items may need a look",
      "qualityGaps": "A few gaps are still open",
      "tryAsking": "Try asking about {{hint}}",
      "details": "Details",
      "moreDetails": "More details",
      "registeredLine": "Registered {{name}} to your catalog.",
      "registeredQuiet": "This ontology is registered",
      "openOntology": "Open ontology",
      "buildAnother": "Build another",
      "moreActions": "More actions",
      "viewDataModel": "View data model",
      "deleteSession": "Delete session",
      "close": "Close"
    },
    "viewer": {
      "loadSummaryFailed": "Laden der Zusammenfassung fehlgeschlagen",
      "generatingSummary": "Ontologiezusammenfassung wird erstellt…",
      "retry": "Erneut versuchen",
      "regenerateSummaryTitle": "Zusammenfassung neu erstellen",
      "regenerateButton": "Neu erstellen",
      "classesLabel": "Klassen",
      "objectPropsLabel": "Objekteigenschaften",
      "dataPropsLabel": "Dateneigenschaften",
      "individualsLabel": "Individuen",
      "aboutThisOntology": "Über diese Ontologie",
      "cachedSummary": "zwischengespeicherte Zusammenfassung",
      "overview": "Übersicht",
      "noSummaryYet": "Noch keine Zusammenfassung verfügbar. Verwenden Sie „Neu erstellen“, um eine zu erstellen.",
      "propertiesLabel": "Eigenschaften",
      "moreCount": "+{{count}} weitere",
      "showLess": "Weniger anzeigen",
      "tab": {
        "about": "Über die Ontologie",
        "ontograf": "OntoGraf",
        "neo4j-graph": "Netzwerkgraph",
        "object-properties": "Objekteigenschaften",
        "data-properties": "Dateneigenschaften",
        "annotation-properties": "Anmerkungen",
        "individuals": "Individuen",
        "compare": "Vergleichen"
      },
      "group": {
        "about": "Über",
        "explore": "Erkunden",
        "compare": "Vergleichen"
      },
      "ontologyNotFound": "Ontologie nicht gefunden",
      "couldNotLoadOntology": "Ontologie konnte nicht geladen werden",
      "backButton": "Zurück",
      "noGraphData": "Keine Graphdaten verfügbar",
      "compareNeedsTwoVersions": "Für den Versionsvergleich sind mindestens zwei Versionen in dieser Familie erforderlich.",
      "backToOntologies": "Ontologien",
      "builtWithAi": "Mit KI erstellt",
      "ontologyViewsAriaLabel": "Ontologieansichten",
      "viewGroupsAriaLabel": "Ansichtsgruppen",
      "exploreViewsAriaLabel": "Explorer-Ansichten",
      "faqTitle": "FAQ",
      "configureFaqAriaLabel": "FAQ konfigurieren",
      "exportTurtleTitle": "Als Turtle exportieren",
      "classHierarchyAriaLabel": "Klassenhierarchie",
      "expandClassHierarchy": "Klassenhierarchie erweitern",
      "showClassHierarchy": "Klassenhierarchie anzeigen",
      "collapseClassHierarchy": "Klassenhierarchie einklappen",
      "collapseHierarchyPanel": "Hierarchiebereich einklappen",
      "askOntologyTitle": "Die Ontologie befragen",
      "askOntologySubtitle": "Klassen, Eigenschaften und Beziehungen abfragen.",
      "askOntologyGreeting": "Stellen Sie Fragen zu Klassen, Hierarchien oder Beziehungen in dieser Ontologie.",
      "loading": "Wird geladen...",
      "name": "Name",
      "domain": "Domäne",
      "range": "Bereich",
      "characteristics": "Merkmale",
      "kind": {
        "object": "Objekt",
        "data": "Daten",
        "annotation": "Annotations"
      },
      "noPropertiesForClass": "Keine {{kind}}-Eigenschaften für diese Klasse.",
      "noPropertiesFound": "Keine {{kind}}-Eigenschaften gefunden.",
      "iriLabel": "IRI",
      "unspecified": "(nicht angegeben)",
      "annotationsLabel": "Annotationen",
      "typesLabel": "Typen",
      "viewLabel": "Ansicht",
      "groupedByClass": "Nach Klasse gruppiert",
      "flatList": "Flache Liste",
      "loadingIndividuals": "Individuen werden geladen…",
      "noIndividualsForClass": "Keine Individuen für diese Klasse.",
      "noIndividualsFound": "Keine Individuen gefunden.",
      "dataPropertiesLabel": "Dateneigenschaften",
      "objectPropertiesLabel": "Objekteigenschaften"
    },
    "dataModels": {
      "cancel": "Abbrechen",
      "close": "Schließen",
      "description": "Beschreibung",
      "industryVertical": "Branchensegment",
      "modelName": "Modellname",
      "nameInvalidChars": "Der Modellname darf nur Buchstaben, Zahlen, Leerzeichen, Bindestriche und Unterstriche enthalten",
      "nameNeedsAlphanumeric": "Der Modellname muss alphanumerische Zeichen enthalten",
      "nameRequired": "Modellname ist erforderlich",
      "save": "Speichern",
      "saving": "Speichern…",
      "selectIndustry": "Branche auswählen",
      "status": {
        "draft": "Entwurf",
        "published": "veröffentlicht"
      },
      "createDialog": {
        "addColumn": "Spalte hinzufügen",
        "addEntity": "Entität hinzufügen",
        "back": "Zurück",
        "columnNamePlaceholder": "spaltenname",
        "columns": "Spalten",
        "continue": "Weiter",
        "createFailed": "Datenmodell konnte nicht erstellt werden",
        "createModel": "Modell erstellen",
        "createdSummary": "{{name}} wurde als Entwurf mit {{count}} Entitäten erstellt.",
        "createdSummaryWithColumns": "{{name}} wurde als Entwurf mit {{count}} Entitäten und {{columns}} Spalten erstellt.",
        "createdTitle": "Datenmodell erstellt",
        "creating": "Wird erstellt...",
        "descriptionPlaceholder": "Beschreiben Sie Zweck und Umfang dieses Datenmodells...",
        "dimension": "Dimension",
        "done": "Fertig",
        "duplicateEntityName": "Dieser Entitätsname wurde bereits hinzugefügt",
        "enterModelName": "Geben Sie einen Modellnamen ein",
        "entityNameInvalidChars": "Der Entitätsname darf nur Buchstaben, Zahlen und Unterstriche enthalten",
        "entityNameNeedsAlphanumeric": "Der Entitätsname muss alphanumerische Zeichen enthalten",
        "entityNamePlaceholder": "Entitätsname (z. B. Customer)",
        "fillOutField": "Bitte füllen Sie dieses Feld aus.",
        "foreignKey": "Fremdschlüssel",
        "missingIndustry": "Branche fehlt",
        "missingModelName": "Modellname fehlt",
        "modelNamePlaceholder": "z. B. Allgemeines Handelsdatenmodell",
        "modelNameRequired": "Modellname *",
        "modelSummary": "Modellübersicht",
        "needMoreEntities": "Fügen Sie mindestens 2 Entitäten hinzu, um Beziehungen zu definieren.",
        "noColumnsYet": "Noch keine Spalten. Optional bei der Erstellung — Sie können sie später in der Modelldetailansicht hinzufügen.",
        "noEntitiesYet": "Noch keine Entitäten hinzugefügt. Beginnen Sie oben mit der Eingabe, um Tabellen hinzuzufügen.",
        "nullable": "Nullable",
        "primaryKey": "Primärschlüssel",
        "removeColumn": "Spalte entfernen",
        "removeEntity": "{{name}} entfernen",
        "selectIndustryVertical": "Wählen Sie ein Branchensegment aus",
        "step1Desc": "Name, Branche und Beschreibung",
        "step1Label": "Grundinformationen",
        "step2Desc": "Tabellen und Spalten hinzufügen",
        "step2Intro": "Fügen Sie Entitäten (Tabellen) hinzu und definieren Sie dann Spalten für jede.",
        "step2Label": "Entitäten definieren",
        "step3Desc": "Fremdschlüssel und Verknüpfungen definieren",
        "step3Intro": "Definieren Sie Beziehungen zwischen Entitäten.",
        "step3Label": "Beziehungen",
        "step4Desc": "Validieren und veröffentlichen",
        "step4Label": "Überprüfen & Erstellen",
        "subtitle": "Ein neues Unternehmensdatenmodell definieren",
        "summaryColumns": "Spalten (benannt):",
        "summaryEntities": "Entitäten:",
        "summaryIndustry": "Branche:",
        "summaryName": "Name:",
        "summaryRelationships": "Beziehungen:",
        "title": "Datenmodell erstellen",
        "typePlaceholder": "Typ"
      },
      "detail": {
        "add": "Hinzufügen",
        "addColumnTitle": "Spalte hinzufügen",
        "back": "Zurück",
        "backToDataModels": "Zurück zu den Datenmodellen",
        "cardinality": "Kardinalität",
        "chooseBothTables": "Wählen Sie beide Tabellen aus",
        "columnNameRequired": "Spaltenname ist erforderlich",
        "couldNotAddRelationship": "Beziehung konnte nicht hinzugefügt werden",
        "couldNotApplyDdl": "DDL konnte nicht angewendet werden",
        "couldNotDeleteColumn": "Spalte konnte nicht gelöscht werden",
        "couldNotDeleteRelationship": "Beziehung konnte nicht gelöscht werden",
        "couldNotLoadDdl": "DDL-Export konnte nicht geladen werden",
        "couldNotSaveColumn": "Spalte konnte nicht gespeichert werden",
        "couldNotUpdateRelationship": "Beziehung konnte nicht aktualisiert werden",
        "dataType": "Datentyp",
        "ddlCouldNotExportYet": "-- DDL konnte noch nicht exportiert werden.\n",
        "ddlUnavailableLargeModel": "-- DDL-Export ist für große Modelle im Exportmenü verfügbar.\n",
        "ddlValidationPassed": "DDL-Validierung erfolgreich",
        "deleteColumnAria": "Spalte {{name}} löschen",
        "deleteColumnMessage": "Dies entfernt die Spalte aus der Datenmodellentität.",
        "deleteColumnTitle": "Spalte löschen",
        "deleteRelationshipAria": "Beziehung löschen",
        "deleteRelationshipMessage": "Diese Beziehung aus dem Modell entfernen.",
        "deleteRelationshipTitle": "Beziehung löschen",
        "diagramExported": "Diagramm exportiert",
        "drawioDownloaded": "Draw.io-Diagramm heruntergeladen",
        "drawioExportFailed": "Draw.io-Export fehlgeschlagen",
        "editColumnAria": "Spalte {{name}} bearbeiten",
        "editColumnTitle": "Spalte bearbeiten",
        "editRelationshipAria": "Beziehung bearbeiten",
        "editRelationshipTitle": "Beziehung bearbeiten",
        "exportFailed": "Export fehlgeschlagen",
        "fkColumnSource": "FK-Spalte (Quelle)",
        "foreignKeys": "Fremdschlüssel",
        "jsonSnapshotDownloaded": "JSON-Snapshot heruntergeladen",
        "modelNotFound": "Modell nicht gefunden",
        "modelUpdatedFromDdl": "Modell aus DDL aktualisiert",
        "name": "Name",
        "noColumnsYet": "Noch keine Spalten. Fügen Sie eine hinzu, um diese Entität zu definieren.",
        "noDirectRelationships": "Keine direkten Beziehungen",
        "nothingToExport": "Nichts zu exportieren",
        "nullableColumns": "Nullable Spalten",
        "optional": "optional",
        "optionalCapitalized": "Optional",
        "primaryKeys": "Primärschlüssel",
        "recordCount": "Datensätze",
        "relationshipAdded": "Beziehung hinzugefügt",
        "snapshotExportFailed": "Snapshot-Export fehlgeschlagen",
        "svgExportFailed": "SVG-Export fehlgeschlagen",
        "svgExported": "SVG exportiert",
        "tab": {
          "columns": "Spalten",
          "relationships": "Beziehungen",
          "stats": "Statistiken"
        },
        "tooManyTablesForImage": "Dieses Modell hat {{count}} Tabellen — zu groß, um im Browser als Bild dargestellt zu werden. Verwenden Sie stattdessen \"Als Draw.io exportieren\".",
        "validation": "Validierung",
        "validationFailed": "Validierung fehlgeschlagen",
        "viewMode": "Ansicht",
        "modifyMode": "Bearbeiten",
        "searchTablesPlaceholder": "Tabellen & Spalten durchsuchen…",
        "filterErDiagramAriaLabel": "ER-Diagramm filtern",
        "exportAsPng": "Als PNG exportieren",
        "exportAsSvg": "Als SVG exportieren",
        "exportJsonSnapshot": "JSON-Snapshot exportieren",
        "exportAsDrawio": "Als Draw.io exportieren",
        "relationshipButton": "Beziehung",
        "modelMetricsAriaLabel": "Modellmetriken",
        "entitiesLabel": "Entitäten",
        "entAbbrev": "Ent.",
        "relationshipsLabel": "Beziehungen",
        "relAbbrev": "Bez.",
        "totalRecordsLabel": "Gesamtdatensätze",
        "recAbbrev": "Ds.",
        "linkedKpisLabel": "Verknüpfte KPIs",
        "kpiAbbrev": "KPI",
        "noEntitiesYet": "Noch keine Entitäten",
        "noEntitiesDescription": "Wenden Sie links DDL an oder importieren Sie ein Modell, um dieses Diagramm zu füllen.",
        "askDataModelTitle": "Das Datenmodell fragen",
        "askDataModelSubtitle": "Entitäten, Spalten und Beziehungen abfragen.",
        "askDataModelGreeting": "Fragen Sie nach Tabellen, Spalten, Beziehungen oder Statistiken in diesem Datenmodell.",
        "addRelationshipTitle": "Beziehung hinzufügen",
        "addRelationshipSubtitle": "Von → Zu · optionale FK-Spalte in der Quelltabelle",
        "fromTable": "Von Tabelle",
        "toTable": "Zu Tabelle",
        "selectEllipsis": "Auswählen…",
        "fkColumnOnSource": "FK-Spalte (Quelle)",
        "optionalLowercase": "optional",
        "ddlRefreshTitle": "Editor aus dem Server-Export ersetzen",
        "ddlRefresh": "Aktualisieren",
        "ddlSwitchToModifyValidate": "Zum Bearbeiten-Modus wechseln, um zu validieren",
        "ddlValidate": "Validieren",
        "ddlSwitchToModifyApply": "Zum Bearbeiten-Modus wechseln, um anzuwenden",
        "ddlApply": "Anwenden"
      },
      "editDialog": {
        "invalidName": "Ungültiger Modellname",
        "saveChanges": "Änderungen speichern",
        "subtitle": "Name, Branche und Beschreibung aktualisieren",
        "title": "Datenmodell bearbeiten",
        "updateFailed": "Datenmodell konnte nicht aktualisiert werden",
        "updated": "Datenmodell aktualisiert"
      },
      "importDialog": {
        "analyzing": "Wird analysiert...",
        "chooseFile": "Datei auswählen",
        "chooseFiles": "Dateien auswählen",
        "close": "Schließen",
        "createFromSampleData": "Aus Beispieldaten erstellen",
        "createdSummary": "\"{{name}}\" erstellt: {{entities}} Entitäten, {{columns}} Spalten, {{relationships}} Beziehungen.",
        "csvFilesLabel": "CSV-Dateien (eine pro Tabelle, bis zu 30)",
        "downloadSampleHint": "Laden Sie eine Beispieldatei herunter, um das erwartete Layout zu sehen",
        "excelWorkbook": "Excel-Arbeitsmappe",
        "fileLabel": "Datei: {{name}} ({{size}} KB)",
        "formatContent": "{{label}}-Inhalt",
        "import": "Import",
        "importAsDataModel": "Als Datenmodell importieren",
        "importFailed": "Import fehlgeschlagen",
        "importFailedTitle": "Import fehlgeschlagen",
        "importFormat": "Importformat",
        "importSuccessful": "Import erfolgreich",
        "importWithVisionModel": "Mit Vision-Modell importieren",
        "importedSummary": "\"{{name}}\" importiert: {{entities}} Entitäten, {{columns}} Spalten, {{relationships}} Beziehungen.",
        "importing": "Wird importiert...",
        "inferredModelNamePlaceholder": "Name für das abgeleitete Modell",
        "loadSample": "Beispiel laden",
        "mediaFileTypes": "Datei (PNG, JPEG, GIF, WebP, PDF, TXT, MD)",
        "mediaHelp": "Laden Sie einen Screenshot eines ER-Diagramms, ein exportiertes PDF oder unstrukturierten Text hoch. Die Verarbeitung nutzt Ihr Mandantenmodell auf der {{brand}}-Plattform; große Dateien können einige Minuten dauern.",
        "modelNameOptional": "Modellname (optional)",
        "noFormatsAvailable": "Vom Server sind keine Importformate verfügbar.",
        "noImportModelConfigured": "Kein Importmodell konfiguriert.",
        "noImportModelLlmHint": "Bitten Sie einen Mandantenadministrator, unter Admin → Allgemeine Einstellungen → Enterprise Ontology ein LLM auszuwählen, bevor Sie diesen Tab verwenden.",
        "noImportModelVisionHint": "Bitten Sie einen Mandantenadministrator, unter Admin → Allgemeine Einstellungen → Enterprise Ontology ein vision-fähiges LLM auszuwählen, bevor Sie diesen Tab verwenden.",
        "overrideTitleNoName": "Titel überschreiben, wenn die Datei keinen klaren Namen hat",
        "overrideTitlePlaceholder": "Automatisch erkannten Titel überschreiben",
        "placeholderCsv": "Fügen Sie UTF-8-CSV ein oder laden Sie eine .csv hoch: entweder tabellarisch (Zeile 1 = Spalten; optionale Zeile 2 = Typen) oder ein Data-Dictionary-Raster (Tabellenname / Spaltenname / Datentyp / optional Primärschlüssel / Referenzierte Tabelle).",
        "placeholderDbml": "Fügen Sie Ihr DBML ein (Tabellendefinitionen und Ref-Zeilen)...",
        "placeholderDdl": "Fügen Sie hier Ihre CREATE TABLE-Anweisungen ein...",
        "placeholderDrawio": "Fügen Sie Ihren Draw.io-XML-Inhalt ein...",
        "placeholderJson": "Fügen Sie {{brand}} Portable JSON ein — dasselbe Format wie Datenmodell exportieren → Portable JSON (Entitäten + Beziehungen).",
        "placeholderJsonSchema": "Fügen Sie Ihr JSON-Schema mit Definitionen ein...",
        "placeholderMermaid": "Fügen Sie Ihren erDiagram-Block ein...",
        "placeholderPlantuml": "Fügen Sie Ihr @startuml-Entitätsdiagramm ein...",
        "placeholderXlsx": "Excel-Importe verwenden nur den Datei-Upload. Jedes Arbeitsblatt ist entweder eine Tabelle (Kopfzeile = Spalten), ein Data-Dictionary-Raster (Tabelle/Spalte/Typ-Zeilen) oder ein Beziehungsblatt (Von-Tabelle / Zu-Tabelle / Fremdschlüsselspalte).",
        "sampleCsv": "Beispiel-CSV",
        "sampleHelp": "Laden Sie eine oder mehrere CSV-Dateien mit repräsentativen Beispieldaten hoch. Das System analysiert Spaltennamen und -werte, um Entitäten, Datentypen, Primär-/Fremdschlüssel und tabellübergreifende Beziehungen abzuleiten.",
        "sampleXlsx": "Beispiel-XLSX",
        "subtitle": "Strukturierte Formate, Bilder & Dokumente oder Ableitung aus Beispiel-CSV-Daten",
        "tabMedia": "Bilder & Dokumente",
        "tabSample": "Aus Beispieldaten",
        "tabStructured": "Strukturierte Formate",
        "title": "Datenmodell importieren",
        "uploadFile": "Datei hochladen",
        "warningPrefix": "Warnung:",
        "xlsxHelp": "Jedes sichtbare Arbeitsblatt wird zu einer oder mehreren Tabellen: Tabellarische Blätter verwenden Zeile 1 als Spaltennamen; Data-Dictionary-Blätter (Tabellenname + Spaltenname + Datentyp, optional Primärschlüssel / Referenzierte Tabelle / Kardinalität) erweitern jede Zeile zu einer logischen Spalte. Verwenden Sie ein Beziehungsblatt (Von-Tabelle, Zu-Tabelle, Fremdschlüsselspalte, optional Kardinalität) für explizite Kanten, oder geben Sie die referenzierte Tabelle in FK-Zeilen des Wörterbuchs an. Anleitungsähnliche Blattnamen (README, Template, …) und Namen, die mit _ beginnen, werden übersprungen. Übrige Fremdschlüssel werden weiterhin aus Spaltennamen abgeleitet (z. B. store_sk → store), wenn Ziele in der Arbeitsmappe vorhanden sind."
      },
      "industryTagDialog": {
        "subtitle": "Katalog-Badge und Filter für {{name}}",
        "title": "Branchen-Tags",
        "updateFailed": "Branchen-Tags konnten nicht aktualisiert werden",
        "updated": "Branchen-Tags aktualisiert"
      },
      "list": {
        "actionClone": "Klonen",
        "actionDelete": "Löschen",
        "actionEdit": "Bearbeiten",
        "actionIndustryTags": "Branchen-Tags",
        "actionPublish": "Veröffentlichen",
        "allCreators": "Alle Ersteller",
        "allIndustries": "Alle Branchen",
        "clearSearch": "Suche löschen",
        "cloneFailed": "Datenmodell konnte nicht geklont werden",
        "clonedAs": "Als \"{{name}}\" geklont",
        "createDataModel": "Datenmodell erstellen",
        "creator": "Ersteller",
        "deleteDialogMessage": "Dies entfernt das Datenmodell aus dem Katalog. Verknüpfte KPI-Referenzen müssen möglicherweise aktualisiert werden.",
        "deleteDialogTitle": "Datenmodell löschen",
        "deleteFailed": "Datenmodell konnte nicht gelöscht werden",
        "deleted": "Datenmodell gelöscht",
        "emptyDescription": "Erstellen oder importieren Sie ein Datenmodell, um zu beginnen.",
        "emptyTitle": "Noch keine Datenmodelle",
        "entities": "Entitäten",
        "exportFailed": "Datenmodell konnte nicht exportiert werden",
        "filters": "Filter",
        "import": "Import",
        "industry": "Branche",
        "kpis": "KPIs",
        "loadFailed": "Datenmodelle konnten nicht geladen werden",
        "loading": "Datenmodelle werden geladen…",
        "loadingMore": "Weitere Datenmodelle werden geladen…",
        "loadingPrev": "Frühere Datenmodelle werden geladen…",
        "noMatchDescription": "Versuchen Sie eine andere Suche oder einen anderen Branchenfilter oder erstellen Sie ein neues Modell.",
        "noMatchTitle": "Keine passenden Datenmodelle",
        "publishFailed": "Veröffentlichen nicht möglich",
        "published": "Datenmodell veröffentlicht",
        "refresh": "Aktualisieren",
        "refreshError": "Katalog konnte nicht aktualisiert werden",
        "refreshList": "Liste aktualisieren",
        "relationships": "Beziehungen",
        "searchPlaceholder": "Datenmodelle durchsuchen…",
        "statEntities": "Entitäten",
        "statLinkedKpis": "Verknüpfte KPIs",
        "statModels": "Modelle",
        "statPublished": "Veröffentlicht",
        "unableToLoad": "Katalog konnte nicht geladen werden"
      },
      "erFlow": {
        "entityType": {
          "dimension": "Dimension",
          "fact": "Faktentabelle",
          "bridge": "Brücke",
          "aggregate": "Aggregat"
        },
        "columnsCount": "{{count}} Spalten",
        "loadingEllipsis": "Wird geladen…",
        "showMore": "Mehr anzeigen",
        "showLess": "Weniger anzeigen",
        "resetViewTitle": "Ansicht & Hervorhebungen zurücksetzen",
        "resetView": "Ansicht zurücksetzen",
        "hintReadOnly": "Nur-Lese-Vorschau · Scrollen zum Schwenken · Zoom-Schaltflächen verwenden",
        "hintModify": "Bearbeiten: Ziehen Sie vom rechten Punkt einer Spalte (FK-Seite) zum linken Punkt einer Spalte in einer anderen Tabelle · ",
        "hintClickTable": "Klicken Sie auf eine Tabelle für Details · ",
        "hintPanZoom": "Scrollen zum Schwenken · Zoom-Schaltflächen verwenden · Ziehen, um Tabellen zu verschieben"
      }
    },
    "optional": "Optional",
    "type": "Typ",
    "kpiAllListView": "Alle KPIs",
    "kpiLibrary": {
      "all": "Alle",
      "allCollections": "Alle Sammlungen",
      "allDataTypes": "Alle Datentypen",
      "allIndustries": "Alle Branchen",
      "andMoreErrors": "... und {{count}} weitere",
      "askAboutKpis": "Fragen zu KPIs stellen",
      "backToFamilies": "Zurück zu den Familien",
      "browseMode": "Anzeigemodus",
      "cardActions": "Kartenaktionen",
      "chatGreeting": "Fragen Sie nach KPI-Namen, Definitionen, Familien, Datentypen oder Verknüpfungen zu Datenmodellen.",
      "chatSubtitleCollection": "Definitionen und Familien in dieser Sammlung.",
      "chatSubtitleFamily": "Definitionen in dieser Familie.",
      "clearFiltersAndSearch": "Filter und Suche zurücksetzen",
      "closeAria": "Schließen",
      "collection": "Sammlung",
      "collectionCardMenu": "Kartenmenü der Sammlung",
      "collectionsView": "Sammlungsansicht",
      "couldNotLoadCatalog": "Katalog konnte nicht geladen werden",
      "createCollection": "Sammlung erstellen",
      "createFamily": "Familie erstellen",
      "createKpi": "KPI erstellen",
      "dataType": "Datentyp",
      "delete": "Löschen",
      "dismiss": "Verwerfen",
      "editDetails": "Details bearbeiten",
      "editLinkedDataModel": "Verknüpftes Datenmodell bearbeiten",
      "enterpriseOntology": "Enterprise-Ontologie",
      "family": "Familie",
      "familiesCount": "{{count}} Familien",
      "filters": "Filter",
      "importCompleteLabel": "Import abgeschlossen:",
      "importCreatedSkipped": "{{created}} erstellt, {{skipped}} übersprungen",
      "importCsv": "CSV importieren",
      "industry": "Branche",
      "industryTags": "Branchen-Tags",
      "internalIdNotePrefix": "Interne ID",
      "internalIdNoteSuffix": "bleibt unverändert – CSV-Importe und Links funktionieren weiterhin.",
      "kpiType": "KPI-Typ",
      "kpisCount": "{{count}} KPIs",
      "legacySuffix": "{{domain}} (veraltet)",
      "linkDataModel": "Datenmodell verknüpfen",
      "linkFamilyToModel": "Diese KPI-Familie mit einem Referenzdatenmodell verknüpfen",
      "linkedDataModel": "Verknüpftes Datenmodell",
      "linkedDataModelTooltip": "Verknüpftes Datenmodell: {{name}}",
      "linkedModelFallback": "Verknüpftes Modell",
      "loadingLibrary": "KPI-Bibliothek wird geladen...",
      "noCollectionsDesc": "Erstellen Sie eine Sammlung oder importieren Sie eine CSV-Datei, um zu beginnen.",
      "noCollectionsMatchTitle": "Keine Sammlungen entsprechen Ihrer Suche",
      "noCollectionsTitle": "Noch keine KPI-Sammlungen",
      "noDataFound": "Keine Daten gefunden",
      "noFamiliesDesc": "Erstellen Sie eine Familie oder importieren Sie eine CSV-Datei, um zu beginnen.",
      "noFamiliesMatchTitle": "Keine Familien entsprechen Ihrer Suche",
      "noFamiliesTitle": "Keine KPI-Familien in dieser Sammlung",
      "noKpisMatch": "Keine KPIs entsprechen den Filtern. Passen Sie die Suche oder Filter an oder importieren Sie Definitionen.",
      "noMatchDesc": "Versuchen Sie einen anderen Suchbegriff oder setzen Sie die Filter zurück.",
      "none": "Keine",
      "precisionYes": "Präzision (Ja)",
      "rename": "Umbenennen",
      "rowActions": "Zeilenaktionen",
      "save": "Speichern",
      "saving": "Wird gespeichert…",
      "searchPlaceholder": "Sammlungen, Familien oder KPI-Name, Definition, Beschreibung durchsuchen...",
      "selectCollection": "Sammlung auswählen...",
      "selectFamily": "Familie auswählen...",
      "selectIndustry": "Branche auswählen…",
      "selectType": "Typ auswählen...",
      "totalCollections": "Sammlungen insgesamt",
      "viewDetails": "Details anzeigen",
      "viewKpiDetails": "KPI-Details anzeigen",
      "columns": {
        "actions": "Aktionen",
        "costPositive": "Kosten +",
        "dataType": "Datentyp",
        "definition": "Definition",
        "description": "Beschreibung",
        "family": "Familie",
        "kpiName": "KPI-Name",
        "kpiType": "KPI-Typ",
        "precision": "Präzision"
      },
      "createCollectionDialog": {
        "descriptionAlnumError": "Die Beschreibung muss gültigen Text enthalten und darf nicht nur aus Sonderzeichen oder Emojis bestehen",
        "descriptionPlaceholder": "Kurze Beschreibung dieser KPI-Sammlung",
        "displayNameAlnumError": "Der Anzeigename muss mindestens einen Buchstaben oder eine Zahl enthalten",
        "displayNameCharsError": "Der Anzeigename darf nur Buchstaben, Zahlen, Leerzeichen, Bindestriche und Unterstriche enthalten",
        "displayNamePlaceholder": "z. B. Einzelhandels-KPIs",
        "displayNameRequired": "Anzeigename *",
        "nameAlnumError": "Der Name muss mindestens einen Buchstaben oder eine Zahl enthalten",
        "nameCharsError": "Der Name darf nur Buchstaben, Zahlen und Unterstriche enthalten",
        "namePlaceholder": "z. B. retail_kpis",
        "nameRequired": "Name *",
        "title": "Neue Sammlung erstellen"
      },
      "createFamilyDialog": {
        "collectionRequired": "KPI-Sammlung *",
        "displayNamePlaceholder": "Kunden-Level-KPIs",
        "displayNameRequired": "Anzeigename *",
        "namePlaceholder": "z. B. COSMOS_CUSTOMER_LEVEL_KPIS",
        "nameRequired": "Name *",
        "title": "Neue KPI-Familie erstellen"
      },
      "createKpiDialog": {
        "collectionRequired": "Sammlung *",
        "costPositiveCheckbox": "Kosten + (Ja/Nein)",
        "create": "KPI erstellen",
        "dataTypePlaceholder": "string",
        "definitionPlaceholder": "Technische Definition oder Berechnungshinweise",
        "descriptionPlaceholder": "Kurze Zusammenfassung",
        "familyRequired": "Familie *",
        "kpiNamePlaceholder": "z. B. CUSTOMER_ATC_RATE",
        "kpiNameRequired": "KPI-Name *",
        "precisionCheckbox": "Präzision (Ja/Nein)",
        "title": "Neuen KPI erstellen"
      },
      "collectionIndustryDialog": {
        "subtitle": "Gilt für \"{{name}}\" und wie es im KPI-Katalog erscheint.",
        "title": "Branchen-Tags der Sammlung"
      },
      "deleteCollectionDialog": {
        "message": "Dadurch werden die Sammlung sowie alle darin enthaltenen KPI-Familien und KPI-Definitionen entfernt. Bei jedem Migrationsprojekt, das auf diese Sammlung verwies, wird das KPI-Sammlungsziel automatisch gelöscht.",
        "title": "KPI-Sammlung löschen"
      },
      "deleteFamilyDialog": {
        "message": "Möchten Sie \"{{name}}\" wirklich löschen? Dadurch werden auch alle KPIs in dieser Familie gelöscht. Dies kann nicht rückgängig gemacht werden.",
        "title": "Familie löschen"
      },
      "deleteKpiDialog": {
        "message": "Möchten Sie \"{{name}}\" wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
        "title": "KPI löschen"
      },
      "detailPopup": {
        "closeAria": "Schließen",
        "costPositive": "Kosten +",
        "dataType": "Datentyp",
        "definition": "Definition",
        "description": "Beschreibung",
        "linkedModel": "Verknüpftes Modell",
        "no": "Nein",
        "precision": "Präzision",
        "tags": "Tags",
        "yes": "Ja"
      },
      "domainDialog": {
        "missingIndustry": "Branche fehlt",
        "updateFailed": "Branchen-Tags konnten nicht aktualisiert werden"
      },
      "editFamilyDialog": {
        "descriptionPlaceholder": "Beschreiben Sie, was diese KPI-Familie abdeckt…",
        "title": "KPI-Familie bearbeiten",
        "titleLabel": "Titel",
        "titlePlaceholder": "z. B. Umsatz-KPIs",
        "updateFailed": "Familie konnte nicht aktualisiert werden"
      },
      "errors": {
        "createCollectionFailed": "Sammlung konnte nicht erstellt werden",
        "createFamilyFailed": "Familie konnte nicht erstellt werden",
        "createKpiFailed": "KPI konnte nicht erstellt werden",
        "csvImportFailed": "CSV-Import fehlgeschlagen",
        "deleteCollectionFailed": "KPI-Sammlung konnte nicht gelöscht werden",
        "deleteFamilyFailed": "Familie konnte nicht gelöscht werden",
        "deleteKpiFailed": "KPI konnte nicht gelöscht werden",
        "exportFailed": "KPIs konnten nicht exportiert werden",
        "loadFailed": "KPI-Bibliothek konnte nicht geladen werden."
      },
      "familyIndustryDialog": {
        "subtitle": "Gilt für \"{{name}}\".",
        "title": "Branchen-Tags der KPI-Familie"
      },
      "importDialog": {
        "appliedToFamiliesNote": "Wird auf KPI-Familien angewendet, die durch diesen Import erstellt oder berührt wurden.",
        "chooseCsvFile": "CSV-Datei auswählen",
        "close": "Schließen",
        "dataTypeHelp": "— z. B. string, decimal; fehlende Werte werden aus Name und Definition abgeleitet.",
        "definitionHelp": "— technische Definition;",
        "descriptionHelp": "— kurze Zusammenfassung.",
        "domainHelp": "— optionale zeilenbezogene Domäne (Standard: Import-Domäne).",
        "familyCreatedNote": "Während des Imports erstellte Familien werden in dieser Sammlung platziert. Standardmäßig \"Default\", wenn leer.",
        "familyDisplayHelp": "— wird in der Benutzeroberfläche beim Erstellen oder Aktualisieren von Familien angezeigt.",
        "familyKpiHelp": "— stabile Kennungen für die Familiengruppe und das KPI-Symbol.",
        "industryOptional": "Branche (optional)",
        "kpiCollection": "KPI-Sammlung",
        "kpiTypeDefault": "(Standard: erforderlich).",
        "linkDataModelOptional": "Datenmodell verknüpfen (optional)",
        "or": "oder",
        "or2": "(oder",
        "overridesDomainNote": "Überschreibt die Domänenspalte in einzelnen CSV-Zeilen.",
        "precisionCostHelp": ") — Ja/Nein; falls weggelassen, sind beide standardmäßig Ja.",
        "requiredColumns": "Erforderliche Spalten:",
        "title": "KPIs aus CSV importieren"
      },
      "linkDialog": {
        "noneHint": "Wählen Sie \"Keine\", um diese Familie von jedem ER-Modell zu lösen. Agent Studio und Blueprints verwenden diese Verknüpfung, um KPIs mit Entitäten abzugleichen.",
        "referenceDataModel": "Referenzdatenmodell",
        "subtitle": "Wählen Sie das Referenzdatenmodell für \"{{name}}\".",
        "title": "KPI-Familie mit Datenmodell verknüpfen",
        "updateFailed": "Datenmodellverknüpfung konnte nicht aktualisiert werden"
      },
      "renameCollectionDialog": {
        "displayName": "Anzeigename",
        "placeholder": "z. B. Einzelhandels-KPIs",
        "renameFailed": "Sammlung konnte nicht umbenannt werden",
        "title": "Sammlung umbenennen"
      },
      "toasts": {
        "collectionDeleted": "KPI-Sammlung gelöscht",
        "collectionRenamed": "Sammlung umbenannt",
        "dataModelLinkRemoved": "Datenmodellverknüpfung entfernt",
        "dataModelLinked": "Datenmodell verknüpft",
        "familyUpdated": "Familie aktualisiert",
        "industryTagsUpdated": "Branchen-Tags aktualisiert"
      },
      "createCollectionButton": "Sammlung erstellen",
      "importCsvButton": "CSV importieren"
    },
    "dataStudio": {
      "list": {
        "newPipeline": "Neue Pipeline",
        "typeLabel": "Typ",
        "statusLabel": "Status",
        "allTypes": "Alle Typen",
        "allStatus": "Alle Status",
        "columnPipeline": "Pipeline",
        "columnType": "Typ",
        "columnStatus": "Status",
        "columnRoute": "Quelle → Ziel",
        "columnSchedule": "Zeitplan",
        "columnUpdated": "Aktualisiert",
        "columnActions": "Aktionen",
        "actionOpen": "Öffnen",
        "actionDelete": "Löschen",
        "deleteDialogTitle": "Pipeline löschen",
        "deleteDialogMessage": "Die Pipeline wird aus Data Studio entfernt. Dieser Vorgang kann nicht rückgängig gemacht werden.",
        "deleted": "Pipeline \"{{name}}\" gelöscht",
        "deleteFailed": "Pipeline konnte nicht gelöscht werden",
        "migrationLinkTitle": "Aus Migration: {{id}}",
        "migrationLinkText": "Migration",
        "statsPipelines": "Pipelines",
        "emptyNoPipelines": "Noch nichts in Data Studio. Pipelines werden meist aus abgeschlossenen Migrationsprojekten übernommen oder oben über „Neue Pipeline“ erstellt.",
        "emptyNoMatches": "Keine Einträge entsprechen den Filtern. Passen Sie Ihre Such- oder Filterkriterien an.",
        "filtersTitle": "Filter",
        "searchPlaceholder": "Katalog durchsuchen...",
        "loadErrorTitle": "Data-Studio-Katalog konnte nicht geladen werden",
        "retry": "Erneut versuchen"
      },
      "status": {
        "pending": "Ausstehend",
        "terminating": "Wird beendet"
      },
      "createDialog": {
        "title": "Pipeline erstellen",
        "subtitleChoose": "Wählen Sie einen Pipeline-Typ, um zu beginnen",
        "subtitleMode": "{{mode}}-Pipeline",
        "steps": {
          "type": {
            "label": "Pipeline-Typ",
            "description": "Pipeline-Modus wählen"
          },
          "sourceTarget": {
            "label": "Quelle & Ziel",
            "description": "Endpunkte auswählen"
          },
          "configuration": {
            "label": "Konfiguration",
            "description": "Zeitplan & Optionen"
          },
          "review": {
            "label": "Überprüfen",
            "description": "Bestätigen & erstellen"
          }
        },
        "modes": {
          "migrate": {
            "label": "Migrieren",
            "description": "KI-gestützte Migration — öffnet Migrations-Studio"
          },
          "orchestrator": {
            "label": "Orchestrator-Workflow",
            "description": "Visueller DAG-Designer — Deployment auf Databricks, Vertex AI oder Airflow"
          },
          "map": {
            "label": "Zuordnen",
            "description": "Feldbasierte Zuordnung zwischen Quell- und Zielschemas"
          },
          "transform": {
            "label": "Transformieren",
            "description": "SQL- oder Python-Transformationen während der Übertragung anwenden"
          },
          "custom": {
            "label": "Benutzerdefiniert",
            "description": "Vollständig konfigurierbare Pipeline mit Code-Editor"
          }
        },
        "createdTitle": "Pipeline erstellt",
        "createdDesc": "{{name}} ({{mode}}) als Entwurf gespeichert.",
        "pipelineNameLabel": "Pipeline-Name",
        "pipelineNamePlaceholder": "z. B. {{source}} → {{target}} {{mode}}",
        "sourceSystemLabel": "Quellsystem",
        "sourceSystemPlaceholder": "z. B. Postgres prod, Snowflake DWH",
        "targetDestinationLabel": "Zielsystem",
        "targetDestinationPlaceholder": "z. B. BigQuery curated, S3-Lake",
        "modeSuffix": "{{mode}}-Modus",
        "change": "Ändern",
        "scheduleLabel": "Zeitplan",
        "scheduleSelectPlaceholder": "Zeitplan auswählen",
        "batchSizeLabel": "Batch-Größe",
        "retryOnFailureLabel": "Bei Fehler wiederholen",
        "retryEnabled": "Aktiviert (3 Versuche)",
        "retryDisabled": "Deaktiviert",
        "transformationSqlLabel": "Transformations-SQL",
        "customPipelineCodeLabel": "Benutzerdefinierter Pipeline-Code",
        "transformSqlPlaceholder": "SELECT\n  customer_id,\n  SUM(amount) as total_spend,\n  COUNT(*) as txn_count\nFROM source_table\nGROUP BY customer_id",
        "customCodePlaceholder": "# Benutzerdefinierte Pipeline-Logik\nimport pandas as pd\n\ndef transform(df):\n    return df",
        "summaryTitle": "Pipeline-Zusammenfassung",
        "summaryName": "Name:",
        "summaryType": "Typ:",
        "summarySchedule": "Zeitplan:",
        "summaryBatchSize": "Batch-Größe:",
        "summaryRetry": "Wiederholung:",
        "retryAttempts": "3 Versuche",
        "back": "Zurück",
        "done": "Fertig",
        "continue": "Weiter",
        "creating": "Wird erstellt…",
        "createPipeline": "Pipeline erstellen"
      },
      "detail": {
        "configured": "Konfiguriert",
        "error": "Fehler",
        "start": "START",
        "end": "ENDE",
        "sourceNodeType": "Quelle",
        "targetNodeType": "Ziel",
        "extractNodeLabel": "Extrahieren & Validieren",
        "parserNodeType": "Parser",
        "notFoundTitle": "Pipeline nicht gefunden",
        "backToPipelines": "Zurück zu Pipelines",
        "typeLabel": "Typ",
        "batchSizeLabel": "Batch-Größe",
        "retryOnFailureLabel": "Bei Fehler wiederholen",
        "updatedLabel": "Aktualisiert",
        "yes": "Ja",
        "no": "Nein",
        "transformationSqlLabel": "Transformations-SQL",
        "customCodeLabel": "Benutzerdefinierter Code"
      }
    }
  },
  "pipelineDesigner": {
    "list": {
      "searchPlaceholder": "Designs suchen...",
      "emptyMessage": "Noch keine Orchestrator-Workflows",
      "newWorkflow": "Neuer Orchestrator-Workflow",
      "columnName": "Name",
      "columnDescription": "Beschreibung",
      "columnStatus": "Status",
      "columnUpdatedAt": "Aktualisiert am",
      "columnCreatedAt": "Erstellt am",
      "columnActions": "Aktionen",
      "actionEdit": "Bearbeiten",
      "actionDelete": "Löschen",
      "createFailed": "Design konnte nicht erstellt werden",
      "deleteFailed": "Design konnte nicht gelöscht werden",
      "deletedToast": "Design \"{{name}}\" gelöscht",
      "filterStatusLabel": "Status",
      "deleteDialogTitle": "Design löschen",
      "deleteDialogMessage": "Möchten Sie \"{{name}}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteDialogConfirm": "Design löschen",
      "cancel": "Abbrechen"
    },
    "status": {
      "draft": "Entwurf",
      "published": "Veröffentlicht",
      "pending": "Ausstehend",
      "running": "Läuft",
      "success": "Erfolgreich",
      "failed": "Fehlgeschlagen",
      "cancelled": "Abgebrochen",
      "terminating": "Wird beendet",
      "timed_out": "Zeitüberschreitung",
      "unknown": "Unbekannt"
    },
    "canvas": {
      "loading": "Design wird geladen...",
      "tabCanvas": "Canvas",
      "tabRuns": "Ausführungen",
      "tabSettings": "Einstellungen",
      "publishButton": "Veröffentlichen & ausführen",
      "publishDisabledTitle": "Wählen Sie im Tab „Einstellungen“ eine Orchestrator-Verbindung, um zu veröffentlichen.",
      "settingsTitle": "Design-Einstellungen",
      "orchestratorRuntimeTitle": "Orchestrator-Laufzeit",
      "orchestratorRuntimeDesc": "Zum Veröffentlichen ist eine Mandanten-Orchestrator-Verbindung erforderlich, die dem Zieltyp entspricht. Anmeldedaten werden vom Connector aufgelöst, nicht im Graph gespeichert.",
      "targetOrchestratorLabel": "Ziel-Orchestrator",
      "saveFailed": "Design konnte nicht gespeichert werden",
      "validationFailed": "Design-Validierung fehlgeschlagen",
      "publishFailed": "Veröffentlichung fehlgeschlagen"
    },
    "createDialog": {
      "title": "Neuer Orchestrator-Workflow",
      "closeAria": "Dialog schließen",
      "nameLabel": "Designname",
      "namePlaceholder": "z. B. nightly-feature-batch",
      "descriptionLabel": "Beschreibung (optional)",
      "descriptionPlaceholder": "Kurze Zusammenfassung für den Katalog",
      "orchestratorLabel": "Ziel-Orchestrator",
      "orchestratorHint": "Veröffentlichen & Ausführen nutzt heute den Enterprise-Ontology-Publisher für Databricks Workflows. Vertex AI und Airflow sind geplant.",
      "cancel": "Abbrechen",
      "create": "Erstellen",
      "creating": "Wird erstellt…"
    },
    "publishDialog": {
      "title": "Veröffentlichen & ausführen",
      "selectConnectionWarning": "Wählen Sie im Tab „Einstellungen“ eine <1>Orchestrator-Verbindung</1>, bevor Sie veröffentlichen. Die Ausführungsschicht löst Anmeldedaten über diesen Connector auf.",
      "translateJobText": "Dies übersetzt <1>{{designName}}</1> in einen <2>{{orchestratorType}}</2>-Job, erstellt ihn und löst sofort eine Ausführung aus.",
      "notebookParamsLabel": "Notebook-Parameter (optionales JSON)",
      "cancel": "Abbrechen",
      "publish": "Veröffentlichen & ausführen",
      "publishing": "Wird veröffentlicht...",
      "orchestratorFallback": "Orchestrator"
    },
    "nodeConfig": {
      "nodeTitle": "{{type}}-Knoten",
      "noConfigurableProps": "Dieser Knoten hat keine konfigurierbaren Eigenschaften.",
      "taskConfigTitle": "Aufgabenkonfiguration",
      "labelLabel": "Bezeichnung",
      "labelPlaceholder": "Aufgabenname",
      "notebookPathLabel": "Notebook-Pfad",
      "notebookPathPlaceholder": "/notebooks/my_notebook.py",
      "notebookPathHint": "Pfad relativ zum Stammverzeichnis des Git-Repositorys.",
      "timeoutLabel": "Timeout (Sekunden)",
      "maxRetriesLabel": "Max. Wiederholungen",
      "retryOnTimeoutLabel": "Bei Zeitüberschreitung wiederholen"
    },
    "canvasEditor": {
      "addTask": "Aufgabe hinzufügen",
      "saveNow": "Jetzt speichern",
      "allChangesSaved": "Alle Änderungen gespeichert",
      "saving": "Wird gespeichert…",
      "saveFailedUseSaveNow": "Speichern fehlgeschlagen — „Jetzt speichern“ verwenden",
      "unsavedWillAutoSave": "Nicht gespeichert — wird automatisch gespeichert",
      "delete": "Löschen",
      "newTaskLabel": "Neue Aufgabe"
    },
    "gitSource": {
      "title": "Git-Quelle",
      "repoUrlLabel": "Repository-URL",
      "repoUrlPlaceholder": "https://github.com/org/repo",
      "providerLabel": "Anbieter",
      "branchLabel": "Branch",
      "branchPlaceholder": "main",
      "branchError": "Geben Sie einen gültigen Branch-Namen ein (nur Buchstaben, Zahlen, /, -, _, .)."
    },
    "runs": {
      "noRuns": "Noch keine Ausführungen. Veröffentlichen Sie das Design, um eine Ausführung zu erstellen.",
      "colStatus": "Status",
      "colRunId": "Ausführungs-ID",
      "colStarted": "Gestartet",
      "colDuration": "Dauer",
      "colExternal": "Extern",
      "colActions": "Aktionen",
      "runningLabel": "Läuft...",
      "view": "Anzeigen",
      "cancel": "Abbrechen"
    },
    "runDetail": {
      "loading": "Ausführungsdetails werden geladen...",
      "title": "Ausführungsdetails",
      "runId": "Ausführungs-ID",
      "externalRunId": "Externe Ausführungs-ID",
      "started": "Gestartet",
      "completed": "Abgeschlossen",
      "viewInOrchestrator": "Im Orchestrator anzeigen",
      "cancelling": "Wird abgebrochen...",
      "cancelRun": "Ausführung abbrechen",
      "taskStates": "Aufgabenstatus"
    },
    "orchestratorConnection": {
      "label": "Orchestrator-Verbindung",
      "loadingConnections": "Verbindungen werden geladen…",
      "optionalSelectToEnable": "Optional — auswählen, um Veröffentlichen & Ausführen zu aktivieren",
      "noConnections": "Keine Verbindungen für diesen Orchestrator-Typ.",
      "addOneLink": "Eine hinzufügen unter Verbindungen → Orchestratoren"
    },
    "nodes": {
      "start": "Start",
      "end": "Ende",
      "untitledTask": "Unbenannte Aufgabe"
    }
  },
  "agentStudio": {
    "selfHeal": {
      "llmModel": "LLM-Modell",
      "llmModelPlaceholder": "Modell auswählen",
      "llmModelEmpty": "Für dieses Projekt sind keine LLM-Modelle konfiguriert.",
      "llmModelSearch": "Modelle suchen",
      "analysis": {
        "engineLabel": "Analyse-Engine",
        "engineModel": "{{model}}",
        "engineModelFallback": "Ausgewähltes Modell",
        "engineRules": "Regelbasiert",
        "engineFallback": "Fallback (regelbasiert)",
        "fallbackTitle": "Modell nicht verfügbar",
        "fallbackNotice": "Modell „{{model}}“ ist fehlgeschlagen ({{reason}}). Die Ergebnisse stammen aus der standardmäßigen regelbasierten Analyse.",
        "fallbackNoticeUnnamed": "Das ausgewählte Modell ist fehlgeschlagen ({{reason}}). Die Ergebnisse stammen aus der standardmäßigen regelbasierten Analyse.",
        "reasonAuthFailed": "API-Schlüssel abgelehnt",
        "reasonRateLimited": "Ratenlimit erreicht",
        "reasonTimeout": "Zeitüberschreitung der Anfrage",
        "reasonMisconfigured": "das Modell ist für dieses Projekt nicht verfügbar",
        "reasonInvalidModel": "die Modellauswahl ist ungültig",
        "reasonInvalidJson": "die Antwort konnte nicht gelesen werden",
        "reasonUnusable": "das Modell hat keine verwertbaren Empfehlungen geliefert",
        "reasonUnavailable": "das Modell war nicht erreichbar"
      }
    },
    "loading": "Agent Studio wird geladen...",
    "permissionDeniedMessage": "Sie sind nicht berechtigt, diese Seite anzuzeigen. Bitte kontaktieren Sie Ihren Administrator.",
    "untitledAgent": "Unbenannter Agent",
    "fallbackAgentName": "Agent",
    "ok": "OK",
    "closeDialogAriaLabel": "Dialog schließen",
    "list": {
      "columnAgentName": "Agentenname",
      "columnProject": "Projekt",
      "columnVersion": "Version",
      "columnStatus": "Status",
      "columnCreator": "Ersteller",
      "columnCreatedAt": "Erstellt am",
      "columnUpdatedAt": "Aktualisiert am",
      "columnActions": "Aktionen",
      "registeredToRegistryTitle": "Im Registry registriert",
      "emptyFavorites": "Noch keine Favoriten — markieren Sie Agenten in der Liste mit einem Stern",
      "emptyArchived": "Keine archivierten Agenten",
      "emptyDefault": "Keine Agenten gefunden",
      "filterFavoritesTitle": "Nach Favoriten filtern",
      "allAgents": "Alle Agenten",
      "favorites": "Favoriten",
      "catalogTitle": "Agentenkatalog",
      "activeAgentsTitle": "Aktive Agenten",
      "archivedAgentsTitle": "Archivierte Agenten",
      "guidedTourTitle": "Geführte Tour durch Agent Studio",
      "autoTune": "Auto Tune",
      "createAgent": "Agent erstellen",
      "exportSelected": "Auswahl exportieren",
      "archiveSelected": "Auswahl archivieren",
      "exportFileName": "Agent_Studio",
      "exportFileNameArchived": "Agent_Studio_Archiviert"
    },
    "filters": {
      "status": "Status",
      "registryStatus": "Registry-Status",
      "draft": "Entwurf",
      "published": "Veröffentlicht",
      "registered": "Registriert",
      "unregistered": "Nicht registriert",
      "project": "Projekt",
      "creator": "Ersteller"
    },
    "actions": {
      "restoreToDraft": "Als Entwurf wiederherstellen",
      "view": "Ansehen",
      "chat": "Chat",
      "traces": "Traces",
      "logs": "Logs",
      "exportYaml": "Exportieren (YAML)",
      "exportJson": "Exportieren (JSON)",
      "evaluate": "Evaluieren",
      "viewEvaluationRuns": "Evaluierungsläufe anzeigen",
      "registerToRegistry": "Im Registry registrieren",
      "registrationPending": "Registrierung ausstehend",
      "unregisterFromRegistry": "Aus Registry entfernen",
      "clone": "Klonen",
      "archive": "Archivieren"
    },
    "backLabels": {
      "traces": "Traces",
      "blueprint": "Blueprint"
    },
    "publishDialog": {
      "title": "Agent veröffentlichen",
      "confirmHeading": "Möchten Sie wirklich veröffentlichen?",
      "confirmDescription": "Durch die Veröffentlichung wird dieser Agent zur Nutzung verfügbar. Diese Aktion kann durch Archivieren des Agenten rückgängig gemacht werden.",
      "agentLabel": "Agent:",
      "frameworkLabel": "Framework:",
      "nodesLabel": "Knoten:",
      "publishButton": "Agent veröffentlichen"
    },
    "archiveDialog": {
      "title": "Agent archivieren",
      "publishedHeading": "Dieser Agent ist veröffentlicht",
      "publishedDescription": "Zum Archivieren beenden Sie zuerst alle Agent-Store-Einträge, archivieren Sie Bereitstellungen in Monitoring und entfernen Sie die Registrierung im Agent Registry, falls noch vorhanden. Der Agent wird in die Archivliste verschoben, sobald diese Schritte abgeschlossen sind.",
      "confirmMessage": "Möchten Sie \"{{name}}\" wirklich archivieren?",
      "checkingDependencies": "Abhängigkeiten werden geprüft…",
      "archiveButton": "Agent archivieren",
      "draftConfirmMessage": "\"{{name}}\" archivieren? Der Agent erscheint unter Archiviert; Sie können ihn dort als Entwurf wiederherstellen oder endgültig löschen."
    },
    "deleteDialog": {
      "title": "Agent löschen",
      "confirmMessage": "\"{{name}}\" endgültig löschen? Der Agent wird aus dem System entfernt und kann nicht rückgängig gemacht werden."
    },
    "bulkArchive": {
      "title_one": "Agent archivieren",
      "title_other": "Agenten archivieren",
      "confirmMessage": "{{count}} Agent(en) archivieren? Sie erscheinen unter Archiviert; Sie können sie dort als Entwürfe wiederherstellen oder endgültig löschen.",
      "confirmButton": "Archivieren",
      "failureMessage": "Agenten konnten nicht archiviert werden",
      "blockedMessage": "\"{{name}}\" hat Abhängigkeiten, die vor dem Archivieren entfernt werden müssen."
    },
    "blockedDialogs": {
      "cannotArchiveTitle": "Agent kann noch nicht archiviert werden",
      "cannotUnregisterTitle": "Kann noch nicht aus der Registry entfernt werden",
      "unregisterDependenciesMessage": "Entfernen Sie Agent-Store-Einträge und archivieren Sie Bereitstellungen, bevor Sie diesen Agenten aus dem Agent Registry entfernen.",
      "dependenciesMustBeCleared": "Abhängigkeiten müssen zuerst entfernt werden."
    },
    "registerDialog": {
      "title": "Im Registry registrieren",
      "submitHeading": "Zur Admin-Genehmigung einreichen",
      "submitDescription": "Dies sendet eine Registrierungsanfrage an Tenant-Admins. Der Agent erscheint erst im Agent Registry, nachdem ein Admin ihn unter Allgemeine Einstellungen → Anfragegenehmigungen genehmigt hat.",
      "confirmMessage": "Registrierungsanfrage für \"{{name}}\" einreichen?",
      "metadata": "Metadaten",
      "submitting": "Wird eingereicht...",
      "submitRequest": "Anfrage einreichen"
    },
    "deletePrerequisites": {
      "stillRegistered": "Dieser Agent ist noch im Agent Registry registriert.",
      "activeStoreListing": "Es gibt einen aktiven Agent-Store-Eintrag für diesen Agenten.",
      "nonArchivedDeployments": "Es gibt noch nicht archivierte Agent-Bereitstellungen.",
      "clearBeforeArchive": "{{details}} Entfernen Sie diese, bevor Sie archivieren können."
    },
    "blockerMessages": {
      "registry": "Entfernen Sie die Registrierung dieses Agenten im Agent Registry, bevor Sie archivieren.",
      "agent_store": "Beenden Sie den aktiven Agent-Store-Eintrag für diesen Agenten, bevor Sie archivieren.",
      "agent_deployments": "Archivieren Sie alle Agent-Bereitstellungen in Monitoring, bevor Sie archivieren.",
      "agent_store_unregister": "Beenden Sie den aktiven Agent-Store-Eintrag, bevor Sie diesen Agenten aus dem Agent Registry entfernen.",
      "agent_deployments_unregister": "Archivieren Sie alle Bereitstellungen in Monitoring, bevor Sie diesen Agenten aus dem Agent Registry entfernen."
    },
    "blockerNav": {
      "registry": "Agent Registry öffnen",
      "workflow_registry": "Workflow Registry öffnen",
      "agent_store": "Agent Store öffnen (verwalten)",
      "agent_deployments": "Monitoring öffnen — Bereitstellungen",
      "workflow_store": "Workflow Store öffnen (verwalten)",
      "workflow_deployments": "Monitoring öffnen — Bereitstellungen",
      "running_executions": "Läufe öffnen"
    }
  },
  "projects": {
    "status": {
      "active": "Aktiv",
      "draft": "Entwurf",
      "archived": "Archiviert",
      "error": "Fehler",
      "pending": "Ausstehend"
    },
    "list": {
      "permissionDeniedMessage": "Sie sind nicht berechtigt, Projekte anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
      "loading": "Projekte werden geladen...",
      "columnName": "Projektname",
      "columnMembers": "Mitglieder",
      "columnStatus": "Status",
      "columnActions": "Aktionen",
      "filterCreatorLabel": "Ersteller",
      "actionOpen": "Öffnen",
      "actionConfigure": "Konfigurieren",
      "actionEdit": "Bearbeiten",
      "actionDelete": "Löschen",
      "bulkDeleteSelected": "Auswahl löschen",
      "emptyMessage": "Keine Projekte gefunden",
      "createProject": "Projekt erstellen",
      "setupWizard": "Setup-Assistent",
      "setupWizardTooltip": "Setup-Assistent – YAML-Dateien importieren, um ein Projekt zu erstellen",
      "deleteDialogTitle": "Projekt löschen",
      "deleteDialogMessage": "Möchten Sie „{{name}}“ wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      "fetchingDependenciesMessage": "Projektabhängigkeiten werden abgerufen…",
      "forceDeleteDialogTitle": "Endgültiges Löschen bestätigen",
      "forceDeleteDialogMessage": "Das endgültige Löschen entfernt „{{name}}“ sowie alle Agenten, Deployments, Agent-Store-Einträge, Simulationen, Prompts, Skills, Tools und weitere Projektdaten dauerhaft. Dies kann nicht rückgängig gemacht werden.",
      "forceDeleteConfirmLabel": "Projekt endgültig löschen",
      "bulkDeleteDialogTitle": "Ausgewählte Projekte löschen",
      "bulkDeleteConfirmMessage_one": "Möchten Sie {{count}} Projekt wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      "bulkDeleteConfirmMessage_other": "Möchten Sie {{count}} Projekte wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      "bulkDeleteConfirmLabel_one": "{{count}} Projekt löschen",
      "bulkDeleteConfirmLabel_other": "{{count}} Projekte löschen",
      "forceDeleteSuccessToast": "Projekt „{{name}}“ wurde endgültig gelöscht",
      "forceDeleteErrorToast": "Endgültiges Löschen fehlgeschlagen. Entfernen Sie verbleibende Abhängigkeiten oder versuchen Sie es erneut.",
      "noProjectsSelectedWarning": "Keine Projekte ausgewählt",
      "bulkDeletePartialWarning": "{{deleted}} Projekt(e) gelöscht, {{skipped}} fehlgeschlagen: {{errors}}",
      "bulkDeleteSuccessToast": "{{deleted}} Projekt(e) erfolgreich gelöscht",
      "bulkDeleteErrorToast": "Projekte konnten nicht gelöscht werden",
      "andOthers": "und {{count}} weitere"
    },
    "createDialog": {
      "title": "Neues Projekt erstellen",
      "closeAriaLabel": "Dialog schließen",
      "loadingQuota": "Kontingent wird geladen...",
      "quotaLabel": "Projekte",
      "nameLabel": "Projektname *",
      "namePlaceholder": "Projektnamen eingeben",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": "Kurze Beschreibung des Projekts",
      "descriptionEmojiError": "Die Beschreibung darf keine Emojis enthalten. Verwenden Sie nur reinen Text.",
      "quotaExceededTitle": "Projektkontingent überschritten",
      "creating": "Wird erstellt..."
    },
    "editDialog": {
      "title": "Projekt bearbeiten",
      "closeAriaLabel": "Dialog schließen",
      "nameLabel": "Projektname *",
      "descriptionLabel": "Beschreibung",
      "saving": "Wird gespeichert...",
      "saveChanges": "Änderungen speichern"
    },
    "actions": {
      "view": "Anzeigen",
      "edit": "Bearbeiten",
      "chat": "Chat",
      "traces": "Traces",
      "logs": "Protokolle",
      "evaluate": "Bewerten",
      "viewEvaluationRuns": "Bewertungsläufe anzeigen",
      "cloneInAgentStudio": "In Agent Studio klonen",
      "openInAgentStudio": "In Agent Studio öffnen",
      "manageArchiveInStudio": "Archiv in Studio verwalten",
      "open": "Öffnen",
      "runs": "Ausführungen",
      "editCanvas": "Canvas bearbeiten",
      "viewInStudio": "In Studio anzeigen",
      "testChat": "Testen / Chat",
      "deployInRegistry": "In Registry bereitstellen",
      "guardrails": "Guardrails",
      "chatDetail": "Chat / Detail",
      "runtimeSettings": "Laufzeiteinstellungen",
      "openInMonitoring": "In Monitoring öffnen"
    },
    "detail": {
      "notFound": "Projekt nicht gefunden",
      "backToProjectsButton": "Zurück zu Projekten",
      "backToProjectsAriaLabel": "Zurück zu Projekten",
      "viewOnlyBadge": "Nur Ansicht",
      "tabsAriaLabel": "Projektdetails-Tabs",
      "tabs": {
        "overview": "Übersicht",
        "agents": "Agenten",
        "workflows": "Workflows",
        "registry": "Registrierung",
        "evals": "Auswertungen",
        "deployments": "Bereitstellungen"
      }
    },
    "overview": {
      "hubSubtitle": "Projekt-Hub",
      "noTabsAvailable": "Für Ihre Rolle sind keine Detail-Tabs verfügbar.",
      "openInBrand": "{{label}} in {{brand}} öffnen",
      "cards": {
        "agents": "Agenten",
        "workflows": "Workflows",
        "registry": "Registriert",
        "evals": "Auswertungsagenten",
        "deployments": "Aktive Bereitstellungen"
      }
    },
    "members": {
      "title": "Mitglieder",
      "refreshTooltip": "Mitgliederliste aktualisieren",
      "addMemberButton": "Mitglied hinzufügen",
      "selectedCount": "{{count}} ausgewählt",
      "changeRoleButton": "Rolle ändern",
      "remove": "Entfernen",
      "clearButton": "Löschen",
      "selectAllButton": "Alle auswählen",
      "noMembersYet": "Noch keine Mitglieder",
      "selectAll": "Alle auswählen",
      "deselectAll": "Alle abwählen",
      "unknown": "Unbekannt",
      "creatorBadge": "Ersteller",
      "role": {
        "member": "Mitglied",
        "admin": "Admin",
        "viewer": "Betrachter",
        "creator": "Ersteller"
      },
      "memberSince": "Mitglied seit {{date}}",
      "changeRoleTitle": "Rolle ändern",
      "memberFallbackName": "Mitglied",
      "select": "Auswählen",
      "deselect": "Abwählen",
      "removeMembersTitle": "Mitglieder entfernen",
      "removeMemberTitle": "Mitglied entfernen",
      "removeMembersMessage": "Möchten Sie wirklich {{count}} Mitglied(er) aus diesem Projekt entfernen? Dies kann nicht rückgängig gemacht werden.",
      "removeMemberMessage": "Möchten Sie „{{name}}\" wirklich aus diesem Projekt entfernen? Dies kann nicht rückgängig gemacht werden.",
      "changeRoleForCount_one": "Rolle für {{count}} Mitglied ändern",
      "changeRoleForCount_other": "Rolle für {{count}} Mitglieder ändern",
      "selectNewRoleLabel": "Neue Rolle auswählen",
      "updating": "Wird aktualisiert...",
      "updateRole": "Rolle aktualisieren",
      "loadErrorFallback": "Mitglieder konnten nicht geladen werden. Bitte laden Sie die Seite neu.",
      "selectAtLeastOneUserError": "Bitte wählen Sie mindestens einen Benutzer aus",
      "addedSuccessToast_one": "{{count}} Mitglied erfolgreich hinzugefügt",
      "addedSuccessToast_other": "{{count}} Mitglieder erfolgreich hinzugefügt",
      "removedSuccessToast": "Mitglied erfolgreich entfernt",
      "roleUpdatedSuccessToast": "Mitgliedsrolle erfolgreich aktualisiert",
      "bulkRoleUpdatedWithErrorsToast": "{{updated}} Mitglieder aktualisiert. {{errorCount}} Fehler aufgetreten.",
      "bulkRoleUpdatedSuccessToast": "{{updated}} Mitgliedsrolle(n) erfolgreich aktualisiert",
      "bulkRemovedWithErrorsToast": "{{removed}} Mitglieder entfernt. {{errorCount}} Fehler aufgetreten.",
      "bulkRemovedSuccessToast": "{{removed}} Mitglied(er) erfolgreich entfernt"
    },
    "configure": {
      "tabsAriaLabel": "Projektkonfigurations-Tabs",
      "tabs": {
        "members": "Mitglieder",
        "orchestrators": "Orchestratoren",
        "prompts": "Prompts",
        "models": "Modelle",
        "tools": "Tools",
        "skills": "Skills",
        "knowledge": "Wissen",
        "graph": "Graph",
        "vector": "Vektor",
        "storage": "Speicher"
      }
    },
    "setupWizard": {
      "title": "Projekt-Einrichtungsassistent",
      "projectFieldLabel": "Projekt",
      "projectFieldPlaceholder": "Projekt auswählen...",
      "projectFieldRequiredLabel": "Projekt *",
      "projectNameFieldName": "Projektname",
      "projectNameFieldRequiredLabel": "Projektname *",
      "projectNamePlaceholder": "Mein tolles Projekt",
      "orDivider": "oder",
      "createNewProject": "Neues Projekt erstellen",
      "descriptionFieldLabel": "Beschreibung",
      "descriptionPlaceholder": "Kurze Beschreibung...",
      "filesImportedIntoSelectedProject": "Dateien werden in das ausgewählte Projekt importiert",
      "dropzoneAriaLabel": "YAML-Dateien hochladen. Dateien hierher ziehen und ablegen oder klicken bzw. Eingabe- oder Leertaste drücken, um zu durchsuchen.",
      "dropzoneText": "Dateien hier ablegen oder zum Durchsuchen klicken",
      "dropzoneHint": ".yaml, .yml — Agenten, Modelle, Tools, Prompts, Skills, Wissen, Connectoren, IAM",
      "validFilesCount": "{{count}} gültige Datei(en)",
      "filesWithErrorsCount": "{{count}} mit Fehlern",
      "noAgentYamlWarning": "Kein Agent-YAML erkannt. Erwägen Sie, eine Agentenkonfiguration hinzuzufügen.",
      "reviewStepTitle": "Importreihenfolge überprüfen",
      "reviewStepDescription": "Dateien werden basierend auf Abhängigkeiten in folgender Reihenfolge importiert:",
      "filesWithErrorsSkipped": "{{count}} Datei(en) mit Fehlern werden übersprungen",
      "importingStepTitle": "Wird importiert...",
      "importingProgress": "Importiere {{current}} von {{total}}: {{fileName}}",
      "importActions": {
        "created": "erstellt",
        "matched": "zugeordnet",
        "failed": "fehlgeschlagen"
      },
      "completeStepTitleSuccess": "Einrichtung abgeschlossen!",
      "completeStepTitleWithErrors": "Einrichtung mit Fehlern abgeschlossen",
      "completeStepDescription": "Ihr Projekt wurde mit den folgenden Entitäten eingerichtet:",
      "summaryBadges": {
        "created": "+{{count}} erstellt",
        "matched": "{{count}} zugeordnet",
        "failed": "{{count}} fehlgeschlagen"
      },
      "errorsHeading": "Fehler:",
      "steps": {
        "selectProject": "Projekt auswählen",
        "addFiles": "Dateien hinzufügen",
        "review": "Überprüfen",
        "import": "Importieren"
      },
      "creatingLabel": "Wird erstellt...",
      "createAndContinue": "Erstellen & Fortfahren",
      "continueLabel": "Weiter",
      "reviewImport": "Import überprüfen",
      "startImport": "Import starten",
      "importingLabel": "Wird importiert...",
      "goToProject": "Zum Projekt",
      "entityTypes": {
        "agent": "Agent",
        "model": "Modell",
        "tool": "Tool",
        "prompt": "Prompt",
        "skill": "Skill",
        "knowledge": "Wissen",
        "connector": "Connector",
        "iam": "IAM",
        "bundle": "Bundle",
        "unknown": "Unbekannt"
      },
      "toasts": {
        "dropYamlFiles": "Bitte YAML-Dateien ablegen",
        "enterProjectName": "Bitte geben Sie einen Projektnamen ein",
        "projectCreated": "Projekt \"{{name}}\" erstellt",
        "selectProject": "Bitte wählen Sie ein Projekt aus",
        "projectSelected": "Projekt \"{{name}}\" ausgewählt",
        "addAtLeastOneFile": "Bitte fügen Sie mindestens eine YAML-Datei hinzu",
        "noValidYamlFiles": "Keine gültigen YAML-Dateien gefunden",
        "projectNotCreated": "Projekt nicht erstellt",
        "noValidFilesToImport": "Keine gültigen Dateien zum Importieren",
        "importReportedFailure": "Import von {{name}} meldete einen Fehler",
        "allImportedSuccessfully": "Alle Entitäten erfolgreich importiert!",
        "importPermissionError": "Import aufgrund unzureichender Berechtigungen fehlgeschlagen. Bitte wenden Sie sich an Ihren Administrator.",
        "importCompletedWithErrors": "Import mit {{count}} Fehler(n) abgeschlossen"
      },
      "unknownProject": "Unbekannt"
    },
    "agentsTab": {
      "agentStatusTitle": "Agentenstatus",
      "activeAgentsTitle": "Aktive Agenten",
      "archivedAgentsTitle": "Archivierte Agenten",
      "openInAgentStudio": "In Agent Studio öffnen",
      "noArchivedAgents": "Keine archivierten Agenten in diesem Projekt.",
      "noAgents": "Keine Agenten in diesem Projekt.",
      "goToAgentStudio": "Zu Agent Studio",
      "archiveDialogTitle": "{{count}} Agent(en) archivieren",
      "archiveDialogMessage": "{{count}} Agent(en) archivieren? Sie erscheinen unter Archiviert; Sie können sie von dort in Entwürfe zurückversetzen oder endgültig löschen.",
      "archiveButtonLabel": "Archivieren",
      "archivedWithSkippedToast": "{{deleted}} Agent(en) archiviert, {{skipped}} aufgrund aktiver Abhängigkeiten übersprungen.",
      "archivedToast": "{{count}} Agent(en) archiviert",
      "exportSelected": "Auswahl exportieren",
      "archiveSelected": "Auswahl archivieren",
      "columns": {
        "name": "Name",
        "status": "Status",
        "framework": "Framework",
        "creator": "Ersteller",
        "createdAt": "Erstellt am",
        "updatedAt": "Aktualisiert am",
        "actions": "Aktionen"
      },
      "searchPlaceholder": "Agenten suchen…"
    },
    "workflowsTab": {
      "statusPublished": "Veröffentlicht",
      "columns": {
        "workflow": "Workflow",
        "status": "Status",
        "schedule": "Zeitplan",
        "controls": "Steuerung",
        "creator": "Ersteller",
        "runs": "Ausführungen",
        "createdAt": "Erstellt am",
        "tags": "Tags",
        "actions": "Aktionen"
      },
      "registeredToRegistryAtVersion": "Im Registry registriert unter v{{version}}",
      "registeredToRegistry": "Im Registry registriert",
      "scheduleActive": "Zeitplan aktiv",
      "schedulePaused": "Zeitplan pausiert",
      "notScheduled": "Nicht geplant",
      "draftCadenceTooltip": "Taktung im Entwurf gespeichert — zum Starten des Zeitplans veröffentlichen ({{cadence}}).",
      "neverRun": "nie ausgeführt",
      "lastRunTitle": "Letzte Ausführung",
      "searchPlaceholder": "Workflows suchen…",
      "clearSearch": "Suche löschen",
      "totalWorkflows": "Workflows insgesamt {{count}}",
      "catalogTitle": "Katalog",
      "activeWorkflowsTitle": "Aktive Workflows",
      "archivedWorkflowsTitle": "Archivierte Workflows",
      "gridViewTitle": "Rasteransicht",
      "listViewTitle": "Listenansicht",
      "openInAgentWorkflows": "In Agent Workflows öffnen",
      "noSearchResults": "Keine Workflows entsprechen Ihrer Suche.",
      "noArchivedWorkflows": "Keine archivierten Workflows in diesem Projekt.",
      "noWorkflows": "Keine Workflows in diesem Projekt.",
      "goToAgentWorkflows": "Zu Agent Workflows",
      "lastRunStatusTooltip": "Status der letzten Ausführung: {{status}}",
      "lastRunTooltip": "Letzte Ausführung: {{time}}",
      "updatedTooltip": "Aktualisiert: {{time}}",
      "noDescriptionProvided": "Keine Beschreibung angegeben",
      "runsCount": "{{count}} Ausführungen",
      "lastRunLabel": "Letzte Ausführung {{time}}",
      "pageOfTotal": "Seite {{page}} von {{totalPages}}",
      "versionTitle": "Version"
    },
    "skillsTab": {
      "loadError": "Fehler beim Laden der Skills",
      "requestedAccessToast": "Zugriff für {{count}} Skill(s) angefordert (Genehmigung ausstehend)",
      "addedToast": "{{count}} Skill(s) zum Projekt hinzugefügt",
      "alreadyInProjectToast": "{{count}} Skill(s) bereits im Projekt",
      "addFailedToast": "Hinzufügen von {{count}} Skill(s) fehlgeschlagen",
      "removedToast": "Skill aus dem Projekt entfernt",
      "bulkRemovedToast": "{{count}} Skill(s) erfolgreich aus dem Projekt entfernt",
      "bulkRemoveFailedToast": "Entfernen von {{count}} Skill(s) fehlgeschlagen",
      "removeFromProject": "Aus Projekt entfernen",
      "pending": "Ausstehend",
      "platform": "Plattform",
      "allModels": "Alle Modelle",
      "columns": {
        "name": "Skill-Name",
        "category": "Kategorie",
        "type": "Typ",
        "model": "Modell",
        "version": "Version",
        "added": "Hinzugefügt",
        "lastUpdated": "Zuletzt aktualisiert",
        "actions": "Aktionen"
      },
      "errorBoundaryMessage": "Skills konnten nicht geladen werden. Bitte Seite aktualisieren.",
      "emptyMessage": "Keine Skills für dieses Projekt konfiguriert",
      "addSkill": "Skill hinzufügen",
      "addSkillsToProjectTitle": "Skills zum Projekt hinzufügen",
      "showApprovedSkills": "Genehmigte Skills anzeigen",
      "removeDialogTitle": "Skill entfernen",
      "removeDialogMessage": "\"{{name}}\" aus diesem Projekt entfernen?",
      "remove": "Entfernen",
      "bulkRemoveDialogTitle": "Skills entfernen",
      "bulkRemoveDialogMessage": "Möchten Sie die {{count}} ausgewählten Skill(s) wirklich aus diesem Projekt entfernen?"
    },
    "toolsTab": {
      "requestedAccessToast": "Zugriff für {{count}} Tool(s) angefordert (Genehmigung ausstehend)",
      "alreadyInProjectToast": "{{count}} Tool(s) bereits im Projekt",
      "addFailedToast": "Hinzufügen von {{count}} Tool(s) fehlgeschlagen",
      "removedToast": "Tool aus dem Projekt entfernt",
      "bulkRemovedToast": "{{count}} Tool(s) erfolgreich aus dem Projekt entfernt",
      "bulkRemoveFailedToast": "Entfernen von {{count}} Tool(s) fehlgeschlagen: {{errors}}",
      "removeFromProject": "Aus Projekt entfernen",
      "exportSelected": "Auswahl exportieren",
      "pending": "Ausstehend",
      "columns": {
        "name": "Tool-Name",
        "type": "Typ",
        "endpoint": "Endpunkt",
        "created": "Erstellt",
        "lastUpdated": "Zuletzt aktualisiert",
        "actions": "Aktionen"
      },
      "errorBoundaryMessage": "Tools konnten nicht geladen werden. Bitte Seite aktualisieren.",
      "emptyMessage": "Keine Tools für dieses Projekt konfiguriert",
      "addTool": "Tool hinzufügen",
      "addToolsToProjectTitle": "Tools zum Projekt hinzufügen",
      "showApprovedTools": "Genehmigte Tools anzeigen",
      "removeDialogTitle": "Tool entfernen",
      "removeDialogMessage": "\"{{name}}\" aus diesem Projekt entfernen?",
      "remove": "Entfernen",
      "bulkRemoveDialogTitle": "Tools entfernen",
      "bulkRemoveDialogMessage": "Möchten Sie die {{count}} ausgewählten Tool(s) wirklich aus diesem Projekt entfernen?"
    },
    "modelsTab": {
      "requestedAccessToast": "Zugriff für {{count}} Modell(e) angefordert (Genehmigung ausstehend)",
      "alreadyInProjectToast": "{{count}} Modell(e) bereits im Projekt",
      "addFailedToast": "{{count}} Modell(e) konnten nicht hinzugefügt werden",
      "removedToast": "Modell erfolgreich entfernt",
      "bulkRemovedToast": "{{count}} Modell(e) erfolgreich aus dem Projekt entfernt",
      "bulkRemoveFailedToast": "Entfernen von {{count}} Modell(en) fehlgeschlagen: {{errors}}",
      "removeFromProject": "Aus Projekt entfernen",
      "pending": "Ausstehend",
      "columns": {
        "name": "Modellname",
        "provider": "Anbieter",
        "modelId": "Modell-ID",
        "created": "Erstellt",
        "lastUpdated": "Zuletzt aktualisiert",
        "actions": "Aktionen"
      },
      "errorBoundaryMessage": "Modelle konnten nicht geladen werden. Bitte Seite aktualisieren.",
      "emptyMessage": "Keine Modelle für dieses Projekt konfiguriert",
      "addModel": "Modell hinzufügen",
      "addModelsToProjectTitle": "Modelle zum Projekt hinzufügen",
      "showApprovedModels": "Genehmigte Modelle anzeigen",
      "removeDialogTitle": "Modell entfernen",
      "removeDialogMessage": "\"{{name}}\" aus diesem Projekt entfernen?",
      "remove": "Entfernen",
      "bulkRemoveDialogTitle": "Modelle entfernen",
      "bulkRemoveDialogMessage": "Möchten Sie die {{count}} ausgewählten Modell(e) wirklich aus diesem Projekt entfernen?"
    },
    "orchestratorsTab": {
      "selectAtLeastOne": "Bitte wählen Sie mindestens einen Orchestrator aus",
      "requestedAccessToast": "Zugriff für {{count}} Orchestrator(en) angefordert (Genehmigung ausstehend)",
      "removedToast": "\"{{name}}\" aus dem Projekt entfernt",
      "bulkRemovedToast": "{{count}} Orchestrator(en) erfolgreich aus dem Projekt entfernt",
      "bulkRemoveFailedToast": "Entfernen von {{count}} Orchestrator(en) fehlgeschlagen: {{errors}}",
      "removeFromProject": "Aus Projekt entfernen",
      "testConnection": "Verbindung testen",
      "testConnectionSuccess": "Verbindungstest für \"{{name}}\" erfolgreich",
      "testConnectionFailure": "Verbindungstest für \"{{name}}\" fehlgeschlagen: {{message}}",
      "columns": {
        "name": "Name",
        "type": "Typ",
        "host": "Host",
        "status": "Status",
        "addedBy": "Hinzugefügt von",
        "addedAt": "Hinzugefügt am",
        "actions": "Aktionen"
      },
      "errorBoundaryMessage": "Orchestratoren konnten nicht geladen werden. Bitte Seite aktualisieren.",
      "emptyMessage": "Keine Orchestratoren für dieses Projekt konfiguriert",
      "addOrchestrator": "Orchestrator hinzufügen",
      "addOrchestratorsToProjectTitle": "Orchestratoren zum Projekt hinzufügen",
      "removeDialogTitle": "Orchestrator entfernen",
      "removeDialogMessage": "\"{{name}}\" aus diesem Projekt entfernen?",
      "remove": "Entfernen",
      "bulkRemoveDialogTitle": "Orchestratoren entfernen",
      "bulkRemoveDialogMessage": "Möchten Sie die {{count}} ausgewählten Orchestrator(en) wirklich aus diesem Projekt entfernen?"
    },
    "knowledgeTab": {
      "unknown": "Unbekannt",
      "vectorDatabase": "Vektordatenbank",
      "vectorDbBadge": "Vektor-DB",
      "schemaTitle": "Schema: {{schema}}",
      "searchPlaceholder": "Tabellen durchsuchen...",
      "clearSearch": "Suche löschen",
      "columns": {
        "name": "Name",
        "database": "Datenbank",
        "rows": "Zeilen",
        "status": "Status",
        "creator": "Ersteller",
        "actions": "Aktionen"
      },
      "status": {
        "error": "Fehler",
        "active": "Aktiv",
        "syncing": "Synchronisiert",
        "pending": "Ausstehend"
      },
      "actions": {
        "previewData": "Daten anzeigen",
        "removeFromProject": "Aus Projekt entfernen",
        "remove": "Entfernen"
      },
      "toasts": {
        "requestedAccess": "Zugriff für {{count}} {{tableLabel}}{{plural}} angefordert (ausstehende Genehmigung)",
        "alreadyInProject": "{{count}} {{tableLabel}}{{plural}} bereits im Projekt",
        "requestAccessFailed": "Zugriffsanfrage für {{count}} {{tableLabel}}{{plural}} fehlgeschlagen",
        "removed": "Wissenstabelle aus Projekt entfernt",
        "bulkRemoved": "{{count}} {{typeLabel}}-Tabelle{{plural}} erfolgreich aus Projekt entfernt",
        "bulkRemoveFailed": "Entfernen von {{count}} {{typeLabel}}-Tabelle{{plural}} fehlgeschlagen: {{errors}}"
      },
      "removeDialogMessage": "\"{{name}}\" aus diesem Projekt entfernen?",
      "bulkRemoveDialogMessage": "Möchten Sie die {{count}} ausgewählten Tabelle(n) wirklich aus diesem Projekt entfernen?",
      "viewToggle": {
        "database": "Datenbankansicht",
        "collection": "Sammlungsansicht"
      },
      "variant": {
        "knowledge": {
          "tableLabel": "Wissenstabelle",
          "typeLabel": "Wissens",
          "addButton": "Wissen hinzufügen",
          "emptyMessage": "Keine Wissenstabellen für dieses Projekt konfiguriert",
          "addModalTitle": "Wissen zum Projekt hinzufügen",
          "membershipToggleLabel": "Genehmigte Tabellen anzeigen",
          "removeDialogTitle": "Wissenstabelle entfernen",
          "removeDialogTitlePlural": "Wissenstabellen entfernen",
          "errorBoundaryMessage": "Wissenstabellen konnten nicht geladen werden. Bitte Seite aktualisieren."
        },
        "graph": {
          "tableLabel": "Graph-Tabelle",
          "typeLabel": "Graph",
          "addButton": "Graph hinzufügen",
          "emptyMessage": "Keine Graph-Tabellen für dieses Projekt konfiguriert",
          "addModalTitle": "Graph-Tabellen zum Projekt hinzufügen",
          "membershipToggleLabel": "Genehmigte Graph-Tabellen anzeigen",
          "removeDialogTitle": "Graph-Tabelle entfernen",
          "removeDialogTitlePlural": "Graph-Tabellen entfernen",
          "errorBoundaryMessage": "Graph-Tabellen konnten nicht geladen werden. Bitte Seite aktualisieren."
        },
        "vector": {
          "tableLabel": "Vektor-Tabelle",
          "typeLabel": "Vektor",
          "addButton": "Vektor hinzufügen",
          "emptyMessage": "Keine Vektor-Tabellen für dieses Projekt konfiguriert",
          "addModalTitle": "Vektor-Tabellen zum Projekt hinzufügen",
          "membershipToggleLabel": "Genehmigte Vektor-Tabellen anzeigen",
          "removeDialogTitle": "Vektor-Tabelle entfernen",
          "removeDialogTitlePlural": "Vektor-Tabellen entfernen",
          "errorBoundaryMessage": "Vektor-Tabellen konnten nicht geladen werden. Bitte Seite aktualisieren."
        }
      }
    },
    "storageTab": {
      "unknown": "Unbekannt",
      "addButton": "Speicher hinzufügen",
      "addModalTitle": "Speicher zum Projekt hinzufügen",
      "emptyMessage": "Keine Speicherordner für dieses Projekt konfiguriert",
      "errorBoundaryMessage": "Speicherordner konnten nicht geladen werden. Bitte Seite aktualisieren.",
      "membershipToggleLabel": "Genehmigten Speicher anzeigen",
      "removeDialogTitle": "Speicherordner entfernen",
      "removeDialogTitlePlural": "Speicherordner entfernen",
      "removeDialogMessage": "\"{{name}}\" aus diesem Projekt entfernen?",
      "bulkRemoveDialogMessage": "Möchten Sie die {{count}} ausgewählten Speicherordner wirklich aus diesem Projekt entfernen?",
      "columns": {
        "folder": "Ordner",
        "connector": "Connector",
        "files": "Dateien",
        "size": "Größe",
        "status": "Status",
        "creator": "Ersteller",
        "actions": "Aktionen"
      },
      "status": {
        "active": "Aktiv",
        "error": "Fehler",
        "pending": "Ausstehend"
      },
      "actions": {
        "previewFiles": "Dateien anzeigen",
        "sync": "Synchronisieren",
        "syncing": "Synchronisiere...",
        "removeFromProject": "Aus Projekt entfernen",
        "remove": "Entfernen"
      },
      "toasts": {
        "requestedAccess": "Zugriff für {{count}} Speicherordner{{plural}} angefordert (ausstehende Genehmigung)",
        "alreadyInProject": "{{count}} Speicherordner{{plural}} bereits im Projekt",
        "addFailed": "Hinzufügen von {{count}} Speicherordner{{plural}} fehlgeschlagen",
        "synced": "Metadaten von „{{name}}“ synchronisiert.",
        "removed": "Speicherordner aus Projekt entfernt",
        "bulkRemoved": "{{count}} Speicherordner{{plural}} erfolgreich aus Projekt entfernt",
        "bulkRemoveFailed": "Entfernen von {{count}} Speicherordner{{plural}} fehlgeschlagen"
      }
    },
    "registryTab": {
      "columnAgent": "Agent",
      "columnFramework": "Framework",
      "columnStatus": "Status",
      "columnEnv": "UMGEBUNG",
      "columnOrchestrator": "Orchestrator",
      "columnRegisteredBy": "Registriert von",
      "columnRegisteredAt": "Registriert am",
      "columnActions": "Aktionen",
      "columnWorkflow": "Workflow",
      "actionOpenCanvas": "Canvas öffnen",
      "actionRuns": "Ausführungen",
      "registryViewsAriaLabel": "Registrieransichten",
      "agentRegistryTitle": "Agenten-Registrierung",
      "agentsLabel": "Agenten",
      "workflowRegistryTitle": "Workflow-Registrierung",
      "workflowsLabel": "Workflows",
      "registryStatusTitle": "Registrierungsstatus",
      "activeItemsTitle": "Aktive Registrierungselemente",
      "archivedItemsTitle": "Archivierte Registrierungselemente",
      "openInRegistryTitle": "Im Register öffnen",
      "emptyActiveAgents": "Keine registrierten Agenten in diesem Projekt.",
      "emptyArchivedAgents": "Keine archivierten registrierten Agenten in diesem Projekt.",
      "emptyActiveWorkflows": "Keine registrierten Workflows in diesem Projekt.",
      "emptyArchivedWorkflows": "Keine archivierten registrierten Workflows in diesem Projekt.",
      "goToRegistry": "Zur Agenten-Registrierung",
      "searchRegistryPlaceholder": "Registrierung durchsuchen…",
      "searchWorkflowsPlaceholder": "Workflows durchsuchen…"
    },
    "promptsTab": {
      "columnName": "Prompt-Name",
      "columnCategory": "Kategorie",
      "columnDescription": "Beschreibung",
      "columnCreated": "Erstellt",
      "columnLastUpdated": "Zuletzt aktualisiert",
      "columnActions": "Aktionen",
      "noDescription": "Keine Beschreibung",
      "viewVersionsTitle": "Prompt-Versionen anzeigen",
      "errorBoundaryMessage": "Prompts konnten nicht geladen werden. Bitte aktualisieren Sie die Seite.",
      "emptyMessage": "Keine Prompts in diesem Projekt. Prompts werden über die Prompts-Seite verwaltet.",
      "dialogCloseAriaLabel": "Dialog schließen",
      "categoryLabel": "Kategorie:",
      "versionsHeading": "VERSIONEN ({{count}})",
      "loadingVersions": "Versionen werden geladen...",
      "noVersionsFound": "Keine Versionen gefunden",
      "versionLabel": "Version {{version}}",
      "latestBadge": "NEUESTE",
      "selectVersionPrompt": "Wählen Sie eine Version aus, um den Inhalt anzuzeigen"
    },
    "deploymentsTab": {
      "columnAgent": "Agent",
      "columnEnv": "Umgebung",
      "columnStatus": "Status",
      "columnDeployedBy": "Bereitgestellt von",
      "columnDeployedAt": "Bereitgestellt am",
      "columnActions": "Aktionen",
      "columnWorkflow": "Workflow",
      "actionOpen": "Öffnen",
      "actionChat": "Chat",
      "actionRuntimeSettings": "Laufzeiteinstellungen",
      "actionOpenInMonitoring": "In Überwachung öffnen",
      "actionManageArchive": "Archiv in Überwachung verwalten",
      "actionGuardrails": "Guardrails",
      "deploymentViewsAriaLabel": "Bereitstellungsansichten",
      "agentDeploymentsTitle": "Agenten-Bereitstellungen",
      "agentsLabel": "Agenten",
      "workflowDeploymentsTitle": "Workflow-Bereitstellungen",
      "workflowsLabel": "Workflows",
      "deploymentStatusTitle": "Bereitstellungsstatus",
      "activeDeploymentsTitle": "Aktive Bereitstellungen",
      "archivedDeploymentsTitle": "Archivierte Bereitstellungen",
      "openInMonitoringTitle": "In Überwachung öffnen",
      "emptyActiveAgents": "Keine aktiven Agenten-Bereitstellungen für dieses Projekt.",
      "emptyArchivedAgents": "Keine archivierten Agenten-Bereitstellungen für dieses Projekt.",
      "emptyActiveWorkflows": "Keine aktiven Workflow-Bereitstellungen für dieses Projekt.",
      "emptyArchivedWorkflows": "Keine archivierten Workflow-Bereitstellungen für dieses Projekt.",
      "goToMonitoring": "Zur Überwachung",
      "searchDeploymentsPlaceholder": "Bereitstellungen durchsuchen…",
      "searchWorkflowDeploymentsPlaceholder": "Workflow-Bereitstellungen durchsuchen…"
    },
    "evalsTab": {
      "columnAgent": "Agent",
      "columnLatestSession": "Letzte Sitzung",
      "columnActions": "Aktionen",
      "actionOpenEvals": "Bewertungen öffnen",
      "actionManageInEvals": "In Bewertungen verwalten",
      "portfolioSubtitle": "Bewertungsportfolio für dieses Projekt",
      "openInEvalsTitle": "In Bewertungen öffnen",
      "emptyMessage": "Keine Bewertungsdaten für dieses Projekt.",
      "goToEvals": "Zu Bewertungen & Simulationen",
      "searchAgentsPlaceholder": "Agenten durchsuchen…"
    }
  },
  "prompts": {
    "exportFileName": "Prompts",
    "searchPlaceholder": "Prompts suchen...",
    "columns": {
      "name": "Prompt-Name",
      "description": "Beschreibung",
      "category": "Kategorie",
      "model": "Modell",
      "project": "Projekt",
      "visibility": "Sichtbarkeit",
      "createdBy": "Erstellt von",
      "updatedAt": "Aktualisiert am",
      "actions": "Aktionen"
    },
    "filters": {
      "title": "Filter",
      "visibility": "Sichtbarkeit",
      "category": "Kategorie",
      "project": "Projekt",
      "creator": "Ersteller",
      "all": "Alle",
      "favorites": "Favoriten"
    },
    "visibility": {
      "project": "Projekt",
      "public": "Plattform"
    },
    "list": {
      "uncategorized": "Nicht kategorisiert",
      "allModels": "Alle Modelle",
      "platformBadge": "Plattform",
      "platformBadgeTooltip": "Code-basierter Systemprompt — schreibgeschützt",
      "versionCount": "{{count}} Version",
      "versionCount_other": "{{count}} Versionen",
      "unknownProject": "Unbekannt",
      "emptyState": {
        "permissionDenied": "Du hast keine Berechtigung, Prompts anzuzeigen. Wende dich für den Zugriff an deinen Administrator.",
        "noResultsSearch": "Keine Prompts gefunden, die deiner Suche entsprechen.",
        "default": "Keine Prompts gefunden. Erstelle deinen ersten Prompt, um loszulegen."
      }
    },
    "actions": {
      "view": "Ansehen",
      "chat": "Chat",
      "exportYaml": "Als YAML exportieren",
      "optimize": "Optimieren",
      "cloneForModel": "Für Modell klonen",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "exportSelected": "Auswahl exportieren",
      "deleteSelected": "Auswahl löschen",
      "createPrompt": "Prompt erstellen",
      "newPrompt": "Neuer Prompt",
      "creating": "Wird erstellt..."
    },
    "quota": {
      "loading": "Kontingent wird geladen...",
      "label": "Prompts"
    },
    "toast": {
      "projectFilterReset": "Das zuvor ausgewählte Projekt existiert nicht mehr. Der Filter wurde zurückgesetzt.",
      "draftInserted": "Prompt-Entwurf eingefügt. Bei Bedarf bearbeiten und erstellen — nach dem Speichern kann die Optimierung im Prompt-Editor ausgeführt werden.",
      "clonedForModel": "Prompt für Modell \"{{model}}\" geklont",
      "bulkDeletePartial": "{{deleted}} Prompt(s) gelöscht, {{skipped}} fehlgeschlagen: {{errors}}",
      "bulkDeleteSuccess": "{{count}} Prompt(s) erfolgreich gelöscht",
      "platformDeleteBlocked": "Plattform-Prompts können nicht gelöscht werden"
    },
    "form": {
      "modelAgnostic": "Modellunabhängig (alle Modelle)",
      "selectProjectFirst": "Bitte zuerst ein Projekt auswählen.",
      "selectProjectModel": "Bitte ein diesem Projekt zugewiesenes LLM-Modell auswählen.",
      "selectModel": "Bitte ein LLM-Modell auswählen.",
      "minBusinessContext": "Mindestens 10 Zeichen Geschäftskontext eingeben.",
      "selectProjectAndModelFirst": "Zuerst Projekt und Modell auswählen",
      "selectModelFirst": "Zuerst Modell auswählen",
      "minCharsRequired": "Mindestens 10 Zeichen erforderlich",
      "selectProjectFirstPlaceholder": "Zuerst ein Projekt auswählen",
      "loadingModels": "Modelle werden geladen…",
      "noLlmForProject": "Diesem Projekt ist kein LLM zugewiesen",
      "noLlmAvailable": "Kein LLM verfügbar",
      "nameAlreadyExists": "Ein Prompt mit diesem Namen existiert bereits",
      "promptNameLabel": "Prompt-Name *",
      "promptNamePlaceholder": "z. B. Kundensupport-Assistent",
      "categoryLabel": "Kategorie",
      "categoryPlaceholder": "z. B. Support, Vertrieb",
      "targetModelLabel": "Zielmodell",
      "targetModelRequiredLabel": "Zielmodell *",
      "selectModelPlaceholder": "Modell auswählen...",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": "Kurzbeschreibung dieses Prompts",
      "charCount": "{{count}}/{{max}} Zeichen",
      "modelLabel": "Modell",
      "selectAiModelPlaceholder": "KI-Modell auswählen",
      "generating": "Wird generiert…",
      "generate": "Generieren",
      "businessContextPlaceholder": "Zielgruppe, Tonfall, Aufgaben, Einschränkungen — das Modell entwirft daraus deinen Prompt. Mindestens 10 Zeichen zum Generieren.",
      "aiGenerateHint": "Nach der Generierung wechselst du in den manuellen Modus, um den Prompt zu überprüfen und zu bearbeiten, bevor du ihn erstellst.",
      "contentPlaceholderPrefix": "Du bist ein hilfreicher Assistent, der...\n\nSchreibe hier deinen Systemprompt. Verwende ",
      "contentPlaceholderSuffix": ", um zur Laufzeit aufgelöste Statusvariablen zu referenzieren.",
      "variableNamePlaceholder": "variablenname",
      "addVariable": "Variable hinzufügen",
      "nameLabel": "Name *",
      "fixValidationErrors": "Bitte Validierungsfehler vor dem Speichern beheben",
      "saving": "Wird gespeichert...",
      "saveChanges": "Änderungen speichern",
      "quotaExceeded": "Prompt-Kontingent überschritten",
      "fillRequiredFields": "Bitte alle Pflichtfelder ausfüllen",
      "cloning": "Wird geklont..."
    },
    "modal": {
      "detailsHeader": "Details",
      "describePromptHeader": "Beschreibe, was der Prompt tun soll",
      "promptDetailsHeader": "Prompt-Details",
      "createTitle": "Neuen Prompt erstellen",
      "creationModeAriaLabel": "Prompt-Erstellungsmodus",
      "modeManual": "Manuell",
      "modeAi": "KI",
      "editorSectionsAriaLabel": "Prompt-Editor-Bereiche",
      "tabPrompt": "Prompt",
      "tabState": "Status",
      "editorHintPrefix": "Verwende",
      "editorHintSuffix": "für Statusvariablen",
      "aiGeneratedNote": "KI-generiert — bei Bedarf bearbeiten. Nutze die Optimierung zur weiteren Feinabstimmung.",
      "loadingEditor": "Prompt-Editor wird geladen...",
      "stateVariablesHintPrefix": "Definiere Statusvariablen zur Verwendung mit",
      "stateVariablesHintSuffix": "in deinem Prompt. Jede im Prompt referenzierte Variable muss hier aufgeführt sein.",
      "noStateVariables": "Noch keine Statusvariablen definiert.",
      "stateVariableNameAriaLabel": "Name der Statusvariable {{name}}",
      "removeStateVariableAriaLabel": "Statusvariable {{name}} entfernen",
      "newVariableFallback": "neu",
      "editTitle": "Prompt-Metadaten bearbeiten",
      "deleteTitle": "Prompt löschen",
      "deleteMessage": "Möchtest du \"{{name}}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "bulkDeleteTitle": "Ausgewählte Prompts löschen",
      "bulkDeleteMessage": "Möchtest du {{count}} Prompt wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "bulkDeleteMessage_other": "Möchtest du {{count}} Prompts wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "bulkDeleteConfirm": "{{count}} Prompt löschen",
      "bulkDeleteConfirm_other": "{{count}} Prompts löschen",
      "cloneTitle": "Für Modell klonen",
      "cloneMessage": "„{{name}}“ mit allen Versionen für ein anderes Modell klonen.",
      "cloneSubmit": "Prompt klonen"
    },
    "optimizeModal": {
      "header": {
        "title": "Prompt optimieren",
        "subtitlePlaceholder": "Prompt auswählen"
      },
      "stepper": {
        "configure": "Konfigurieren",
        "running": "Läuft",
        "result": "Ergebnis"
      },
      "framework": {
        "sectionTitle": "Framework auswählen",
        "bestFor": "Am besten für: {{value}}",
        "catalog": {
          "dspy": {
            "label": "DSPy",
            "tier": "Stufe 1",
            "desc": "Deklarative Optimierung (MIPROv2, COPRO oder Bootstrap-Few-Shot). Am besten mit gelabelten Beispielen.",
            "tooltip": "Kompiliert ein deklaratives Programm in optimierte Prompts. Wählen Sie unten einen Compiler-Typ (Standard MIPROv2).",
            "bestFor": "Klassifikation, Q&A, Extraktionsaufgaben"
          },
          "cot": {
            "label": "Chain-of-Thought",
            "tier": "Stufe 2",
            "desc": "Optimierung des Schlussfolgerns: Schritt für Schritt, Spurqualität, Schrittzerlegung.",
            "tooltip": "Testet mehrere CoT-Strategien (z. B. „Denke Schritt für Schritt“), optimiert die Qualität der Denkspur und die Schrittzerlegung. Verwenden Sie den Prompt-Typ „Chain-of-Thought“ für alle Strategien.",
            "bestFor": "Schlussfolgern, Mathematik, mehrstufige Aufgaben"
          },
          "opro": {
            "label": "OPRO",
            "tier": "Stufe 2",
            "desc": "LLM als Optimierer. Liefert (Prompt, Score)-Verlauf und bittet um Verbesserung.",
            "tooltip": "Nutzt das LLM selbst als Optimierer — schlägt iterativ bessere Prompts vor, indem es Score-Verläufe analysiert. Einfach einzusetzen, keine Gradientenberechnung.",
            "bestFor": "Schnelle Iteration bei jeder Aufgabe"
          },
          "reflexion": {
            "label": "Reflexion",
            "tier": "Stufe 2",
            "desc": "Selbstreflektierendes verbales RL. Erzeugt Kritik-→-Umschreib-Schleife.",
            "tooltip": "Erzeugt nach jedem Versuch eine Selbstkritik und schreibt den Prompt dann um, um erkannte Fehler zu beheben. Kombiniert Reflexion mit episodischem Gedächtnis für dauerhafte Verbesserung.",
            "bestFor": "Komplexes Schlussfolgern, mehrstufige Aufgaben"
          },
          "gepa": {
            "label": "GEPA",
            "tier": "Stufe 3",
            "desc": "Upstream-Genetic-Pareto-Engine mit Pareto-Auswahl pro Beispiel und Kandidatenverschmelzung.",
            "tooltip": "Führt die Referenz-GEPA-Engine aus. Hält eine Pareto-Front pro Validierungsbeispiel statt eines einzelnen Gesamtscores, sodass Prompts, die nur bei einer Teilmenge helfen, weiterhin kombiniert werden können.",
            "bestFor": "Mehrknotige Agentengraphen, stagnierende Läufe"
          },
          "gepa_legacy": {
            "label": "GEPA (Legacy)",
            "tier": "Stufe 3",
            "desc": "Hauseigene reflektierende evolutionäre Methode mit LLM-gestützter Fehlerdiagnose.",
            "tooltip": "Die vorherige integrierte GEPA-Annäherung. Als Fallback beibehalten, wenn das Upstream-Paket nicht verfügbar ist, sowie für A/B-Vergleiche.",
            "bestFor": "Offline-Installationen ohne das gepa-Paket"
          },
          "optimize_anything": {
            "label": "optimize_anything",
            "tier": "Stufe 3",
            "desc": "Upstream-GEPA-Launcher für Nicht-Prompt-Artefakte (Agentengraph, Node-Konfiguration).",
            "tooltip": "Optimiert Graph-JSON oder Node-Konfigurationsparameter über dieselbe Genetic-Pareto-Engine. Ungültige Kandidaten erhalten Score 0 mit dem Validierungsfehler als Feedback. Persistenz erfordert einen expliziten Anwendungsschritt.",
            "bestFor": "Topologie- und Konfigurationssuche über Prompts hinaus"
          },
          "evoprompt": {
            "label": "EvoPrompt",
            "tier": "Stufe 3",
            "desc": "Populationsbasierte Evolution mit Crossover- und Mutationsoperatoren.",
            "tooltip": "Verwaltet eine Population von Prompt-Kandidaten und wendet von genetischen Algorithmen inspirierte Crossover-/Mutationsoperatoren an. Ideal zur Erkundung vielfältiger Prompt-Formulierungen.",
            "bestFor": "Vielfältige Prompt-Erkundung"
          },
          "ape": {
            "label": "APE",
            "tier": "Stufe 3",
            "desc": "Automatic Prompt Engineer. Erzeugen → Bewerten → Resampling.",
            "tooltip": "Erzeugt viele Kandidatenanweisungen aus I/O-Demonstrationen, bewertet sie und resampelt um die besten herum. Schnell und effektiv zur Entdeckung von Anweisungen.",
            "bestFor": "Anweisungsentdeckung anhand von Beispielen"
          },
          "textgrad": {
            "label": "TextGrad",
            "tier": "Stufe 4",
            "desc": "Textuelle Backpropagation. Berechnet Textgradienten für gezielte Korrekturen.",
            "tooltip": "Propagiert textuelle „Gradienten“ — natürlichsprachliches Feedback — rückwärts durch den Prompt, um genau zu erkennen, welche Teile bearbeitet werden müssen. Präzise, chirurgische Verfeinerung.",
            "bestFor": "Präzise Bearbeitung langer Prompts"
          },
          "rl_tuning": {
            "label": "RL-PPO",
            "tier": "Stufe 5",
            "desc": "PPO-artige Policy-Optimierung mit eigenen Belohnungsfunktionen.",
            "tooltip": "Behandelt die Prompt-Auswahl als Policy und optimiert sie mittels Proximal Policy Optimization. Definieren Sie Ihre eigene Belohnungsfunktion für volle Kontrolle über das Optimierungsziel.",
            "bestFor": "Individuelle Belohnungsziele"
          },
          "rag_aware": {
            "label": "RAG-Aware",
            "tier": "Stufe 6",
            "desc": "Gemeinsame Optimierung von Prompt- und Retrieval-Pipeline.",
            "tooltip": "Optimiert Prompt und Retrieval-Konfiguration gemeinsam. Passt Abfrageformatierung, Kontextplatzierung und Anweisungsformulierung für RAG-lastige Workflows an.",
            "bestFor": "Retrieval-Augmented Generation"
          },
          "multi_obj": {
            "label": "Multi-Objective",
            "tier": "Übergreifend",
            "desc": "Pareto-Front-Optimierung über Genauigkeit, Latenz und Kosten.",
            "tooltip": "Erkundet die Pareto-Front über mehrere konkurrierende Ziele (Genauigkeit, Latenz, Token-Kosten). Liefert eine Menge trade-off-optimaler Prompts statt eines einzelnen Gewinners.",
            "bestFor": "Ausgleich von Genauigkeit und Kosten"
          },
          "ensemble": {
            "label": "Ensemble",
            "tier": "Übergreifend",
            "desc": "Mehrere Optimierer parallel ausführen und Ergebnisse fusionieren (Turnier, Merge oder Voting).",
            "tooltip": "Führt 2+ komplementäre Frameworks gleichzeitig aus (z. B. Reflexion + OPRO + TextGrad) und kombiniert deren beste Kandidaten. Höhere Kosten als ein einzelnes Framework; am besten, wenn Sie eine robuste, vielseitige Prompt-Verbesserung wünschen.",
            "bestFor": "Maximale Abdeckung und Robustheit"
          }
        }
      },
      "promptVersion": {
        "sectionTitle": "Prompt & Version",
        "projectLabel": "Projekt",
        "promptLabel": "Prompt",
        "promptPlaceholder": "Prompt auswählen...",
        "promptSearchPlaceholder": "Nach Name suchen...",
        "promptRequiredError": "Die Auswahl eines Prompts ist erforderlich.",
        "versionLabel": "Version",
        "versionPlaceholder": "Version auswählen...",
        "versionRequiredError": "Die Auswahl einer Prompt-Version ist erforderlich.",
        "versionCurrentSuffix": " (aktuell)",
        "compilerTypeLabel": "Compiler-Typ",
        "compilerTypeTitle": "Welcher DSPy-Teleprompter läuft (MIPROv2 ist der Standard-Multiplex-Optimierer).",
        "compilerOptions": {
          "miprov2": "MIPROv2",
          "copro": "COPRO",
          "bootstrapFewShot": "Bootstrap Few-Shot"
        },
        "promptTypeLabel": "Prompt-Typ",
        "promptTypeTitle": "Chain-of-Thought-Optimierungsstrategien.",
        "promptTypeOptions": {
          "standard": "Standard",
          "cot": "Chain-of-Thought",
          "fewShot": "Few-Shot",
          "structuredOutput": "Strukturierte Ausgabe (JSON/XML)"
        },
        "allProjectsLabel": "Alle Projekte"
      },
      "model": {
        "sectionTitle": "Modellkonfiguration",
        "responseModelLabel": "Antwortmodell",
        "responseModelPlaceholder": "LLM-Modell auswählen...",
        "responseModelRequiredError": "Ein Antwortmodell ist erforderlich (oder aktivieren Sie Multi-Modell mit 2+ Zielen).",
        "judgeModelLabel": "Bewertungsmodell",
        "judgeModelPlaceholder": "Bewertungsmodell auswählen",
        "gepaMutationModelLabel": "GEPA-Mutationsmodell",
        "gepaMutationModelTitle": "LLM für GEPA-Reflexion und -Mutation (LiteLLM-Modell-ID oder Plattform-Modell-UUID).",
        "gepaMutationModelPlaceholder": "Mutationsmodell auswählen",
        "gepaMutationModelHint": "Reflexion und Mutantenerzeugung; die Bewertung nutzt weiterhin Ihre Bewertungs-/Antwortmodelle oben.",
        "multiModelLabel": "Über mehrere Modelle hinweg optimieren",
        "multiModelHint": "Prompt an 2+ Modellen bewerten und aggregieren (modellagnostischer Prompt)",
        "targetModelsLabel": "Zielmodelle (2+ auswählen)",
        "selectAtLeast2Hint": "Wählen Sie mindestens 2 Modelle aus.",
        "modelsSelectedCount": "{{count}} Modelle ausgewählt.",
        "aggregationStrategyLabel": "Aggregationsstrategie",
        "aggregationOptions": {
          "mean": "Mittelwert — Durchschnitt über alle Modelle",
          "min": "Minimum — Worst-Case (kein Modell wird zurückgelassen)",
          "pareto": "Pareto — Ausgleich zwischen Minimum und Mittelwert"
        },
        "aggregationHint": "Minimum = für das schwächste Modell optimieren; Mittelwert = Durchschnitt; Pareto = Ausgleich.",
        "noModelsHint": "Diesem Projekt sind keine LLM-Modelle zugeordnet. Fügen Sie Modelle unter Projekt → Modelle hinzu, sonst greift die Optimierung möglicherweise auf Backend-Standardwerte zurück.",
        "selectPromptHint": "Wählen Sie einen Prompt aus, um Antwort- und Bewertungsmodelle aus dessen Projekt zu laden."
      },
      "ensemble": {
        "sectionTitle": "Ensemble-Konfiguration",
        "subFrameworksLabel": "Sub-Frameworks (2+ auswählen)",
        "subFrameworksHint": "Jeder ausgewählte Optimierer läuft parallel; die Ergebnisse werden mit der unten stehenden Strategie fusioniert.",
        "fusionLabel": "Fusionsstrategie",
        "fusionOptions": {
          "tournament": "Turnier — Kandidaten am gesamten Datensatz bewerten, Besten wählen",
          "merge": "Merge — LLM synthetisiert Top-Kandidaten zu einem Prompt",
          "voting": "Voting — Kandidaten am Testset bewerten, gewichtete Kombination"
        },
        "minTwoToast": "Wählen Sie mindestens zwei Sub-Frameworks für das Ensemble aus"
      },
      "metrics": {
        "sectionTitle": "Bewertungsmetrik",
        "autoDiscoverLabel": "Metriken automatisch aus Datensatz und Prompt erkennen (empfiehlt Treue, Relevanz usw., wenn Kontext vorhanden ist)",
        "selectPromptHint": "Wählen Sie einen Prompt aus, um den Metrikkatalog für dessen Projekt zu laden.",
        "weightsTitle": "Metrikgewichte (optional — kombinierter Score)",
        "weightsHint": "Leer lassen für gleiche Gewichtung. Gewichte werden auf Summe 1 normiert.",
        "weightPlaceholder": "gleich",
        "noMetricsWarning": "Keine Metriken ausgewählt — es wird standardmäßig „Answer Correctness“ verwendet.",
        "embeddingLabel": "Embedding-Modell (für ausgewählte Metriken erforderlich)",
        "embeddingPlaceholder": "Embedding-Modell auswählen…",
        "embeddingNoModelsHint": "Keine aktiven Embedding-Modelle in diesem Projekt. Registrieren Sie eines unter Projekt → Modelle.",
        "sqlLabel": "Ausführungsdatenbank (für Text2SQL EX/VES erforderlich)",
        "sqlPlaceholder": "Datenbank-Connector auswählen…",
        "sqlNoConnectorsHint": "Keine Datenbank-Connectoren registriert. Fügen Sie einen unter Knowledge → Connectors hinzu.",
        "schemaLabel": "Schemadefinition (JSON, für Schema-Konformität erforderlich)",
        "schemaPlaceholder": "{\"tables\": [{\"name\": \"orders\", \"columns\": [\"id\", \"amount\"]}]}"
      },
      "dataset": {
        "sectionTitle": "Benchmark-Datensatz",
        "optionalGepaSuffix": "(optional für GEPA)",
        "selectPromptHint": "Wählen Sie einen Prompt aus, um die mit dem Projekt-Wissen verknüpften Benchmark-Datensätze aufzulisten.",
        "datasetPlaceholder": "Registrierte Tabelle auswählen...",
        "datasetSearchPlaceholder": "Datensätze nach Name oder Tabelle suchen...",
        "datasetRowsSuffix": "({{count}} Zeilen)",
        "datasetRequiredError": "Die Auswahl eines Benchmark-Datensatzes ist erforderlich.",
        "noDatasetsHint": "Diesem Projekt sind keine Wissenstabellen zugeordnet. Ordnen Sie Tabellen unter Projekt → Wissen zu.",
        "inputColumnLabel": "Eingabespalte",
        "columnPlaceholder": "Spalte auswählen...",
        "expectedOutputColumnLabel": "Erwartete-Ausgabe-Spalte",
        "expectedOutputRequiredError": "Die Spalte „Erwartete Ausgabe“ ist für DSPy erforderlich.",
        "contextColumnsLabel": "Kontextspalten (optional)",
        "selectDatasetFirst": "Wählen Sie zuerst einen Datensatz aus",
        "contextColumnsHint": "Mehrere Spalten werden für den Bewertungskontext zusammengeführt (RAGAS / DeepEval).",
        "samplingStrategyLabel": "Sampling-Strategie",
        "samplingOptions": {
          "random": "Zufällig",
          "stratified": "Stratifiziert (nach erwarteter Ausgabe)",
          "difficultyWeighted": "Schwierigkeitsgewichtet (Fokus auf schwierige Beispiele)",
          "progressive": "Progressiv (Teilmenge erweitert sich mit fortschreitender Optimierung)"
        },
        "samplingHint": "Stratifiziert und schwierigkeitsgewichtet können das Signal aus weniger Zeilen verbessern."
      },
      "dspyContext": {
        "title": "DSPy-Kontextintegration",
        "modeLabel": "Kontextübergabemodus",
        "modeOptions": {
          "auto": "Auto — Kontext bei Erkennung als DSPy-Eingabe injizieren",
          "injectField": "Feld injizieren — Kontext immer als DSPy-Eingabe hinzufügen",
          "ragModule": "RAG-Modul — Retrieval aus Kontextkorpus vor der Vorhersage"
        },
        "modeHints": {
          "auto": "Injiziert Kontext aus dem Datensatz automatisch in die DSPy-Signatur, auch wenn die Prompt-Vorlage nicht darauf verweist.",
          "injectField": "Erzwingt die Kontextinjektion als DSPy-Eingabefeld. DSPy lernt, den Kontext während der Kompilierung zu nutzen.",
          "ragModule": "Erstellt ein zusammengesetztes Retrieve-+-Predict-DSPy-Modul. MIPROv2 kann Retrieval und Vorhersage gemeinsam optimieren."
        },
        "demoStrategyLabel": "Demo-Auswahlstrategie",
        "demoOptions": {
          "default": "Standard — DSPy-Compiler entscheiden lassen",
          "diverseContext": "Vielfältiger Kontext — Kontextvielfalt über Demos maximieren",
          "maxCoverage": "Maximale Abdeckung — breitestes Spektrum an Kontextthemen abdecken"
        },
        "demoHint": "Vielfältiger Kontext und maximale Abdeckung wählen Demonstrationen mit reichhaltigerer Kontextvielfalt für bessere Few-Shot-Qualität aus.",
        "topKLabel": "Retrieval Top-K",
        "topKHint": "Anzahl der pro Abfrage aus dem Golden-Datensatz abgerufenen Kontextpassagen.",
        "truncateLabel": "Lange Kontexte kürzen",
        "truncateHint": "Kontextpassagen auf Token-Budgets begrenzen",
        "maxTokensLabel": "Maximale Kontext-Tokens",
        "maxTokensHint": "Ungefähre wortbasierte Kürzung pro Passage."
      },
      "advanced": {
        "sectionTitle": "Erweiterte Optionen",
        "warmStartLabel": "Meta-Learning-Warmstart",
        "warmStartHint": "Aus ähnlichen früheren Läufen initialisieren",
        "adversarialLabel": "Adversarial-Robustheitstest",
        "adversarialHint": "Auf gestörten Eingaben testen; mit sauberem Score kombinieren",
        "adversarialWeightLabel": "Adversarial-Gewicht (0–1)",
        "adversarialWeightHint": "robust_score = (1 − α)×sauber + α×adversarial; höheres α gewichtet Adversarial stärker.",
        "requireApprovalLabel": "Freigabe vor dem Speichern erforderlich",
        "requireApprovalHint": "Optimierten Prompt prüfen, bevor er zu einer neuen Version wird",
        "driftGuardLabel": "Semantischer Drift-Schutz",
        "driftGuardHint": "Kandidaten ablehnen, die zu weit von der ursprünglichen Absicht abweichen",
        "maxDriftLabel": "Maximaler Drift (0–1)",
        "maxDriftHint": "Kandidaten mit Drift > diesem Wert werden abgelehnt. Niedriger = strenger (z. B. 0,3).",
        "driftMethodLabel": "Drift-Methode",
        "driftMethodOptions": {
          "jaccard": "Jaccard (tokenbasiert)",
          "vector": "Vektor (Embedding-Kosinus)"
        },
        "driftMethodHint": "Vektor-Drift nutzt das untenstehende Embedding-Modell; Jaccard ist rein lexikalisch.",
        "embeddingModelLabel": "Embedding-Modell",
        "embeddingLoading": "Modelle werden geladen…",
        "embeddingNoModelsHint": "Keine aktiven Embedding-Modelle in diesem Projekt. Nutzen Sie Jaccard-Drift oder registrieren Sie Modelle unter Foundation Models.",
        "embeddingPlaceholder": "Embedding-Modell auswählen",
        "embeddingRequiredHint": "Erforderlich, wenn die Drift-Methode Vektor ist (gespeichert als drift_embedding_model_id).",
        "guardrailsLabel": "Inhaltssicherheits-Guardrails",
        "guardrailsHint": "Kandidaten ablehnen, die Toxizitäts-, PII-, Prompt-Injection- oder Markensicherheitsprüfungen nicht bestehen",
        "guardrailBackendLabel": "Guardrail-Backend",
        "guardrailBackendOptions": {
          "builtin": "Integriert (musterbasiert)",
          "azureContentSafety": "Azure Content Safety",
          "awsBedrock": "AWS Bedrock Guardrails",
          "custom": "Benutzerdefiniert (HTTP-Endpunkt)"
        },
        "guardrailBackendHint": "Integriert führt PII-, Toxizitäts-, Jailbreak- und optionale Markensicherheitsprüfungen ohne externe APIs durch.",
        "checksLabel": "Auszuführende Prüfungen",
        "checksHint": "Kandidaten, die eine ausgewählte Prüfung nicht bestehen, werden vor der Bewertung abgelehnt.",
        "checkLabels": {
          "piiCheck": "PII",
          "toxicity": "Toxizität",
          "promptInjection": "Prompt-Injection",
          "jailbreak": "Jailbreak",
          "brandSafety": "Markensicherheit",
          "lengthCheck": "Längenprüfung"
        }
      },
      "parameters": {
        "sectionTitle": "Parameter",
        "maxIterationsLabel": "Maximale Iterationen",
        "maxIterationsEnsembleLabel": "Maximale Iterationen (pro Sub-Framework)",
        "maxIterationsHint": "Höher = mehr Verfeinerung, längere Laufzeit",
        "maxIterationsEnsembleHint": "Jeder parallele Optimierer läuft bis zu dieser Anzahl Iterationen (Ensemble nutzt sub_max_iterations).",
        "timeBudgetLabel": "Zeitbudget (Sekunden)",
        "timeBudgetHint": "Feste Obergrenze für die Laufzeit (60–14.400 s). Der Lauf stoppt, wenn das Budget erreicht ist.",
        "maxCostLabel": "Maximale Kosten (USD, optional)",
        "maxCostPlaceholder": "Kein Limit",
        "maxCostHint": "Geschätzte Ausgabenobergrenze; Sitzung wird bei Überschreitung abgebrochen. Leer lassen für keine Obergrenze.",
        "targetScoreLabel": "Zielscore (optional)",
        "targetScorePlaceholder": "Keiner",
        "targetScoreHint": "Frühzeitig stoppen, wenn der kombinierte Score diesen Wert erreicht (0–1). Leer lassen, um bis zu den Iterationen oder anderen Limits zu laufen.",
        "candidateCountHint": "Anzahl der pro Iteration erzeugten oder bewerteten Kandidaten-Prompts für diesen Optimierer.",
        "evalMaxRowsLabel": "Maximale Zeilen für Evaluierungsdatensatz",
        "evalMaxRowsHint": "Pro Bewertung aus dem Benchmark abgerufene Zeilen (Baseline nutzt die volle Obergrenze; innere Schleifen ggf. weniger).",
        "rowsPerIterationLabel": "Zeilen pro Kandidatenbewertung (optional)",
        "rowsPerIterationPlaceholder": "Automatisch",
        "rowsPerIterationHint": "Begrenzt die Zeilen bei der Bewertung jedes vorgeschlagenen Prompts; leer lassen für automatisch (etwa die Hälfte der Maximalzeilen, min. 5).",
        "earlyStoppingLabel": "Frühzeitiges Stoppen",
        "patienceHint": "Geduld (Runden ohne Verbesserung)",
        "candidateLabels": {
          "gepa": "Mutanten pro Iteration",
          "ape": "Kandidaten pro Runde",
          "opro": "Vorschläge pro Iteration",
          "evoprompt": "Populationsgröße",
          "rl_tuning": "Rollouts pro Iteration"
        }
      },
      "reward": {
        "sectionTitle": "Belohnungsfunktion (Python)",
        "description": "Definieren Sie Ihre eigene Belohnungsfunktion. Sie erhält jede Bewertungszeile und liefert ein Belohnungssignal im Bereich [-1, 1]. Die Policy maximiert diese Belohnung."
      },
      "estimate": {
        "title": "Geschätzte Ressourcen",
        "summary": "~{{calls}} LLM-Aufrufe · ca. ${{low}}–${{high}} USD",
        "monthlyUsed": "Monatlich verbraucht: ${{used}} / ${{limit}}",
        "acknowledge": "Ich bestätige die geschätzten Kosten (bis zu ${{cost}} USD) und möchte diesen Lauf starten"
      },
      "start": {
        "button": "{{framework}}-Optimierung starten",
        "confirmButton": "Bestätigen und starten",
        "changeParams": "Parameter ändern"
      },
      "toast": {
        "selectPrompt": "Bitte wählen Sie einen Prompt aus",
        "selectVersion": "Bitte wählen Sie eine Prompt-Version aus",
        "selectDataset": "Bitte wählen Sie einen Benchmark-Datensatz aus",
        "selectResponseModel": "Bitte wählen Sie ein Antwortmodell aus oder aktivieren Sie Multi-Modell mit mindestens 2 Modellen",
        "multiModelMin2": "Multi-Modell-Optimierung erfordert mindestens 2 Zielmodelle",
        "dspyExpectedOutput": "Wählen Sie für DSPy eine Spalte „Erwartete Ausgabe“ aus",
        "vectorDriftEmbedding": "Vektor-Drift erfordert ein Embedding-Modell, oder setzen Sie die Drift-Methode auf Jaccard.",
        "embeddingForMetrics": "Wählen Sie ein Embedding-Modell für die ausgewählten Metriken aus.",
        "sqlForMetrics": "Wählen Sie eine Ausführungsdatenbank für die ausgewählten Text2SQL-Metriken aus.",
        "schemaForMetrics": "Geben Sie eine gültige JSON-Schemadefinition für die Schema-Konformitätsmetrik an.",
        "ensembleMin2": "Ensemble erfordert mindestens zwei Sub-Frameworks",
        "unsupportedSubframework": "Nicht unterstütztes Sub-Framework: {{list}}",
        "maxCostInvalid": "Maximale Kosten (USD) müssen eine nicht negative Zahl sein",
        "targetScoreInvalid": "Der Zielscore muss zwischen 0 und 1 liegen",
        "llmCapExceeded": "Geschätzte LLM-Aufrufe ({{calls}}) überschreiten das Sitzungslimit ({{cap}}). Reduzieren Sie Iterationen oder Populationsgröße.",
        "cancelRequested": "Abbruch des Optimierungslaufs angefordert",
        "cancelFailed": "Abbruch des Optimierungslaufs fehlgeschlagen"
      },
      "running": {
        "title": "Optimiere „{{name}}“",
        "engineLabel": "Engine:",
        "jobLabel": "Job:",
        "progressLabel": "Fortschritt",
        "statusLabel": "Status:",
        "statusStarting": "STARTET",
        "iterationSuffix": " · Iteration {{current}}/{{max}}",
        "initializing": "{{engine}}-Engine wird initialisiert...",
        "loadingDataset": "Benchmark-Datensatz wird geladen",
        "completedIterations": "{{current}}/{{max}} Iterationen abgeschlossen",
        "errorPrefix": "Fehler: {{message}}",
        "cancelButton": "Lauf abbrechen"
      },
      "result": {
        "awaitingApproval": "Warten auf Freigabe",
        "complete": "Optimierung abgeschlossen",
        "cancelled": "Optimierung abgebrochen",
        "failed": "Optimierung fehlgeschlagen",
        "approvalHint": "Der optimierte Prompt erfordert eine menschliche Freigabe, bevor er als neue Version gespeichert wird. Prüfen und genehmigen Sie ihn auf der Detailseite des Laufs.",
        "baseline": "Baseline",
        "optimized": "Optimiert",
        "iterationsSuffix": "Iterationen: {{count}}",
        "evaluationsSuffix": " · Bewertungen: {{count}}",
        "reviewApprove": "Prüfen & Genehmigen",
        "viewRunDetails": "Laufdetails anzeigen",
        "viewOptimizedVersion": "Optimierte Version anzeigen"
      }
    },
    "runDetail": {
      "pageTitle": "Prompt-Optimierung",
      "backToRuns": "Zurück zu den Läufen",
      "backToOptimizationRuns": "Zurück zu Optimierungsläufen",
      "notFound": "Optimierungslauf nicht gefunden",
      "loading": "Optimierungsdetails werden geladen...",
      "status": {
        "completed": "abgeschlossen",
        "failed": "fehlgeschlagen",
        "cancelled": "abgebrochen",
        "running": "läuft",
        "queued": "in Warteschlange",
        "pending_approval": "Genehmigung ausstehend"
      },
      "approvalBadge": {
        "pending": "Genehmigung ausstehend",
        "approved": "Genehmigt",
        "rejected": "Abgelehnt"
      },
      "viewOptimizedPrompt": "Optimierten Prompt anzeigen",
      "errorBanner": {
        "title": "Optimierung fehlgeschlagen"
      },
      "createdAt": "Erstellt am {{date}}",
      "approval": {
        "reviewTitle": "Optimierten Prompt überprüfen",
        "reviewSubtitle": "Diese Optimierung erfordert eine Genehmigung, bevor der optimierte Prompt als neue Version gespeichert wird.",
        "reasonPlaceholder": "Optionaler Grund für Genehmigung/Ablehnung...",
        "reject": "Ablehnen",
        "approve": "Genehmigen & als neue Version speichern",
        "approvedMessage": "Prompt genehmigt und als neue Version gespeichert.",
        "rejectedMessage": "Prompt abgelehnt. Es wurde keine neue Version erstellt.",
        "promptApprovedTitle": "Prompt genehmigt",
        "promptRejectedTitle": "Prompt abgelehnt",
        "approvedSubtitle": "Dieser optimierte Prompt wurde genehmigt und als neue Version gespeichert.",
        "rejectedSubtitle": "Dieser optimierte Prompt wurde abgelehnt. Es wurde keine neue Version erstellt."
      },
      "diff": {
        "originalPrompt": "Ursprünglicher Prompt",
        "optimizedPrompt": "Optimierter Prompt"
      },
      "tabs": {
        "overview": "Übersicht",
        "insights": "Einblicke",
        "rowMetrics": "Zeilenmetriken",
        "candidates": "Kandidaten",
        "trace": "Ablaufverfolgung",
        "abTest": "A/B-Test",
        "configuration": "Konfiguration"
      },
      "configView": {
        "formatted": "Formatiert",
        "raw": "Roh",
        "copy": "Kopieren",
        "copied": "Kopiert"
      },
      "metrics": {
        "baselineScore": "Basiswert",
        "optimizedScore": "Optimierter Wert",
        "improvement": "Verbesserung",
        "holdoutScore": "Holdout-Wert",
        "holdoutSubValue": "Tatsächlicher Wert auf zurückgehaltenem Datensatz",
        "iterations": "Iterationen",
        "iterationsSubValue": "von {{max}} max.",
        "evaluations": "Auswertungen",
        "duration": "Dauer",
        "totalTokens": "Tokens gesamt",
        "tokensSubValue": "{{prompt}} Prompt / {{completion}} Vervollständigung",
        "estimatedCost": "Geschätzte Kosten",
        "estimatedCostSubValue": "LLM-Verbrauch"
      },
      "orchestrator": {
        "label": "Orchestrator",
        "openRun": "Workflow-Lauf öffnen"
      },
      "earlyStopping": {
        "label": "Vorzeitiger Abbruch",
        "completedOf": "{{completed}} von {{max}} konfigurierten Iterationen abgeschlossen."
      },
      "perModelScores": {
        "title": "Modellspezifische Werte (modellunabhängiger Lauf)",
        "desc": "Der oben genannte Gesamtwert wird aus diesen modellspezifischen Werten abgeleitet. Der Prompt wurde für jedes Basismodell ausgewertet."
      },
      "coproDescription": "COPRO: Ihre Einstellung <strong>Maximale Iterationen</strong> ist die Optimierungstiefe ({{depth}}). Jede Tiefe wertet mehrere vorgeschlagene Prompts aus (Breite {{breadth}}), sodass das Wertdiagramm {{candidatesTracked}} auflistet — nicht nur einen Punkt pro Tiefenschritt.",
      "coproScoredCandidates": "{{count}} bewertete Kandidaten",
      "coproOneRowPerCandidate": "eine Zeile pro bewertetem Kandidaten",
      "miproDescription": "MIPROv2: <strong>Maximale Iterationen</strong> ({{trials}}) ist die Anzahl der Bayes'schen Optimierungsversuche. Diagramm und Kandidatenliste zeigen Prompts, die auf dem <strong>vollständigen</strong> Validierungsdatensatz ausgewertet wurden (reine Minibatch-Proben werden ausgelassen), sodass die Anzahl der Zeilen ({{rows}}) von den Versuchen abweichen kann — besonders bei aktiviertem Minibatching.",
      "scoreChartTitle": "Wertverlauf",
      "scoreChartXAxis": "Iteration",
      "scoreChartYAxis": "Aggregierter Score",
      "scoreChartYAxisAggregated": "Aggregierter Score ({{strategy}})",
      "scoreChartAggregation": {
        "mean": "Mittelwert",
        "min": "Min",
        "pareto": "Pareto"
      },
      "chartTooltip": "Iteration {{iteration}}: {{score}}",
      "chartTooltipBestSuffix": " (beste)",
      "insights": {
        "title": "Optimierer-Einblicke",
        "foundationModel": "Basismodell",
        "judgeModel": "Bewertungsmodell",
        "evalMetrics": "Auswertungsmetriken",
        "mutationModel": "Mutationsmodell",
        "targetScore": "Zielwert",
        "timeBudget": "Zeitbudget",
        "defaultModel": "Standard (Serverstandard)"
      },
      "componentsTitle": "Optimierte Komponenten",
      "rowEvaluations": {
        "title": "Zeilenweise Auswertungen",
        "sourceLabel": "Quelle:",
        "source": {
          "optimization_trace": "Letzter bester Benchmark-Durchlauf aus der Optimierer-Ablaufverfolgung",
          "final_eval": "Auswertung des optimierten Prompts auf dem Datensatz nach dem Lauf",
          "none": "Für diesen Lauf wurden keine Datensatzzeilen ausgewertet",
          "failed": "Zeilen-Snapshot konnte nicht erfasst werden"
        },
        "metricsConfigured": "Konfigurierte Metriken: {{metrics}}.",
        "emptyFailed": "Der Optimierer wurde abgeschlossen, aber das Speichern der zeilenweisen Werte ist fehlgeschlagen. Serverprotokolle prüfen.",
        "emptyNoDataset": "Dieser Lauf hat keine zeilenweisen Werte erzeugt (kein Datensatz oder keine Auswertungszeilen).",
        "emptyDefault": "Für diese Sitzung wurden keine zeilenweisen Zeilen zurückgegeben.",
        "columns": {
          "index": "#",
          "input": "Eingabe / Frage",
          "generatedAnswer": "Generierte Antwort",
          "metrics": "Metriken",
          "score": "Wert",
          "reasoning": "Begründung"
        },
        "expectedOutput": "Erwartete Ausgabe"
      },
      "candidates": {
        "title": "Kandidaten-Prompts ({{count}})",
        "iteration": "Iteration {{iteration}}",
        "candidateLabel": "Kandidat {{index}}",
        "best": "Beste",
        "driftRejected": "Drift abgelehnt",
        "guardrails": "Leitplanken",
        "rejectionReason": "Ablehnungsgrund:"
      },
      "trace": {
        "title": "Optimierungsablauf ({{count}} Einträge)",
        "iter": "Iter {{iteration}}"
      },
      "abTest": {
        "dailyTrafficLabel": "Erwarteter täglicher Traffic (optional):",
        "dailyTrafficPlaceholder": "z. B. 10000",
        "generateButton": "A/B-Test generieren",
        "generating": "Wird generiert…",
        "variantsLabel": "Varianten",
        "sampleSizeLabel": "Stichprobengröße pro Variante",
        "sampleSizeValue": "{{perVariant}} (insgesamt {{total}})",
        "improvementCiLabel": "Verbesserung (KI)",
        "recommendedDurationLabel": "Empfohlene Dauer",
        "durationDays": "~{{days}} Tage",
        "durationHours": "~{{hours}} Stunden",
        "variantPromptsSummary": "Varianten-Prompts",
        "controlLabel": "Kontrolle (A)",
        "treatmentLabel": "Behandlung (B)"
      },
      "metadataLabels": {
        "meta_model": "Meta-Modell",
        "reflection_model": "Reflexionsmodell",
        "stale_rounds": "Stagnierende Runden",
        "population_size": "Populationsgröße",
        "gradient_model": "Gradientenmodell",
        "mutation_model": "Mutationsmodell",
        "gen_model": "Generierungsmodell",
        "policy_model": "Policy-Modell",
        "optimizer_model": "Optimierer-Modell",
        "compiler": "DSPy-Compiler",
        "dspy_version": "DSPy-Version",
        "dspy_copro": "COPRO (Tiefe / Breite)",
        "final_avg_reward": "Endgültige Durchschnittsbelohnung",
        "baseline_reward": "Basisbelohnung",
        "reward_function": "Belohnungsfunktion",
        "objectives": "Ziele",
        "pareto_size": "Pareto-Front-Größe",
        "early_stopping_reason": "Vorzeitiger Abbruch",
        "ensemble_frameworks": "Ensemble-Unterframeworks",
        "fusion_strategy": "Fusionsstrategie"
      },
      "frameworkTier": {
        "dspy": "Deklarative Programmoptimierung",
        "opro": "Meta-Prompting / LLM als Optimierer",
        "reflexion": "Selbstreflexive Verfeinerung",
        "gepa": "Reflektierende Evolutionäre Suche",
        "evoprompt": "Evolutionäre + LLM-Suche",
        "ape": "Automatisches Prompt-Engineering",
        "textgrad": "Textuelle Backpropagation",
        "rl_tuning": "RL-basierte Policy-Optimierung",
        "rag_aware": "Retrieval-gestützte gemeinsame Optimierung",
        "multi_obj": "Multi-Ziel-Pareto-Optimierung",
        "ensemble": "Multi-Framework-Fusion",
        "cot": "Strukturierte Reasoning-Prompts"
      }
    },
    "comparison": {
      "backAriaLabel": "Zurück",
      "title": "Optimierungsläufe vergleichen",
      "subtitle": "Wählen Sie einen Prompt und dann 2 oder mehr abgeschlossene Läufe, um Verläufe, Frameworks und optimierte Ausgaben zu vergleichen",
      "promptFieldLabel": "Prompt",
      "promptPlaceholder": "Prompt auswählen...",
      "runsFieldLabel": "Optimierungsläufe",
      "runsFilterLabel": "Optimierungsläufe",
      "selectPromptFirst": "Zuerst einen Prompt auswählen",
      "loadingRuns": "Wird geladen…",
      "noCompletedRuns": "Keine abgeschlossenen Läufe",
      "clearSelection": "Auswahl löschen",
      "compareButton": "Vergleichen ({{count}} ausgewählt)",
      "selectAtLeastTwo": "Wählen Sie mindestens 2 Läufe zum Vergleichen aus.",
      "genericCompareError": "Vergleich der Sitzungen fehlgeschlagen",
      "scoreTrajectoriesTitle": "Wertverläufe",
      "yAxisScore": "Wert",
      "xAxisIteration": "Iteration",
      "summaryTitle": "Zusammenfassung",
      "exportCsvTitle": "CSV exportieren",
      "columns": {
        "framework": "Framework",
        "original": "Original",
        "optimized": "Optimiert",
        "improvement": "Verbesserung",
        "holdout": "Holdout",
        "duration": "Dauer",
        "iterations": "Iterationen",
        "actions": "Aktionen"
      },
      "view": "Anzeigen",
      "promptComparisonTitle": "Prompt-Vergleich",
      "selectPromptVersion": "Prompt-Version auswählen...",
      "originalPromptLabel": "Original",
      "optimizedPromptLabel": "Optimiert",
      "originalPromptOption": "Ursprünglicher Prompt",
      "noPromptContent": "(Kein Prompt-Inhalt verfügbar)",
      "csv": {
        "sessionId": "Sitzungs-ID",
        "framework": "Framework",
        "originalScore": "Ursprünglicher Wert",
        "optimizedScore": "Optimierter Wert",
        "improvementPct": "Verbesserung %",
        "holdoutScore": "Holdout-Wert",
        "duration": "Dauer",
        "iterations": "Iterationen",
        "evaluations": "Auswertungen"
      }
    },
    "editPage": {
      "backAriaLabel": "Zurück zu Prompts",
      "backToPrompts": "Zurück zu Prompts",
      "platformTooltip": "Code-basierter Systemprompt — schreibgeschützt",
      "platformBadge": "Plattform",
      "versionsCount": "{{count}} Versionen",
      "targetModelTooltip": "Zielmodell",
      "allModels": "Alle Modelle",
      "changeModelTooltip": "Modell ändern oder klonen",
      "changeModelHeader": "Modell ändern",
      "modelAgnostic": "Modellunabhängig (alle Modelle)",
      "autoSavingAriaLabel": "Beschreibung wird automatisch gespeichert",
      "autoSaving": "Automatisches Speichern...",
      "autoSaveTooltip": "Nur die Beschreibung wird automatisch gespeichert. Änderungen am Prompt-Inhalt erfordern ein manuelles Commit.",
      "loadingPrompt": "Prompt wird geladen...",
      "notFound": "Prompt nicht gefunden",
      "contentPlaceholder": "Prompt-Inhalt eingeben... Verwenden Sie {{syntax}}, um auf Statusvariablen zu verweisen.",
      "comingSoon": "Demnächst verfügbar...",
      "targetModelLabel": "Zielmodell *",
      "selectModelPlaceholder": "Modell auswählen...",
      "cloning": "Wird geklont...",
      "tabs": {
        "text": "Prompt-Text",
        "diffs": "Prompt-Unterschiede",
        "testing": "Prompt-Tests",
        "evals": "Prompt-Bewertungen",
        "metrics": "Metriken"
      },
      "testing": {
        "title": "Prompt-Tests",
        "description": "Testen Sie Ihre Prompts mit verschiedenen Eingaben und Modellen"
      },
      "evals": {
        "title": "Prompt-Bewertungen",
        "description": "Bewerten Sie die Leistung und Qualität des Prompts"
      },
      "metrics": {
        "title": "Optimierungsmetriken",
        "description": "Diese Version wurde durch KI-Optimierung erstellt",
        "descriptionWithFramework": "Diese Version wurde durch KI-Optimierung erstellt ({{framework}})",
        "baselineScore": "Basiswert",
        "optimizedScore": "Optimierter Wert",
        "improvement": "Verbesserung",
        "iterations": "Iterationen",
        "evaluations": "Bewertungen",
        "duration": "Dauer",
        "viewAllRuns": "Alle Optimierungsläufe anzeigen"
      },
      "toast": {
        "retagged": "Umbenannt zu „{{modelId}}\"",
        "setModelAgnostic": "Auf modellunabhängig gesetzt",
        "cloned": "Prompt für „{{modelId}}\" geklont",
        "forkedSuccess": "Version erfolgreich verzweigt",
        "noChangesToCommit": "Keine Änderungen zum Committen",
        "enterCommitMessage": "Bitte geben Sie eine Commit-Nachricht ein",
        "platformReadOnlyFork": "Plattform-Prompts sind schreibgeschützt und können nicht verzweigt werden",
        "platformReadOnlyModify": "Plattform-Prompts sind schreibgeschützt und können nicht geändert werden"
      }
    },
    "playground": {
      "loadingPlayground": "Playground wird geladen...",
      "unableToLoad": "Prompt konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
      "unableToLoadSessions": "Chat-Sitzungen konnten nicht geladen werden.",
      "headerTitle": "{{name}} — Playground",
      "versionOption": "v{{version}}",
      "versionOptionCurrent": "v{{version}} (aktuell)",
      "selectModelOption": "Modell auswählen...",
      "loadingSession": "Sitzung wird geladen...",
      "noModelSelected": "Kein Modell ausgewählt",
      "typeMessage": "Nachricht eingeben...",
      "emptyStateTitleFallback": "Playground",
      "emptyStateMessage": "Beginnen Sie mit dem Testen Ihres Prompts",
      "noResponseGenerated": "(Keine Antwort generiert)",
      "toast": {
        "noModelsAvailable": "Keine Modelle verfügbar",
        "promptNotLoaded": "Prompt nicht geladen",
        "noModelsAvailableAddOne": "Keine Modelle verfügbar. Bitte fügen Sie zuerst ein Modell hinzu.",
        "switchedModel": "Zu {{name}} gewechselt",
        "stopBeforeSending": "Bitte stoppen Sie die aktuelle Antwort, bevor Sie eine neue Nachricht senden",
        "uploadAttachmentsFailed": "Anhänge konnten nicht hochgeladen werden",
        "messageNotFoundForRetry": "Nachricht für Wiederholung nicht gefunden",
        "noUserMessageToRegenerate": "Keine Benutzernachricht zum Neuerstellen gefunden",
        "cannotRegenerateEmptyContent": "Kann nicht neu generiert werden: Benutzernachricht hat keinen Inhalt",
        "cannotRetryMessageType": "Dieser Nachrichtentyp kann nicht wiederholt werden",
        "addAttachmentFailed": "Anhang konnte nicht hinzugefügt werden: {{name}}"
      }
    },
    "runsPage": {
      "title": "Prompt-Optimierung",
      "subtitle": "Verlauf aller Optimierungsläufe über alle Prompts hinweg",
      "backToPrompts": "Zurück zu Prompts",
      "compareRuns": "Läufe vergleichen",
      "newOptimization": "Neue Optimierung",
      "loadingMessage": "Optimierungsläufe werden geladen...",
      "emptyMessage": "Noch keine Optimierungsläufe. Klicken Sie auf „Neue Optimierung“, um zu beginnen.",
      "status": {
        "queued": "In Warteschlange",
        "running": "Läuft",
        "completed": "Abgeschlossen",
        "failed": "Fehlgeschlagen",
        "cancelled": "Abgebrochen"
      },
      "columns": {
        "promptName": "Prompt-Name",
        "framework": "Framework",
        "status": "Status",
        "metrics": "Metriken",
        "improvementPct": "Verbesserung %",
        "cost": "Kosten",
        "tokens": "Tokens",
        "createdBy": "Erstellt von",
        "createdAt": "Erstellt am",
        "updatedAt": "Aktualisiert am",
        "actions": "Aktionen"
      },
      "tokensTooltip": "Prompt: {{prompt}} | Vervollständigung: {{completion}}",
      "actions": {
        "retry": "Wiederholen",
        "delete": "Löschen"
      },
      "retryConfirm": "Eine neue Optimierung für „{{label}}“ mit demselben Framework und denselben Optionen wie in diesem Lauf starten?",
      "retryDefaultLabel": "diesen Prompt",
      "deleteConfirm": "Optimierungssitzung für „{{label}}“ löschen? Dies kann nicht rückgängig gemacht werden.",
      "deleteDefaultLabel": "diese Sitzung",
      "toast": {
        "newRunStarted": "Neuer Optimierungslauf gestartet.",
        "retryFailed": "Optimierung konnte nicht wiederholt werden.",
        "sessionDeleted": "Optimierungssitzung gelöscht.",
        "deleteSessionFailed": "Sitzung konnte nicht gelöscht werden.",
        "bulkDeleteWarning": "{{deleted}} Lauf/Läufe gelöscht; {{skipped}} konnte(n) nicht gelöscht werden.{{detail}}",
        "bulkDeleteSuccess_one": "{{count}} Optimierungslauf gelöscht.",
        "bulkDeleteSuccess_other": "{{count}} Optimierungsläufe gelöscht.",
        "bulkDeleteFailed": "Ausgewählte Optimierungsläufe konnten nicht gelöscht werden."
      },
      "bulkDelete": {
        "selectedLabel": "Auswahl löschen",
        "title": "Ausgewählte Läufe löschen",
        "message_one": "Möchten Sie {{count}} Optimierungslauf wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
        "message_other": "Möchten Sie {{count}} Optimierungsläufe wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
        "confirmLabel_one": "{{count}} Lauf löschen",
        "confirmLabel_other": "{{count}} Läufe löschen"
      }
    },
    "optimizationLogModal": {
      "title": {
        "complete": "Optimierung abgeschlossen",
        "cancelled": "Optimierung abgebrochen",
        "failed": "Optimierung fehlgeschlagen",
        "running": "Optimierung läuft..."
      },
      "subtitleDefault": "Prompt",
      "closeAriaLabel": "Schließen",
      "progressLabel": "Fortschritt",
      "statusLabel": "Status:",
      "statusStarting": "STARTET",
      "iterationSuffix": " · Iteration {{iteration}}/{{max}}",
      "bestSuffix": " · Beste: {{value}}",
      "runIdLabel": "Lauf-ID:",
      "jobIdLabel": "Job-ID:",
      "initializingEngine": "{{framework}}-Engine wird initialisiert...",
      "loadingDataset": "Benchmark-Datensatz wird geladen",
      "completedIterations": "{{completed}}/{{max}} Iterationen abgeschlossen",
      "cancelRun": "Lauf abbrechen",
      "viewResults": "Ergebnisse anzeigen"
    },
    "commitMessageModal": {
      "title": "Version committen",
      "closeAriaLabel": "Schließen",
      "description": "Geben Sie eine Commit-Nachricht ein, um die Änderungen in dieser Version zu beschreiben.",
      "placeholder": "z. B. Tippfehler im Prompt behoben, neue Beispiele hinzugefügt...",
      "commit": "Commit",
      "committing": "Wird committet..."
    },
    "diffView": {
      "noVersionsTitle": "Keine Versionen zum Vergleichen",
      "noVersionsDesc": "Erstellen Sie weitere Versionen, um Unterschiede zwischen ihnen zu sehen.",
      "baseLabel": "Basis:",
      "compareLabel": "Vergleich:",
      "swapTooltip": "Basis und Vergleich tauschen",
      "fileLabel": "prompt.txt",
      "collapseContextTooltip": "Kontext einklappen",
      "expandContextTooltip": "Kontext ausklappen",
      "copyDiffTooltip": "Diff kopieren",
      "loadingDiff": "Diff wird geladen...",
      "expandHiddenLines": "{{count}} verborgene Zeilen anzeigen",
      "sameVersionTitle": "Gleiche Version ausgewählt",
      "sameVersionDesc": "Wählen Sie unterschiedliche Versionen aus, um die Unterschiede zu sehen.",
      "noDifferencesTitle": "Keine Unterschiede",
      "noDifferencesDesc": "Diese Versionen sind identisch.",
      "toast": {
        "copied": "Diff in die Zwischenablage kopiert"
      }
    },
    "versionList": {
      "title": "Versionen",
      "refreshTooltip": "Versionen aktualisieren",
      "searchPlaceholder": "Versionen suchen...",
      "emptyMessage": "Keine Versionen gefunden"
    },
    "versionItem": {
      "commitTooltip": "Version committen",
      "commitLabel": "Commit",
      "forkTooltip": "Version {{version}} forken",
      "forkLabel": "Fork",
      "createdByPrefix": "von {{name}}",
      "wordCount_one": "{{count}} Wort",
      "wordCount_other": "{{count}} Wörter"
    },
    "visibilitySelector": {
      "label": "Sichtbarkeit",
      "platformDescription": "Verfügbar in allen Projekten der Plattform",
      "projectDescription": "Nur im ausgewählten Projekt verfügbar",
      "platformHint": "Der Prompt ist in allen Projekten der Plattform verfügbar.",
      "projectHint": "Der Prompt ist nur im ausgewählten Projekt verfügbar.",
      "projectLabel": "Projekt",
      "selectProjectPlaceholder": "Projekt auswählen",
      "searchProjectsPlaceholder": "Projekte suchen..."
    }
  },
  "data": {
    "tabs": {
      "knowledge": "Wissen",
      "graph": "Graph",
      "vector": "Vektordatenbank",
      "storage": "Speicher"
    }
  },
  "knowledge": {
    "connections": {
      "tabs": {
        "databases": "Datenbanken",
        "storage": "Speicherkonten",
        "orchestrators": "Orchestratoren",
        "telephony": "Telefonie",
        "service_connections": "Dienstverbindungen"
      }
    },
    "serviceConnectionModal": {
      "titleCreate": "Dienstverbindung hinzufügen",
      "titleEdit": "Dienstverbindung bearbeiten",
      "titleView": "Dienstverbindung anzeigen",
      "loadingTypes": "Diensttypen werden geladen…",
      "loadingQuota": "Kontingent wird geprüft…",
      "groups": {
        "microsoft": "Microsoft",
        "developer_tools": "Entwicklertools",
        "google": "Google",
        "business_apps": "Geschäftsanwendungen",
        "messaging_and_events": "Nachrichten und Ereignisse",
        "http_and_webhooks": "HTTP und Webhooks",
        "ai_search": "KI-Suche",
        "observability": "Beobachtbarkeit",
        "other": "Sonstiges"
      },
      "fields": {
        "name": "Name",
        "description": "Beschreibung",
        "iam": "IAM-Eintrag",
        "iamPlaceholder": "IAM-Eintrag auswählen",
        "host": "Aufgelöster Host",
        "advanced": "Erweitert (optional)"
      },
      "hints": {
        "iamEmpty": "Kein aktiver IAM-Eintrag passt zu {{subtypes}}. Legen Sie einen unter IAM an.",
        "iamLink": "IAM öffnen",
        "inbound": "Eingehende Dienstverbindungen verwenden keinen IAM-Eintrag.",
        "testRequired": "Testen Sie die Verbindung vor dem Speichern.",
        "secretsOnIam": "Geheimnisse bleiben im IAM-Eintrag und werden hier nicht gespeichert.",
        "missing": "Erforderlich: {{fields}}"
      },
      "buttons": {
        "back": "Zurück",
        "close": "Schließen",
        "cancel": "Abbrechen",
        "create": "Erstellen",
        "save": "Speichern"
      },
      "toasts": {
        "created": "Dienstverbindung erstellt",
        "updated": "Dienstverbindung aktualisiert"
      },
      "errors": {
        "testFailed": "Verbindungstest fehlgeschlagen",
        "selectTenant": "Mandanten auswählen",
        "selectProject": "Projekt auswählen",
        "saveFailed": "Dienstverbindung konnte nicht gespeichert werden"
      }
    },
    "connectorsTab": {
      "testErrorToast": "Verbindungstest fehlgeschlagen",
      "batchTestSuccessToast_one": "Verbindungstest erfolgreich für {{count}} importierte Verbindung",
      "batchTestSuccessToast_other": "Verbindungstest erfolgreich für {{count}} importierte Verbindungen",
      "batchTestFailedToast_one": "Verbindungstest fehlgeschlagen für {{count}} importierte Verbindung",
      "batchTestFailedToast_other": "Verbindungstest fehlgeschlagen für {{count}} importierte Verbindungen",
      "batchTestFinishedToast": "Verbindungstests abgeschlossen: {{success}} erfolgreich, {{fail}} fehlgeschlagen",
      "loadErrorToast": "Connectors konnten nicht geladen werden",
      "loadingMessage": "Verbindungen werden geladen...",
      "filterResourceLabel": {
        "database": "Datenbank-Engine",
        "storage": "Speichertyp",
        "orchestrator": "Orchestrator-Typ",
        "telephony": "Telefonietyp",
        "service": "Diensttyp"
      },
      "filterAllTypesPlaceholder": "Alle Typen",
      "filterCreatorLabel": "Ersteller",
      "filterAllCreatorsPlaceholder": "Alle Ersteller",
      "filterStatusLabel": "Status",
      "filterAllStatusesPlaceholder": "Alle Status",
      "filterStatusError": "Fehler",
      "deletePermissionDeniedToast": "Sie sind nicht berechtigt, diesen Connector zu löschen",
      "deleteErrorToast": "Connector konnte nicht gelöscht werden",
      "bulkDeletePermissionDeniedToast": "Sie sind nicht berechtigt, Connectors zu löschen",
      "bulkDeletePartialWarning": "{{deleted}} Connector(s) gelöscht, {{skipped}} fehlgeschlagen: {{errors}}",
      "bulkDeleteSuccessToast_one": "{{count}} Connector erfolgreich gelöscht",
      "bulkDeleteSuccessToast_other": "{{count}} Connectors erfolgreich gelöscht",
      "bulkDeleteErrorToast": "Connectors konnten nicht gelöscht werden",
      "unsetDefaultToast": "{{name}} ist nicht mehr der Standard-{{category}}",
      "setDefaultToast": "{{name}} ist jetzt der Standard-{{category}}",
      "unsetDefaultErrorToast": "Standard-{{category}} konnte nicht entfernt werden",
      "setDefaultErrorToast": "Standard-{{category}} konnte nicht festgelegt werden",
      "status": {
        "active": "Aktiv",
        "failed": "Fehlgeschlagen",
        "notTested": "Nicht getestet",
        "unknown": "Unbekannt"
      },
      "statusTooltip": "Status: {{status}}",
      "authModeTooltip": "Authentifizierung: {{mode}}",
      "columnName": "Name",
      "columnCloud": "Cloud",
      "columnResource": "Ressource",
      "columnType": "Typ",
      "columnHost": "Host",
      "columnStatus": "Status",
      "columnLastTested": "Zuletzt getestet",
      "columnCreatedBy": "Erstellt von",
      "columnUpdatedBy": "Aktualisiert von",
      "columnActions": "Aktionen",
      "actionView": "Anzeigen",
      "actionTestConnection": "Verbindung testen",
      "actionRemoveAsDefault": "Als Standard-{{category}} entfernen",
      "actionSetAsDefault": "Als Standard festlegen",
      "actionExport": "Exportieren",
      "actionEdit": "Bearbeiten",
      "actionDelete": "Löschen",
      "entityFilterAllLabel": "Alle",
      "entityFilterFavoritesLabel": "Favoriten",
      "bulkExportSelected": "Auswahl exportieren",
      "bulkDeleteSelected": "Auswahl löschen",
      "emptyMessage": "Keine Connectors gefunden. Fügen Sie eine Verbindung hinzu, um sich mit Datenbanken, Speicher oder anderen Datenquellen zu verbinden.",
      "addConnection": "Verbindung hinzufügen",
      "deleteDialogTitle": "Connector löschen",
      "deleteDialogMessage": "Möchten Sie \"{{name}}\" wirklich löschen? Dadurch werden auch alle registrierten Tabellen dieses Connectors gelöscht.",
      "deleteDialogConfirmLabel": "Löschen",
      "bulkDeleteDialogTitle": "Ausgewählte Connectors löschen",
      "bulkDeleteDialogMessage_one": "Möchten Sie {{count}} Connector wirklich löschen? Dadurch werden auch alle registrierten Tabellen dieser Connectors gelöscht. Dies kann nicht widerrufen werden.",
      "bulkDeleteDialogMessage_other": "Möchten Sie {{count}} Connectors wirklich löschen? Dadurch werden auch alle registrierten Tabellen dieser Connectors gelöscht. Dies kann nicht widerrufen werden.",
      "bulkDeleteDialogConfirmLabel_one": "{{count}} Connector löschen",
      "bulkDeleteDialogConfirmLabel_other": "{{count}} Connectors löschen"
    },
    "tab": {
      "unknownConnectorType": "Unbekannt",
      "filterEngineLabel": "Datenbank-Engine",
      "filterAllEnginesPlaceholder": "Alle Engines",
      "filterCreatorLabel": "Ersteller",
      "filterAllCreatorsPlaceholder": "Alle Ersteller",
      "deleteErrorToast": "Wissenstabelle konnte nicht gelöscht werden",
      "bulkDeletePartialWarning": "{{deleted}} Tabelle(n) gelöscht, {{skipped}} fehlgeschlagen: {{errors}}",
      "bulkDeleteSuccessToast_one": "{{count}} Tabelle erfolgreich gelöscht",
      "bulkDeleteSuccessToast_other": "{{count}} Tabellen erfolgreich gelöscht",
      "bulkDeleteErrorToast": "Tabellen konnten nicht gelöscht werden",
      "deleteSchemaErrorToast": "Schema konnte nicht gelöscht werden",
      "deleteSchemaPartialWarning": "{{deleted}} Tabelle(n) über {{schemaCount}} Schema(s) gelöscht; {{skipped}} fehlgeschlagen",
      "deleteSchemaSuccessToast_one": "Schema gelöscht ({{count}} Tabelle)",
      "deleteSchemaSuccessToast_other": "Schema gelöscht ({{count}} Tabellen)",
      "deleteSchemaSuccessToastNamed_one": "Schema \"{{schema}}\" gelöscht ({{count}} Tabelle)",
      "deleteSchemaSuccessToastNamed_other": "Schema \"{{schema}}\" gelöscht ({{count}} Tabellen)",
      "deleteSchemasSuccessToast_one": "{{schemaCount}} Schemas gelöscht ({{count}} Tabelle)",
      "deleteSchemasSuccessToast_other": "{{schemaCount}} Schemas gelöscht ({{count}} Tabellen)",
      "syncRequeuedToast": "Metadaten-Synchronisierung für '{{name}}' erneut eingereiht (war blockiert)",
      "syncQueuedToast": "Metadaten-Synchronisierung für '{{name}}' eingereiht",
      "syncQueueErrorToast": "Metadaten-Synchronisierung für '{{name}}' konnte nicht eingereiht werden",
      "bulkSyncStartedRequeuedToast_one": "Metadaten-Synchronisierung für {{count}} Tabelle gestartet (blockierte Introspektion erneut eingereiht)",
      "bulkSyncStartedRequeuedToast_other": "Metadaten-Synchronisierung für {{count}} Tabellen gestartet (blockierte Introspektion erneut eingereiht)",
      "bulkSyncStartedToast_one": "Metadaten-Synchronisierung für {{count}} Tabelle gestartet",
      "bulkSyncStartedToast_other": "Metadaten-Synchronisierung für {{count}} Tabellen gestartet",
      "bulkSyncStartErrorToast": "Massen-Metadaten-Synchronisierung konnte nicht gestartet werden",
      "columnName": "Name",
      "defaultBadgeTooltip": "Standard",
      "schemaTooltip": "Schema: {{schema}}",
      "columnDatabase": "Datenbank",
      "columnType": "Typ",
      "columnRows": "Zeilen",
      "columnIntrospection": "Introspektion",
      "syncStatus": {
        "queued": "Eingereiht",
        "running": "Wird ausgeführt",
        "synced": "Synchronisiert",
        "failed": "Fehlgeschlagen",
        "active": "Aktiv"
      },
      "viewSyncLogsTooltip": "Synchronisierungsprotokolle anzeigen",
      "columnStatus": "Status",
      "columnCreated": "Erstellt",
      "columnUpdated": "Aktualisiert",
      "columnCreator": "Ersteller",
      "unknownCreator": "Unbekannt",
      "columnLogs": "Protokolle",
      "viewLink": "Anzeigen",
      "columnActions": "Aktionen",
      "actionViewDetails": "Details anzeigen",
      "actionPreviewData": "Daten-Vorschau",
      "actionApprovals": "Genehmigungen",
      "actionEvals": "Evaluierungen",
      "actionEdit": "Bearbeiten",
      "actionRequeueSync": "Metadaten-Sync erneut einreihen",
      "actionSyncMetadata": "Metadaten synchronisieren",
      "actionExport": "Exportieren",
      "actionDelete": "Löschen",
      "databaseViewLabel": "Datenbankansicht",
      "collectionViewLabel": "Sammlungsansicht",
      "addGraphTable": "Graph-Tabelle hinzufügen",
      "addKnowledgeTable": "Wissenstabelle hinzufügen",
      "leafTitleTables": "Tabellen",
      "leafTitleGraphTables": "Graph-Tabellen",
      "defaultSchemaLabel": "(Standard)",
      "entityFilterAllLabel": "Alle",
      "entityFilterFavoritesLabel": "Favoriten",
      "noGraphConnectorsEmptyMessage": "Noch keine Graph-DB-Connectors.",
      "noDataConnectorsEmptyMessage": "Noch keine Daten-Connectors.",
      "schemasPaneTitle": "Schemas",
      "bulkExportSelected": "Auswahl exportieren",
      "bulkSyncMetadata": "Metadaten synchronisieren",
      "bulkDeleteSelected": "Auswahl löschen",
      "graphDataExplorerAriaLabel": "Graph-Datenexplorer",
      "knowledgeDataExplorerAriaLabel": "Wissensdatenexplorer",
      "deleteDialogTitle": "Wissenstabelle löschen",
      "deleteDialogMessage": "Möchten Sie \"{{name}}\" wirklich löschen? Dies kann nicht widerrufen werden.",
      "deleteDialogConfirmLabel": "Löschen",
      "deleteSchemaDialogTitle": "Schema löschen",
      "deleteSchemasDialogTitle": "Schemas löschen",
      "deleteSchemaDialogMessage_one": "Möchten Sie das Schema \"{{schema}}\" und die darin enthaltene {{count}} registrierte Tabelle wirklich löschen? Dadurch werden nur {{brand}}-Metadaten entfernt und dies kann nicht widerrufen werden.",
      "deleteSchemaDialogMessage_other": "Möchten Sie das Schema \"{{schema}}\" und die darin enthaltenen {{count}} registrierten Tabellen wirklich löschen? Dadurch werden nur {{brand}}-Metadaten entfernt und dies kann nicht widerrufen werden.",
      "deleteSchemasDialogMessage_one": "Möchten Sie {{schemaCount}} Schemas und die darin enthaltene {{count}} registrierte Tabelle wirklich löschen? Dadurch werden nur {{brand}}-Metadaten entfernt und dies kann nicht widerrufen werden.",
      "deleteSchemasDialogMessage_other": "Möchten Sie {{schemaCount}} Schemas und die darin enthaltenen {{count}} registrierten Tabellen wirklich löschen? Dadurch werden nur {{brand}}-Metadaten entfernt und dies kann nicht widerrufen werden.",
      "deletingLabel": "Wird gelöscht…",
      "deleteSchemasDialogConfirmLabel": "{{count}} Schemas löschen",
      "andOthersLabel": "{{names}} und {{count}} weitere",
      "bulkDeleteDialogTitle": "Ausgewählte Tabellen löschen",
      "bulkDeleteDialogMessage_one": "Möchten Sie {{count}} Tabelle wirklich löschen? Dies kann nicht widerrufen werden.",
      "bulkDeleteDialogMessage_other": "Möchten Sie {{count}} Tabellen wirklich löschen? Dies kann nicht widerrufen werden.",
      "bulkDeleteDialogConfirmLabel_one": "{{count}} Tabelle löschen",
      "bulkDeleteDialogConfirmLabel_other": "{{count}} Tabellen löschen",
      "emptyStatePermissionDenied": "Sie haben keine Berechtigung, {{resource}} anzuzeigen. Wenden Sie sich an Ihren Administrator.",
      "emptyStateSearching": "Keine {{resource}} gefunden, die Ihrer Suche entsprechen.",
      "emptyStateDefault": "Keine {{resource}} gefunden. Erstellen Sie Ihr erstes {{resourceSingular}}, um zu beginnen.",
      "resourceGraphTables": "Graph-Tabellen",
      "resourceGraphTable": "Graph-Tabelle",
      "resourceKnowledgeTables": "Knowledge-Tabellen",
      "resourceKnowledgeTable": "Knowledge-Tabelle"
    },
    "addTableModal": {
      "title": "Wissenstabelle hinzufügen",
      "closeDialogAriaLabel": "Dialog schließen",
      "cancelButton": "Abbrechen",
      "loadConnectorsError": "Connectors konnten nicht geladen werden",
      "noDatabasesFoundWarning": "Keine Datenbanken gefunden. Der Connector hat möglicherweise keinen Zugriff auf Datenbanken.",
      "loadTablesTimedOut": "Das Laden der Tabellen hat zu lange gedauert. Versuchen Sie einen engeren Bereich oder prüfen Sie Ihre Verbindung.",
      "loadTablesForSchemaError": "Tabellen für das Schema konnten nicht geladen werden",
      "loadingTablesForSchema": "Tabellen für {{schema}} werden geladen...",
      "schemaFallbackLabel": "Schema",
      "inlineSearch": {
        "defaultPlaceholder": "Suchen",
        "clearAriaLabel": "Suche löschen"
      },
      "breadcrumb": {
        "backAriaLabel": "Zurück",
        "schemasCount_one": "{{count}} Schema",
        "schemasCount_other": "{{count}} Schemas"
      },
      "connectorSelection": {
        "emptyTitle": "Keine Connectors",
        "emptyMessage": "Erstellen Sie zuerst einen Connector, um Wissenstabellen hinzuzufügen",
        "filterByTypeLabel": "Nach Connector-Typ filtern",
        "connectorTypeLabel": "Connector-Typ",
        "allConnectorTypesPlaceholder": "Alle Connector-Typen ({{count}})",
        "searchPlaceholder": "Connectors suchen",
        "noMatchingConnections": "Keine passenden Verbindungen. Passen Sie die Suche an oder wählen Sie einen anderen Connector-Typ."
      },
      "databaseSelection": {
        "loadingCatalog": "Katalog wird geladen…",
        "catalogUnavailableTitle": "Katalog nicht verfügbar",
        "catalogUnavailableMessage": "Der Katalog konnte nicht geladen werden. Prüfen Sie die Connector-Konfiguration und versuchen Sie es erneut.",
        "noDatabasesTitle": "Keine Datenbanken gefunden",
        "noDatabasesMessage": "Der Connector hat keinen Zugriff auf Datenbanken, oder die Introspektion ist fehlgeschlagen.",
        "title": "Datenbank auswählen",
        "countLabel_one": "{{shown}} von {{count}} Datenbank",
        "countLabel_other": "{{shown}} von {{count}} Datenbanken",
        "searchPlaceholder": "Datenbanken suchen",
        "noMatchMessage": "Keine Datenbanken entsprechen Ihrer Suche.",
        "schemaCount_one": "{{count}} Schema",
        "schemaCount_other": "{{count}} Schemas"
      },
      "schemaSelection": {
        "title": "Schema auswählen",
        "countLabel_one": "{{shown}} von {{count}} Schema",
        "countLabel_other": "{{shown}} von {{count}} Schemas",
        "selectedCount": "{{count}} ausgewählt",
        "deselectAll": "Alle abwählen",
        "selectAll": "Alle auswählen",
        "continueWith_one": "Mit {{count}} Schema fortfahren",
        "continueWith_other": "Mit {{count}} Schemas fortfahren",
        "searchPlaceholder": "Schemas suchen",
        "hint": "Aktivieren Sie Schemas und klicken Sie auf Weiter, um sie einzeln zu durchsuchen, oder klicken Sie auf eine Karte, um ein Schema zu öffnen.",
        "noMatchMessage": "Keine Schemas entsprechen Ihrer Suche.",
        "selectSchemaAriaLabel": "Schema {{schema}} auswählen",
        "tableCount_one": "{{count}} Tabelle",
        "tableCount_other": "{{count}} Tabellen",
        "clickToLoadTables": "Zum Laden der Tabellen klicken"
      },
      "tableSelection": {
        "loadingTables": "Tabellen werden geladen…",
        "noTablesFoundTitle": "Keine Tabellen gefunden",
        "noTablesInSchema": "Keine Tabellen in diesem Schema verfügbar",
        "noTablesInDatabase": "Keine Tabellen in dieser Datenbank verfügbar",
        "hint": "Tabellen werden nur für das geöffnete Schema geladen. Klicken Sie auf Zeilen oder verwenden Sie das Kopfzeilen-Kontrollkästchen zur Auswahl.",
        "searchPlaceholder": "Tabellen suchen",
        "showingCount": "{{shown}} von {{count}} werden angezeigt",
        "selectedAcrossSchemas": "{{count}} über Schemas hinweg ausgewählt",
        "deselectAllAriaLabel": "Alle Tabellen abwählen",
        "selectAllAriaLabel": "Alle Tabellen auswählen",
        "columnTable": "Tabelle",
        "columnDatabase": "Datenbank",
        "columnRows": "Zeilen",
        "columnCols": "Spalten",
        "noMatchMessage": "Keine Tabellen entsprechen Ihrer Suche.",
        "selectTableAriaLabel": "{{label}} auswählen",
        "updateAvailableTooltip": "Neue Knoten/Labels verfügbar",
        "updateAvailableBadge": "Update verfügbar",
        "alreadyRegisteredTooltip": "Sie haben diese Tabelle bereits registriert",
        "registeredBadge": "Registriert"
      },
      "registrationStep": {
        "loadingTables": "Tabellen werden geladen…",
        "selectedSchemasAriaLabel": "Ausgewählte Schemas",
        "multiGraphRegistrationLabel": "Multi-Graph-Registrierung:",
        "multiGraphRegistrationTextPrefix": "Jede ausgewählte",
        "multiGraphRegistrationTextSuffix": "Zeile wird als Wissens-Asset für diesen Graphen registriert.",
        "graphSchemaRegistrationLabel": "Graph-Schema-Registrierung:",
        "graphSchemaRegistrationText": "Ausgewählte Graph-Tabellen werden als ein einziger Graph-Schema-Eintrag registriert.",
        "relationshipTypesDetected_one": "{{count}} Beziehungstyp erkannt.",
        "relationshipTypesDetected_other": "{{count}} Beziehungstypen erkannt.",
        "finalizeAndRegisterTitle": "Abschließen & registrieren",
        "subtitleRegisterPrefix": "Registrieren Sie",
        "subtitleChoosePrefix": "Wählen Sie, wie dieses Wissen verwendet wird, und registrieren Sie dann",
        "subtitleGraphSchemaSuffix_one": "Graph-Tabelle als einen einzigen Graph-Schema-Eintrag.",
        "subtitleGraphSchemaSuffix_other": "Graph-Tabellen als einen einzigen Graph-Schema-Eintrag.",
        "subtitleGraphsSuffix_one": "Graph in einem Schritt.",
        "subtitleGraphsSuffix_other": "Graphen in einem Schritt.",
        "subtitleGraphTablesSuffix_one": "Graph-Tabelle in einem Schritt.",
        "subtitleGraphTablesSuffix_other": "Graph-Tabellen in einem Schritt.",
        "subtitleTablesSuffix_one": "Tabelle in einem Schritt.",
        "subtitleTablesSuffix_other": "Tabellen in einem Schritt.",
        "selectGraphTablesAbove": "Graph-Tabellen oben auswählen",
        "selectGraphsAbove": "Graphen oben auswählen",
        "selectTablesAbove": "Tabellen oben auswählen",
        "registerGraphSchema_one": "Graph-Schema registrieren ({{count}} Graph-Tabelle)",
        "registerGraphSchema_other": "Graph-Schema registrieren ({{count}} Graph-Tabellen)",
        "registerGraphs_one": "{{count}} Graph registrieren",
        "registerGraphs_other": "{{count}} Graphen registrieren",
        "registerGraphTables_one": "{{count}} Graph-Tabelle registrieren",
        "registerGraphTables_other": "{{count}} Graph-Tabellen registrieren",
        "registerTables_one": "{{count}} Tabelle registrieren",
        "registerTables_other": "{{count}} Tabellen registrieren"
      },
      "introspectionError": {
        "thisConnection": "diese Verbindung",
        "timedOut": "{{name}} hat zu lange zum Antworten gebraucht.",
        "forbidden": "Sie haben keinen Zugriff auf {{name}} — fragen Sie einen Projektadministrator.",
        "credentialsRejected": "{{name}} hat die gespeicherten Anmeldedaten abgelehnt.",
        "missingSecret": "{{name}} fehlt ein Passwort oder ein Secret.",
        "databaseNotFound": "Die auf {{name}} gespeicherte Datenbank oder der Katalog existiert nicht mehr.",
        "hostUnreachable": "Der auf {{name}} konfigurierte Host ist nicht erreichbar.",
        "serviceBusy": "{{name}} ist derzeit ausgelastet.",
        "notConnecting": "{{name}} stellt keine Verbindung her.",
        "genericFailure": "Der Katalog konnte nicht von {{name}} geladen werden.",
        "validateInConnections": "In Verbindungen überprüfen",
        "tryAgain": "Erneut versuchen"
      }
    },
    "editModal": {
      "title": "Wissenstabelle bearbeiten",
      "closeDialogAriaLabel": "Dialog schließen",
      "vectorDbBadge": "Vektor-DB",
      "displayNameLabel": "Anzeigename",
      "displayNamePlaceholder": "Anzeigename eingeben",
      "nameAlreadyExistsToast": "Eine Wissenstabelle mit diesem Namen existiert bereits",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": "Beschreibung eingeben (optional)",
      "knowledgeTypeLabel": "Wissenstyp",
      "knowledgeTypeData": "Daten",
      "knowledgeTypeDataHint": "= allgemeines Wissen.",
      "knowledgeTypeBenchmarks": "Benchmarks",
      "knowledgeTypeBenchmarksFull": "Benchmarks (Evals & Simulationen)",
      "knowledgeTypeBenchmarksHint": "= wird in Evals und Simulationen angezeigt.",
      "knowledgeTypePlaceholder": "Wissenstyp auswählen...",
      "benchmarkTypeLabel": "Benchmark-Typ",
      "benchmarkTypeHint": "Workload-Kategorie, die im Tab Benchmarks angezeigt wird (Text2SQL, RAG, Tool-Nutzung, …).",
      "benchmarkTypePlaceholder": "Benchmark-Typ auswählen…",
      "benchmarkIconLabel": "Benchmark-Symbol",
      "benchmarkIconHint": "Wird auf der Benchmark-Karte in Evals & Simulationen angezeigt. Fällt auf das Connector-Symbol zurück, wenn kein Bild festgelegt ist.",
      "embeddingModelLabel": "Embedding-Modell",
      "embeddingModelHint": "Wählen Sie das Embedding-Modell aus, das zum Erstellen von Vektoren in dieser Tabelle verwendet wird.",
      "embeddingModelPlaceholder": "Embedding-Modell auswählen...",
      "searchModelsPlaceholder": "Modelle suchen...",
      "loadingModelsMessage": "Embedding-Modelle werden geladen...",
      "noModelsRegisteredMessage": "Keine Embedding-Modelle registriert. Bitte registrieren Sie zuerst ein Embedding-Modell.",
      "noModelSelectedWarning": "Kein Embedding-Modell ausgewählt. Die Vektorsuche kann fehlschlagen oder falsche Ergebnisse liefern.",
      "defaultBadge": "Standard",
      "loadModelsErrorToast": "Embedding-Modelle konnten nicht geladen werden",
      "updateErrorToast": "Wissenstabelle konnte nicht aktualisiert werden",
      "cancelButton": "Abbrechen",
      "savingButton": "Speichern...",
      "saveChangesButton": "Änderungen speichern"
    },
    "modal": {
      "title": "Tabellen für Wissensdatenbank registrieren",
      "closeDialogAriaLabel": "Dialog schließen",
      "registeringTooltip_one": "{{count}} Tabelle wird von {{name}} registriert",
      "registeringTooltip_other": "{{count}} Tabellen werden von {{name}} registriert",
      "registeringText_one": "{{count}} Tabelle wird von {{name}} registriert",
      "registeringText_other": "{{count}} Tabellen werden von {{name}} registriert",
      "registerSubmitLabel_one": "{{count}} Tabelle registrieren",
      "registerSubmitLabel_other": "{{count}} Tabellen registrieren",
      "tablesToRegisterLabel": "Zu registrierende Tabellen",
      "columnsCount_one": "{{count}} Spalte",
      "columnsCount_other": "{{count}} Spalten",
      "rowsCount_one": "{{formattedCount}} Zeile",
      "rowsCount_other": "{{formattedCount}} Zeilen",
      "columnsHeader": "Spalten",
      "notNullBadge": "NOT NULL",
      "cancelButton": "Abbrechen"
    },
    "viewModal": {
      "title": "Details der Wissenstabelle",
      "closeDialogAriaLabel": "Dialog schließen",
      "closeButton": "Schließen",
      "notAvailable": "Nicht verfügbar",
      "yesLabel": "Ja",
      "noLabel": "Nein",
      "noneDetectedMessage": "Keine erkannt",
      "statusUnknown": "Unbekannt",
      "statusActive": "Aktiv",
      "statusError": "Fehler",
      "statusSyncing": "Synchronisierung",
      "noErrorsMessage": "Keine Fehler",
      "noColumnInfoMessage": "Keine Spalteninformationen verfügbar",
      "basicInformationHeader": "Grundinformationen",
      "tableInformationHeader": "Tabelleninformationen",
      "graphInformationHeader": "Graph-Informationen",
      "embeddingModelHeader": "Embedding-Modell",
      "columnsHeader": "Spalten",
      "errorInformationHeader": "Fehlerinformationen",
      "metadataHeader": "Metadaten",
      "auditInformationHeader": "Prüfinformationen",
      "fieldId": "ID",
      "fieldConnector": "Connector",
      "fieldStatus": "Status",
      "fieldDatabase": "Datenbank",
      "fieldSchema": "Schema",
      "fieldTableName": "Tabellenname",
      "fieldRowCountNodes": "Zeilenanzahl (Knoten)",
      "fieldTotalNodes": "Knoten insgesamt",
      "fieldTotalEdges": "Kanten insgesamt",
      "fieldRelationshipTypes": "Beziehungstypen",
      "fieldNodeLabels": "Knotenbezeichnungen",
      "fieldModel": "Modell",
      "fieldErrorMessage": "Fehlermeldung",
      "fieldCreatedAt": "Erstellt am",
      "fieldUpdatedAt": "Aktualisiert am",
      "fieldCreatedBy": "Erstellt von",
      "fieldUpdatedBy": "Aktualisiert von",
      "noEmbeddingModelConfiguredTitle": "Kein Embedding-Modell konfiguriert",
      "noEmbeddingModelConfiguredHint": "Die Vektorsuche kann fehlschlagen oder falsche Ergebnisse liefern. Bearbeiten Sie diese Tabelle, um ein Embedding-Modell zuzuweisen, das mit dem zur Erstellung der gespeicherten Vektoren verwendeten übereinstimmt.",
      "columnName": "Name",
      "columnType": "Typ",
      "columnNullable": "Nullwerte zulässig"
    },
    "registerFields": {
      "embeddingModelLabel": "Embedding-Modell",
      "embeddingModelHint": "Modell für die semantische Suche in diesen Vektortabellen.",
      "loadingModelsMessage": "Embedding-Modelle werden geladen…",
      "noModelsRegisteredMessage": "Keine Embedding-Modelle registriert. Registrieren Sie zuerst eines.",
      "selectEmbeddingModelOption": "— Embedding-Modell auswählen —",
      "defaultBadge": "Standard",
      "managedVectorDbHint": "Dieser Connector verwaltet Indizes und Embeddings intern — keine Spaltenzuordnung erforderlich. Das ausgewählte Embedding-Modell wird zur Abfragezeit verwendet, um Ihre Suchanfrage einzubetten.",
      "columnMappingLabel": "Spaltenzuordnung",
      "columnMappingHint": "ID-, Inhalts- und Embedding-Spalten für die Vektorsuche zuordnen.",
      "columnLabelId": "ID",
      "columnLabelContent": "Inhalt",
      "columnLabelEmbedding": "Embedding",
      "columnFieldLabel": "{{column}}-Spalte",
      "selectOption": "— Auswählen —",
      "vectorSuffix": "Vektor",
      "knowledgePurposeLabel": "Wissenszweck",
      "knowledgeTypeData": "Daten",
      "knowledgeTypeDataHint": "für allgemeines RAG.",
      "knowledgeTypeBenchmarks": "Benchmarks",
      "knowledgeTypeBenchmarksHint": "zeigt diese Daten in Evals & Simulationen an.",
      "knowledgeTypeGroupAriaLabel": "Wissenstyp",
      "encryptDataLabel": "Tabellendaten für Betrachter im Ruhezustand verschlüsseln",
      "encryptDataHint": "Nur Sie (Ersteller) sehen Klartextwerte; andere sehen Chiffretext. Verwendet denselben Schlüssel wie Tool-Secrets.",
      "selectEmbeddingModelTooltip": "Ein Embedding-Modell auswählen",
      "mapColumnsTooltip": "ID-, Inhalts- und Embedding-Spalten zuordnen",
      "registeringButton": "Wird registriert…"
    },
    "groupedView": {
      "loadingMessage": "Tabellen werden geladen...",
      "emptyMessage": "Keine Wissenstabellen gefunden",
      "emptySearchHint": "Versuchen Sie, Ihre Suchanfrage anzupassen",
      "tableCount_one": "{{count}} Tabelle",
      "tableCount_other": "{{count}} Tabellen",
      "rowsCount_one": "{{formattedCount}} Zeile",
      "rowsCount_other": "{{formattedCount}} Zeilen",
      "vectorDbTooltip": "Vektordatenbank",
      "vectorDbBadge": "Vektor-DB",
      "createdTooltip": "Erstellt",
      "updatedTooltip": "Aktualisiert",
      "statusUnknown": "Unbekannt",
      "statusError": "Fehler",
      "statusActive": "Aktiv",
      "statusSyncing": "Synchronisierung",
      "actionViewDetails": "Details anzeigen",
      "actionPreviewData": "Daten-Vorschau",
      "actionEdit": "Bearbeiten",
      "actionVectorSearch": "Vektorsuche",
      "actionSync": "Synchronisieren",
      "actionManageAccess": "Zugriff verwalten",
      "actionDelete": "Löschen"
    },
    "addStorageFolderModal": {
      "title": "Speicherordner hinzufügen",
      "closeDialogAriaLabel": "Dialog schließen",
      "selectConnectorTitle": "Speicherconnector auswählen",
      "noConnectorsFoundMessage": "Keine Speicherconnectoren gefunden. Bitte erstellen Sie zuerst einen Speicherconnector.",
      "searchConnectorsPlaceholder": "Connectoren suchen",
      "countOf": "{{shown}} von {{count}}",
      "noConnectorsMatchFilters": "Keine Connectoren entsprechen Ihren Filtern.",
      "connectorTypeLabel": "Connector-Typ",
      "allConnectorTypesPlaceholder": "Alle Connector-Typen ({{count}})",
      "selectBucketTitle": "Bucket auswählen",
      "noBucketsFoundMessage": "Keine Buckets gefunden.",
      "searchBucketsPlaceholder": "Buckets suchen",
      "noBucketsMatchSearch": "Keine Buckets entsprechen Ihrer Suche.",
      "selectFoldersTitle": "Ordner auswählen",
      "selectAllButton": "Alle auswählen",
      "deselectAllButton": "Alle abwählen",
      "searchFoldersPlaceholder": "Ordner suchen",
      "fileCount_one": "{{count}} Datei",
      "fileCount_other": "{{count}} Dateien",
      "openSubfolderTooltip": "Unterordner öffnen",
      "noFoldersMatchSearch": "Keine Ordner entsprechen Ihrer Suche.",
      "noSubfoldersMessage": "Keine Unterordner vorhanden. Sie können diesen Ordnerpfad registrieren, wenn er Dateien enthält.",
      "noFoldersInBucketMessage": "Keine Ordner in diesem Bucket gefunden.",
      "selectFolderButton": "Ordner „{{name}}“ auswählen",
      "selectedFoldersCount_one": "{{count}} Ordner ausgewählt",
      "selectedFoldersCount_other": "{{count}} Ordner ausgewählt",
      "cancelButton": "Abbrechen",
      "registeringButton": "Wird registriert...",
      "registerFoldersButton_one": "{{count}} Ordner registrieren",
      "registerFoldersButton_other": "{{count}} Ordner registrieren",
      "registerSuccessToast_one": "{{count}} Speicherordner erfolgreich registriert",
      "registerSuccessToast_other": "{{count}} Speicherordner erfolgreich registriert"
    },
    "splitView": {
      "storageBucketPane": {
        "title": "Buckets",
        "columnBucket": "Bucket",
        "columnFolders": "Ordner",
        "defaultBucketLabel": "(Standard)",
        "searchPlaceholder": "Buckets suchen…",
        "emptyMessage": "Keine Buckets registriert.",
        "emptySearchMessage": "Keine Buckets entsprechen dieser Suche.",
        "loadErrorMessage": "Buckets konnten nicht geladen werden"
      },
      "connectorPane": {
        "columnCreatedAt": "Erstellt",
        "columnDatabase": "Typ",
        "columnName": "Name",
        "columnStatus": "Status",
        "columnUpdatedAt": "Aktualisiert",
        "emptyMessage": "Keine Connectors gefunden.",
        "emptySearchMessage": "Keine Connectors entsprechen Ihrer Suche.",
        "loadErrorMessage": "Connectors konnten nicht geladen werden.",
        "searchPlaceholder": "Connectors suchen…",
        "title": "Connectors"
      },
      "schemaPane": {
        "ariaDeleteMany_one": "{{count}} ausgewähltes Schema löschen",
        "ariaDeleteMany_other": "{{count}} ausgewählte Schemas löschen",
        "ariaDeleteOne": "Ausgewähltes Schema löschen",
        "columnName": "Name",
        "columnObjects": "Objekte",
        "defaultLabel": "Standard",
        "deleteTitleEmpty": "Schema löschen",
        "deleteTitleMany_one": "{{count}} Schema löschen",
        "deleteTitleMany_other": "{{count}} Schemas löschen",
        "deleteTitleOne": "Schema löschen",
        "deleteTitleOneNamed": "{{schema}} löschen",
        "emptyMessage": "Keine Schemas gefunden",
        "emptySearchMessage": "Keine Schemas entsprechen Ihrer Suche",
        "loadErrorMessage": "Schemas konnten nicht geladen werden",
        "searchPlaceholder": "{{title}} suchen…",
        "title": "Schemas"
      }
    },
    "connectorFields": {
      "extraParamField": {
        "authApiKey": "API-Schlüssel",
        "authBasic": "Einfache Authentifizierung",
        "configured": "konfiguriert",
        "engineMssql": "SQL Server",
        "engineMysql": "MySQL",
        "enginePostgres": "PostgreSQL",
        "payloadBase64Json": "Base64 JSON",
        "payloadBinary": "Binär",
        "provisioned": "Bereitgestellt",
        "schemeBolt": "bolt",
        "schemeBoltS": "bolt+s",
        "schemeNeo4j": "neo4j",
        "schemeNeo4jS": "neo4j+s",
        "serverless": "Serverless"
      },
      "extraParams": {
        "advancedLabel": "Erweiterte Optionen"
      },
      "scopeSelector": {
        "currentScope": "Aktueller Bereich: {{scope}}",
        "enableTenantNote": "Aktivieren Sie dies, um den Bereich auf den Mandanten-Modus zu ändern.",
        "projectDescription": "Nur innerhalb eines bestimmten Projekts verfügbar",
        "projectFieldLabel": "Projekt",
        "projectHint": "Dieser Connector ist nur innerhalb des ausgewählten Projekts verfügbar.",
        "projectLabel": "Projekt",
        "projectPlaceholder": "Projekt auswählen",
        "projectSearchPlaceholder": "Projekte suchen…",
        "tenantDescription": "Für alle Projekte in diesem Mandanten verfügbar",
        "tenantHint": "Dieser Connector ist für alle Projekte in diesem Mandanten verfügbar.",
        "tenantLabel": "Mandant",
        "tenantToggleLabel": "Mandanten-Bereich"
      },
      "shared": {
        "aihubSubscriptionKeySecretNameLabel": "Secret-Name für AI Hub-Abonnementschlüssel",
        "authHelp": {
          "awsDefault": "Geben Sie AWS-Anmeldeinformationen für diesen Connector an.",
          "awsKeyBoto": "AWS-Zugriffsschlüssel und Secret Key, verwendet über boto3.",
          "awsKeySql": "AWS-Zugriffsschlüssel und Secret Key zur Verbindung mit der Datenbank.",
          "awsWif": "Verwenden Sie AWS Workload Identity Federation anstelle langlebiger Zugriffsschlüssel.",
          "azureAiSearchKey": "Verbindung zu Azure AI Search über einen Admin-API-Schlüssel.",
          "azureAihub": "Verbindung über einen AI Hub-Abonnementschlüssel anstelle von Azure AD-Anmeldeinformationen.",
          "azureBlobKey": "Verbindung zu Azure Blob Storage über einen Kontoschlüssel.",
          "azureDocIntelligenceKey": "Verbindung zu Azure Document Intelligence über einen API-Schlüssel.",
          "azureKeyDefault": "Verbindung über einen Schlüssel oder eine Verbindungszeichenfolge.",
          "azureOboAiSearch": "Zugriff auf Azure AI Search im Namen des angemeldeten Benutzers (delegierte Authentifizierung).",
          "azureOboBlob": "Zugriff auf Azure Blob Storage im Namen des angemeldeten Benutzers (delegierte Authentifizierung).",
          "azureOboDefault": "Zugriff auf diese Ressource im Namen des angemeldeten Benutzers (delegierte Authentifizierung).",
          "azureOboDocIntelligence": "Zugriff auf Azure Document Intelligence im Namen des angemeldeten Benutzers (delegierte Authentifizierung).",
          "azureOboSharePoint": "Zugriff auf SharePoint im Namen des angemeldeten Benutzers (delegierte Authentifizierung).",
          "azureSharePointKey": "Verbindung zu SharePoint über ein Client-Secret.",
          "azureSpAiSearch": "Zugriff auf Azure AI Search in {brand} über ein registriertes Dienstprinzipal.",
          "azureSpBlob": "Zugriff auf Azure Blob Storage über ein registriertes Dienstprinzipal.",
          "azureSpDefault": "Zugriff auf diese Ressource in {brand} über ein registriertes Dienstprinzipal.",
          "azureSpDocIntelligence": "Zugriff auf Azure Document Intelligence in {brand} über ein registriertes Dienstprinzipal.",
          "azureSpRlsDeprecated": "Dieser Dienstprinzipal-Modus ist veraltet. Wechseln Sie zu einem unterstützten Authentifizierungsmodus.",
          "azureSpSharePoint": "Zugriff auf SharePoint über ein registriertes Dienstprinzipal.",
          "gcpDefault": "Geben Sie GCP-Anmeldeinformationen für diesen Connector an.",
          "gcpKey": "Verbindung über einen GCP-Dienstkontoschlüssel.",
          "gcpSaDefault": "Verbindung über ein GCP-Dienstkonto.",
          "gcpSaGcs": "Zugriff auf Google Cloud Storage über ein GCP-Dienstkonto.",
          "gcpSaRlsDeprecated": "Dieser Dienstkonto-Modus ist veraltet. Wechseln Sie zu einem unterstützten Authentifizierungsmodus.",
          "gcpWifDefault": "Verbindung über GCP Workload Identity Federation.",
          "gcpWifGcs": "Zugriff auf Google Cloud Storage über GCP Workload Identity Federation.",
          "oracleIamRequired": "Für diesen Oracle-Authentifizierungsmodus ist ein Cloud-IAM-Eintrag erforderlich.",
          "oracleUsernamePassword": "Verbindung über Oracle-Datenbank-Benutzername und -Passwort.",
          "oracleWallet": "Verbindung über ein Oracle-Wallet."
        },
        "authModeLabel": "Authentifizierungsmodus",
        "authModePlaceholder": "Authentifizierungsmodus auswählen",
        "databaseEngineHelpText": "Wählen Sie die zugrunde liegende Datenbank-Engine für diese Azure Managed SQL-Verbindung aus.",
        "databaseEngineLabel": "Datenbank-Engine",
        "databaseLabel": "Datenbank",
        "databaseUsernameEntraLabel": "Entra-Anzeigename",
        "descriptionLabel": "Beschreibung",
        "descriptionPlaceholder": "Optionale Beschreibung für diesen Connector",
        "displayNameLabel": "Anzeigename",
        "displayNamePlaceholder": "z. B. Produktionsdatenbank",
        "docIntelVerifySslHelpText": "Nur deaktivieren, wenn eine Verbindung zu einem Document Intelligence-Endpunkt mit einem selbstsignierten Zertifikat hergestellt wird.",
        "engineMysql": "MySQL",
        "enginePostgresql": "PostgreSQL",
        "engineSqlServer": "SQL Server",
        "entraDisplayNamePlaceholder": "z. B. john.doe@company.com",
        "entraUsernameHelpText": "Geben Sie den Entra ID-Anzeigenamen oder UPN für den Datenbankprinzipal ein.",
        "fromIamSuffix": "(aus Cloud IAM)",
        "iamEmptyWarning": {
          "awsBasicAuth": "Keine Cloud-IAM-Einträge für die einfache AWS-Authentifizierung gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren.",
          "awsIamUser": "Keine Cloud-IAM-Einträge für AWS IAM-Benutzer gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren.",
          "awsWif": "Keine Cloud-IAM-Einträge für AWS Workload Identity Federation gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren.",
          "azureBasicAuth": "Keine Cloud-IAM-Einträge für die einfache Azure-Authentifizierung gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren.",
          "azureBlobIamOnly": "Keine Cloud-IAM-Einträge für Azure Blob Storage gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren.",
          "azureBlobKey": "Keine Cloud-IAM-Einträge für Azure Blob Storage-Schlüssel gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren.",
          "azureServicePrincipal": "Keine Cloud-IAM-Einträge für Azure-Dienstprinzipale gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren.",
          "databricks": "Keine Databricks Cloud-IAM-Einträge gefunden. Fügen Sie ein persönliches Zugriffstoken hinzu, bevor Sie fortfahren.",
          "default": "Keine Cloud-IAM-Einträge gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren.",
          "gcp": "Keine GCP Cloud-IAM-Einträge gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren.",
          "gcpBasicAuth": "Keine Cloud-IAM-Einträge für die einfache GCP-Authentifizierung gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren.",
          "gcpServiceAccount": "Keine Cloud-IAM-Einträge für GCP-Dienstkonten gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren.",
          "tokenBasedOnprem": "Keine Cloud-IAM-Einträge für Zugriffstoken gefunden. Fügen Sie einen hinzu, bevor Sie fortfahren."
        },
        "iamHelp": {
          "awsAccessKeys": "Wählen Sie den Cloud-IAM-Eintrag mit Ihrem AWS-Zugriffsschlüssel und Secret Key aus.",
          "awsBasicAuth": "Wählen Sie den Cloud-IAM-Eintrag mit Ihren AWS-Datenbank-Anmeldeinformationen aus.",
          "awsWif": "Wählen Sie den für AWS Workload Identity Federation konfigurierten Cloud-IAM-Eintrag aus.",
          "azureBasicAuth": "Wählen Sie den Cloud-IAM-Eintrag mit Ihren Azure Basic Auth-Anmeldeinformationen aus.",
          "azureBlobIamOnly": "Wählen Sie den Cloud-IAM-Eintrag für den Zugriff auf Azure Blob Storage aus.",
          "azureBlobKey": "Wählen Sie den Cloud-IAM-Eintrag mit Ihrem Azure Blob Storage-Kontoschlüssel aus.",
          "azureServicePrincipal": "Wählen Sie den Cloud-IAM-Eintrag für das Azure-Dienstprinzipal aus.",
          "databricks": "Wählen Sie den Cloud-IAM-Eintrag mit Ihrem persönlichen Databricks-Zugriffstoken aus.",
          "default": "Wählen Sie einen Cloud-IAM-Eintrag für diesen Connector aus.",
          "gcp": "Wählen Sie den Cloud-IAM-Eintrag für diesen GCP-Connector aus.",
          "gcpBasicAuth": "Wählen Sie den Cloud-IAM-Eintrag mit Ihren GCP Basic Auth-Anmeldeinformationen aus.",
          "gcpServiceAccount": "Wählen Sie den Cloud-IAM-Eintrag mit Ihrem GCP-Dienstkontoschlüssel aus.",
          "gcpTokenMode": "Wählen Sie den Cloud-IAM-Eintrag aus, der zum Generieren von Zugriffstoken verwendet wird.",
          "gcpWif": "Wählen Sie den für GCP Workload Identity Federation konfigurierten Cloud-IAM-Eintrag aus.",
          "oracleOptional": "Wählen Sie optional einen Cloud-IAM-Eintrag aus, anstatt Anmeldeinformationen direkt einzugeben.",
          "oracleRequired": "Wählen Sie den für diesen Oracle-Authentifizierungsmodus erforderlichen Cloud-IAM-Eintrag aus.",
          "tokenBasedOnprem": "Wählen Sie den Cloud-IAM-Eintrag mit Ihrem Zugriffstoken aus."
        },
        "iamLabel": {
          "accessToken": "Zugriffstoken",
          "awsAccessKeys": "AWS-Zugriffsschlüssel",
          "awsBasicAuth": "AWS Basic Auth",
          "awsWif": "AWS Workload Identity Federation",
          "azureBasicAuth": "Azure Basic Auth",
          "azureBlobStorage": "Azure Blob Storage",
          "azureOrGraph": "Azure AD / Microsoft Graph",
          "azureServicePrincipal": "Azure-Dienstprinzipal",
          "azureStorage": "Azure Storage",
          "cloudIam": "Cloud IAM",
          "cloudIamOptional": "Cloud IAM (optional)",
          "databricksIam": "Databricks IAM (PAT oder Dienstprinzipal)",
          "databricksPat": "Databricks Personal Access Token",
          "gcp": "GCP Cloud IAM",
          "gcpBasicAuth": "GCP Basic Auth",
          "gcpServiceAccount": "GCP-Dienstkonto",
          "gcpWif": "GCP Workload Identity Federation"
        },
        "iamPlaceholder": {
          "accessToken": "Zugriffstoken auswählen",
          "awsAccessKeys": "AWS-Zugriffsschlüssel auswählen",
          "awsBasicAuth": "AWS Basic Auth-Anmeldeinformationen auswählen",
          "awsWif": "AWS Workload Identity Federation-Eintrag auswählen",
          "azureBasicAuth": "Azure Basic Auth-Anmeldeinformationen auswählen",
          "azureBlobIamOnly": "Azure Blob Storage Cloud-IAM-Eintrag auswählen",
          "azureBlobKey": "Azure Blob Storage-Schlüssel auswählen",
          "azureServicePrincipal": "Azure-Dienstprinzipal auswählen",
          "databricksIam": "Databricks-IAM-Eintrag auswählen (PAT oder Dienstprinzipal)",
          "databricksPat": "Databricks Personal Access Token auswählen",
          "default": "Cloud-IAM-Eintrag auswählen",
          "gcp": "GCP Cloud-IAM-Eintrag auswählen",
          "gcpBasicAuth": "GCP Basic Auth-Anmeldeinformationen auswählen",
          "gcpServiceAccount": "GCP-Dienstkonto auswählen",
          "gcpWif": "GCP Workload Identity Federation-Eintrag auswählen"
        },
        "loadingIamEntries": "Cloud-IAM-Einträge werden geladen…",
        "passwordSecretKeyNameOptionalLabel": "Secret-Key-Name für das Passwort (optional)",
        "portLabel": "Port",
        "schemaLabel": "Schema",
        "secretKeyNameLabel": "Secret-Key-Name",
        "secretKeyNamePlaceholder": "z. B. my-connector-password",
        "serverHostHelpMssql": "Geben Sie den SQL Server-Hostnamen ein, z. B. myserver.database.windows.net",
        "serverHostHelpMysql": "Geben Sie den MySQL-Hostnamen ein, z. B. myserver.mysql.database.azure.com",
        "serverHostHelpPostgres": "Geben Sie den PostgreSQL-Hostnamen ein, z. B. myserver.postgres.database.azure.com",
        "serverHostLabel": "Server-Host",
        "usernameLabel": "Benutzername"
      },
      "testSection": {
        "cancel": "Abbrechen",
        "connectionFailed": "Verbindung fehlgeschlagen",
        "connectionSuccessful": "Verbindung erfolgreich",
        "latency": "Latenz: {{ms}} ms",
        "subtitle": "Überprüfen Sie Ihre Verbindungseinstellungen vor dem Speichern",
        "testConnection": "Verbindung testen",
        "title": "Verbindung testen",
        "version": "Version: {{version}}"
      }
    },
    "connectorModal": {
      "aria": {
        "backToSelection": "Zurück zur Connector-Auswahl",
        "closeDialog": "Dialog schließen"
      },
      "buttons": {
        "addConnector": "Connector hinzufügen",
        "back": "Zurück",
        "cancel": "Abbrechen",
        "creating": "Wird erstellt…",
        "updateConnector": "Connector aktualisieren",
        "updating": "Wird aktualisiert…"
      },
      "connectorsLabel": "Connectors",
      "errors": {
        "aiHubSecretRequired": "Der Secret-Name für den AI Hub-Abonnementschlüssel ist erforderlich",
        "awsIamUserRequired": "Wählen Sie einen AWS IAM-Benutzer-Cloud-IAM-Eintrag aus",
        "awsWifIamRequired": "Wählen Sie einen Cloud-IAM-Eintrag für die AWS Workload Identity Federation aus",
        "azureBasicAuthIamRequired": "Wählen Sie einen Cloud-IAM-Eintrag für die einfache Azure-Authentifizierung aus",
        "azureBlobIamRequired": "Wählen Sie einen Cloud-IAM-Eintrag für Azure Blob Storage aus",
        "azureBlobIamRequiredFull": "Für den Zugriff auf Azure Blob Storage ist ein Cloud-IAM-Eintrag erforderlich",
        "azureSpIamRequiredObo": "Wählen Sie einen Cloud-IAM-Eintrag für den delegierten On-Behalf-Of-Zugriff aus",
        "azureSpIamRequiredSp": "Wählen Sie einen Cloud-IAM-Eintrag für das Azure-Dienstprinzipal aus",
        "cloudIamOrSecretRequired": "Geben Sie entweder einen Cloud-IAM-Eintrag oder einen Secret-Key-Namen an",
        "cloudIamRequired": "Ein Cloud-IAM-Eintrag ist erforderlich",
        "cloudIamRequiredForMode": "Für diesen Authentifizierungsmodus ist ein Cloud-IAM-Eintrag erforderlich",
        "displayNameRequired": "Anzeigename ist erforderlich",
        "fieldRequired": "{{field}} ist erforderlich",
        "gcpBasicAuthIamRequired": "Wählen Sie einen Cloud-IAM-Eintrag für die einfache GCP-Authentifizierung aus",
        "gcpServiceAccountIamRequired": "Wählen Sie einen Cloud-IAM-Eintrag für das GCP-Dienstkonto aus",
        "hostNoUnderscores": "Der Host darf keine Unterstriche enthalten",
        "nameAlreadyExists": "Ein Connector mit diesem Namen existiert bereits",
        "oracleCloudIamRequired": "Für diesen Oracle-Authentifizierungsmodus ist ein Cloud-IAM-Eintrag erforderlich",
        "oracleSecretOrIamRequired": "{{field}} ist erforderlich, oder wählen Sie einen Cloud-IAM-Eintrag aus",
        "portRange": "Der Port muss zwischen 1 und 65535 liegen",
        "projectRequired": "Wählen Sie ein Projekt aus",
        "provideCloudIamOrSecret": "Geben Sie vor dem Testen einen Cloud-IAM-Eintrag oder ein Secret an",
        "schemaRequired": "Schema ist erforderlich",
        "sharepointCredentialsRequired": "SharePoint-Anmeldeinformationen sind erforderlich",
        "testFailedCheckConfig": "Verbindungstest fehlgeschlagen. Überprüfen Sie Ihre Konfiguration und versuchen Sie es erneut.",
        "usernameRequired": "Benutzername ist erforderlich",
        "walletLocationRequired": "Der Wallet-Speicherort ist erforderlich"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "Secret-Name für AI Hub-Abonnementschlüssel",
        "awsIamUserCloudIamEntry": "AWS IAM-Benutzer Cloud-IAM-Eintrag",
        "awsWifCloudIamEntry": "AWS Workload Identity Federation Cloud-IAM-Eintrag",
        "azureBasicAuthIamRequired": "Azure Basic Auth Cloud-IAM-Eintrag",
        "azureBlobIamEntry": "Azure Blob Storage Cloud-IAM-Eintrag",
        "azureBlobIamRequiredForMode": "Azure Blob Storage Cloud-IAM-Eintrag",
        "azureSpIamObo": "Azure-Dienstprinzipal (On-Behalf-Of) Cloud-IAM-Eintrag",
        "azureSpIamSp": "Azure-Dienstprinzipal Cloud-IAM-Eintrag",
        "cloudIamEntry": "Cloud-IAM-Eintrag",
        "cloudIamOrPasswordSecretKeyName": "Cloud-IAM-Eintrag oder Secret-Key-Name für das Passwort",
        "connectorFallback": "Connector",
        "database": "Datenbank",
        "displayName": "Anzeigename",
        "gcpIamEntryBasicAuth": "GCP Basic Auth Cloud-IAM-Eintrag",
        "gcpIamEntryServiceAccount": "GCP-Dienstkonto Cloud-IAM-Eintrag",
        "host": "Host",
        "passwordSecretKeyName": "Secret-Key-Name für das Passwort",
        "project": "Projekt",
        "secretKeyName": "Secret-Key-Name",
        "sharepointCredentialsRequired": "SharePoint-Anmeldeinformationen",
        "walletLocation": "Wallet-Speicherort"
      },
      "loadingQuota": "Kontingent wird geladen…",
      "missingFieldsTitle": "Fehlende Pflichtfelder: {{fields}}",
      "requiredFieldsHint": "Fehlt: {{fields}}",
      "titles": {
        "configureConnector": "{{name}} konfigurieren",
        "editConnector": "Connector bearbeiten",
        "selectConnectorType": "Connector-Typ auswählen"
      },
      "toasts": {
        "createFailed": "Connector konnte nicht erstellt werden",
        "updateFailed": "Connector konnte nicht aktualisiert werden"
      }
    },
    "connectorSelectionGrid": {
      "categories": {
        "aws": "AWS",
        "azure": "Azure",
        "databricks": "Databricks",
        "gcp": "GCP",
        "onprem": "On-Prem",
        "orchestrators": "Orchestratoren",
        "snowflake": "Snowflake",
        "storage": "Speicher",
        "telephony": "Telefonie",
        "vectorDb": "Vektordatenbank"
      },
      "loading": "Connector-Typen werden geladen…"
    },
    "connectorViewModal": {
      "aria": {
        "backToSelection": "Zurück zur Connector-Auswahl",
        "closeDialog": "Dialog schließen"
      },
      "buttons": {
        "addConnector": "Connector hinzufügen",
        "back": "Zurück",
        "cancel": "Abbrechen",
        "close": "Schließen",
        "creating": "Wird erstellt…",
        "updateConnector": "Connector aktualisieren",
        "updating": "Wird aktualisiert…"
      },
      "connectorsLabel": "Connectors",
      "errors": {
        "aiHubSecretRequired": "Der Secret-Name für den AI Hub-Abonnementschlüssel ist erforderlich",
        "awsIamUserRequired": "Wählen Sie einen AWS IAM-Benutzer-Cloud-IAM-Eintrag aus",
        "awsWifIamRequired": "Wählen Sie einen Cloud-IAM-Eintrag für die AWS Workload Identity Federation aus",
        "azureBasicAuthIamRequired": "Wählen Sie einen Cloud-IAM-Eintrag für die einfache Azure-Authentifizierung aus",
        "azureBlobIamRequired": "Wählen Sie einen Cloud-IAM-Eintrag für Azure Blob Storage aus",
        "azureBlobIamRequiredFull": "Für den Zugriff auf Azure Blob Storage ist ein Cloud-IAM-Eintrag erforderlich",
        "azureSpIamRequiredObo": "Wählen Sie einen Cloud-IAM-Eintrag für den delegierten On-Behalf-Of-Zugriff aus",
        "azureSpIamRequiredSp": "Wählen Sie einen Cloud-IAM-Eintrag für das Azure-Dienstprinzipal aus",
        "cloudIamOrSecretRequired": "Geben Sie entweder einen Cloud-IAM-Eintrag oder einen Secret-Key-Namen an",
        "cloudIamRequired": "Ein Cloud-IAM-Eintrag ist erforderlich",
        "cloudIamRequiredForMode": "Für diesen Authentifizierungsmodus ist ein Cloud-IAM-Eintrag erforderlich",
        "displayNameRequired": "Anzeigename ist erforderlich",
        "fieldRequired": "{{field}} ist erforderlich",
        "gcpBasicAuthIamRequired": "Wählen Sie einen Cloud-IAM-Eintrag für die einfache GCP-Authentifizierung aus",
        "gcpServiceAccountIamRequired": "Wählen Sie einen Cloud-IAM-Eintrag für das GCP-Dienstkonto aus",
        "oracleCloudIamRequired": "Für diesen Oracle-Authentifizierungsmodus ist ein Cloud-IAM-Eintrag erforderlich",
        "oracleSecretOrIamRequired": "{{field}} ist erforderlich, oder wählen Sie einen Cloud-IAM-Eintrag aus",
        "portRange": "Der Port muss zwischen 1 und 65535 liegen",
        "provideCloudIamOrSecret": "Geben Sie vor dem Testen einen Cloud-IAM-Eintrag oder ein Secret an",
        "schemaRequired": "Schema ist erforderlich",
        "sharepointCredentialsRequired": "SharePoint-Anmeldeinformationen sind erforderlich",
        "testFailedCheckConfig": "Verbindungstest fehlgeschlagen. Überprüfen Sie Ihre Konfiguration und versuchen Sie es erneut.",
        "usernameRequired": "Benutzername ist erforderlich",
        "walletLocationRequired": "Der Wallet-Speicherort ist erforderlich"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "Secret-Name für AI Hub-Abonnementschlüssel",
        "awsIamUserCloudIamEntry": "AWS IAM-Benutzer Cloud-IAM-Eintrag",
        "awsWifCloudIamEntry": "AWS Workload Identity Federation Cloud-IAM-Eintrag",
        "azureBasicAuthIamRequired": "Azure Basic Auth Cloud-IAM-Eintrag",
        "azureBlobIamEntry": "Azure Blob Storage Cloud-IAM-Eintrag",
        "azureBlobIamRequiredForMode": "Azure Blob Storage Cloud-IAM-Eintrag",
        "azureSpIamObo": "Azure-Dienstprinzipal (On-Behalf-Of) Cloud-IAM-Eintrag",
        "azureSpIamSp": "Azure-Dienstprinzipal Cloud-IAM-Eintrag",
        "cloudIamEntry": "Cloud-IAM-Eintrag",
        "cloudIamOrPasswordSecretKeyName": "Cloud-IAM-Eintrag oder Secret-Key-Name für das Passwort",
        "connectorFallback": "Connector",
        "database": "Datenbank",
        "displayName": "Anzeigename",
        "gcpIamEntryBasicAuth": "GCP Basic Auth Cloud-IAM-Eintrag",
        "gcpIamEntryServiceAccount": "GCP-Dienstkonto Cloud-IAM-Eintrag",
        "host": "Host",
        "passwordSecretKeyName": "Secret-Key-Name für das Passwort",
        "secretKeyName": "Secret-Key-Name",
        "sharepointCredentialsRequired": "SharePoint-Anmeldeinformationen",
        "walletLocation": "Wallet-Speicherort"
      },
      "loadingQuota": "Kontingent wird geladen…",
      "missingFieldsTitle": "Fehlende Pflichtfelder: {{fields}}",
      "requiredFieldsHint": "Fehlt: {{fields}}",
      "titles": {
        "configureConnector": "{{name}} konfigurieren",
        "editConnector": "Connector bearbeiten",
        "selectConnectorType": "Connector-Typ auswählen",
        "viewConnection": "Verbindung anzeigen"
      },
      "toasts": {
        "createFailed": "Connector konnte nicht erstellt werden",
        "updateFailed": "Connector konnte nicht aktualisiert werden"
      }
    },
    "graphEvals": {
      "backToGraphAriaLabel": "Zurück zum Graphen",
      "cancel": "Abbrechen",
      "close": "Schließen",
      "columnConfidence": "Konfidenz",
      "columnDateTime": "Datum / Uhrzeit",
      "columnGrade": "Note",
      "columnReport": "Bericht",
      "columnSchema": "Schema",
      "columnSemantic": "Semantik",
      "columnStatus": "Status",
      "columnStructural": "Struktur",
      "confidenceMeta": "Konfidenz: {{value}}",
      "configModalAriaLabel": "Konfiguration der Bewertung",
      "derivationsDescFallback": "Führen Sie eine Bewertung aus, um zu sehen, wie die Qualitätsnote berechnet wird.",
      "download": "Herunterladen",
      "downloadReportTooltip": "Bericht als PDF herunterladen",
      "emptyRunsMessage": "Es wurden noch keine Bewertungen ausgeführt.",
      "entityCompletenessLabel": "Vollständigkeit der Entitäten",
      "gradeConfidenceSummary": "Note {{grade}} · {{confidence}} Konfidenz",
      "gradeErrorAbbreviation": "FEHLER",
      "hideFormulas": "Formeln ausblenden",
      "howScoresCalculatedTitle": "Wie die Werte berechnet werden",
      "latestScoresAriaLabel": "Neueste Qualitätswerte",
      "llmModelLabel": "LLM-Modell",
      "llmModelTooltip": "Modell zur Beurteilung der semantischen Kohärenz",
      "loadingEvaluations": "Bewertungen werden geladen …",
      "loadingModelsPlaceholder": "Modelle werden geladen …",
      "loadingReport": "Bericht wird geladen …",
      "missingGraphIdMessage": "Es wurde keine Graphtabelle angegeben.",
      "modelDefaultLabel": "{{name}} (Standard)",
      "noMatchingEvaluations": "Keine Bewertungen entsprechen Ihrer Suche.",
      "noReportAttachedMessage": "Diesem Lauf ist kein Bericht angehängt.",
      "noStructuralBreakdown": "Keine strukturelle Aufschlüsselung verfügbar.",
      "pageSubtitle": "Verlauf der Qualitätsbewertungen für {{name}}",
      "pageTitle": "Graph-Bewertungen",
      "pdfFrameTitle": "Validierungsbericht",
      "qualityGradeHelp": "Gesamtqualitätsnote, abgeleitet aus der gewichteten Mischung aus struktureller Gesundheit, Schemakonformität und semantischer Kohärenz.",
      "qualityGradeLabel": "Qualitätsnote",
      "refresh": "Aktualisieren",
      "relationshipRichnessLabel": "Beziehungsreichtum",
      "reportDownloadFailedMessage": "Der Bericht konnte nicht heruntergeladen werden.",
      "reportLoadFailedGeneric": "Bericht konnte nicht geladen werden",
      "reportLoadFailedMessage": "Die Berichtsdatei konnte nicht geladen werden.",
      "reportModalAriaLabel": "Validierungsbericht",
      "runEvaluationButton": "Bewertung ausführen",
      "runEvaluationDescription": "Wählen Sie aus, was validiert werden soll und wie viel des Graphen gesampelt wird.",
      "runEvaluationTitle": "Bewertung ausführen",
      "running": "Wird ausgeführt …",
      "runningEvaluation": "Bewertung läuft …",
      "sampleSizeLabel": "Stichprobengröße",
      "schemaConformanceDerivationHelp": "Wie der Schemakonformitätswert aus der Vollständigkeit von Entitäten und Beziehungen abgeleitet wird.",
      "schemaConformanceHelp": "Wie genau Entitäten und Beziehungen im Graphen dem registrierten Schema folgen.",
      "schemaConformanceLabel": "Schemakonformität",
      "schemaFormulaFallback": "Führen Sie eine Bewertung aus, um die Formel für die Schemakonformität zu sehen.",
      "schemaMetaFallback": "Noch keine Schemadaten",
      "schemaPartsFormula": "Entität {{entity}} × Beziehung {{relationship}} = {{result}}",
      "scopeAll": "Gesamter Graph",
      "scopeSample": "Stichprobe",
      "scoreDerivationsAriaLabel": "Wertableitungen",
      "searchEvaluationsPlaceholder": "Bewertungen durchsuchen …",
      "searchModelsPlaceholder": "Modelle durchsuchen …",
      "selectAtLeastOneTargetError": "Wählen Sie mindestens ein Validierungsziel aus.",
      "selectModelPlaceholder": "Modell auswählen",
      "semanticCoherenceCaveat": "Die semantische Kohärenz wird anhand einer Stichprobe beurteilt und spiegelt möglicherweise nicht den gesamten Graphen wider.",
      "semanticCoherenceDerivationHelp": "Wie der Wert für semantische Kohärenz aus den gesampelten Tripeln abgeleitet wird.",
      "semanticCoherenceHelp": "Ob Beziehungen im Graphen logisch und sachlich sinnvoll sind.",
      "semanticCoherenceLabel": "Semantische Kohärenz",
      "semanticFactScopeLegend": "Zu validierende Fakten",
      "semanticFormula": "{{coherent}} kohärent / {{sampled}} gesampelt = {{result}}",
      "semanticMetaCoherent": "{{coherent}} / {{sampled}} kohärent",
      "semanticMetaFallback": "Noch keine semantischen Daten",
      "semanticMetaSampled": "{{sampled}} von {{total}} gesampelt",
      "semanticMetaTotal": "{{total}} Tripel",
      "showFormulas": "Formeln anzeigen",
      "startEvaluation": "Bewertung starten",
      "structuralFormula": "Gewichteter Durchschnitt der Knoten-/Kanten-Integritätsprüfungen",
      "structuralHealthDerivationHelp": "Wie der Wert für strukturelle Gesundheit aus den zugrunde liegenden Integritätsprüfungen abgeleitet wird.",
      "structuralHealthHelp": "Strukturelle Integrität des Graphen — hängende Referenzen, verwaiste Knoten und fehlerhafte Kanten.",
      "structuralHealthLabel": "Strukturelle Gesundheit",
      "structuralMetaFallback": "Noch keine strukturellen Daten",
      "targetSchema": "Schemakonformität",
      "targetSemantic": "Semantische Kohärenz",
      "targetStructural": "Strukturelle Gesundheit",
      "validatingHint": "Dies kann je nach Größe des Graphen einige Minuten dauern.",
      "validationReportTitle": "Validierungsbericht",
      "validationTargetsLegend": "Validierungsziele",
      "view": "Anzeigen",
      "weightBitSchema": "Schema {{value}}",
      "weightBitSemantic": "Semantik {{value}}",
      "weightBitStructural": "Struktur {{value}}",
      "weightedMixSummary": "Gewichtete Mischung aus {{bits}} = {{confidence}} Konfidenz"
    },
    "graphApprovalSession": {
      "addToQueue": "Zur Warteschlange hinzufügen",
      "addTripletButton": "Tripel hinzufügen",
      "addTripletDescription": "Schlagen Sie ein neues Subjekt–Relation–Objekt-Tripel für diese Sitzung vor.",
      "addTripletTitle": "Tripel hinzufügen",
      "approve": "Genehmigen",
      "approveAll": "Alle genehmigen",
      "backToApprovalsAriaLabel": "Zurück zu den Genehmigungen",
      "cancel": "Abbrechen",
      "collapse": "Einklappen",
      "collapsePanelAriaLabel": "Prüfbereich einklappen",
      "collapseSchemaPanelAriaLabel": "Schemabereich einklappen",
      "collapseSchemaTooltip": "Schemabereich einklappen",
      "columnConfidence": "Konfidenz",
      "columnObject": "Objekt",
      "columnRelation": "Relation",
      "columnSubject": "Subjekt",
      "commit": "Übernehmen",
      "commitSuccessApplied": "Änderungen übernommen",
      "commitSuccessCounted_one": "{{count}} Entscheidung übernommen",
      "commitSuccessCounted_other": "{{count}} Entscheidungen übernommen",
      "committing": "Wird übernommen …",
      "confidenceRangeLabel": "Konfidenz (0–1)",
      "confidenceTooltip": "Konfidenz: {{value}}",
      "decisionRecorded": "Entscheidung erfasst.",
      "defaultSessionTitle": "Genehmigungssitzung",
      "emptyAllMessage": "Keine vorgeschlagenen Änderungen in dieser Sitzung.",
      "emptyFilteredMessage": "Keine {{kind}} entsprechen dem aktuellen Filter.",
      "entityNamePlaceholder": "Entitätsname",
      "expandPanelAriaLabel": "Prüfbereich erweitern",
      "expandSchemaPanelAriaLabel": "Schemabereich erweitern",
      "filterAll": "Alle",
      "filterEntities": "Entitäten",
      "filterProposedUpdatesAriaLabel": "Vorgeschlagene Aktualisierungen filtern",
      "filterTriplets": "Tripel",
      "graphCanvasAriaLabel": "Graph-Zeichenfläche",
      "legendConflict": "Konflikt",
      "legendExisting": "Vorhanden",
      "legendNew": "Neu",
      "missingIdsMessage": "Es wurde keine Tabelle oder Sitzung angegeben.",
      "modify": "Ändern",
      "modifySnapshotTitle": "Snapshot ändern",
      "noChangesStaged": "Keine Änderungen vorgemerkt",
      "noConfidenceScore": "Kein Konfidenzwert",
      "pendingBadge_one": "{{count}} ausstehend",
      "pendingBadge_other": "{{count}} ausstehend",
      "proposedUpdatesAriaLabel": "Vorgeschlagene Aktualisierungen",
      "proposedUpdatesTitle": "Vorgeschlagene Aktualisierungen",
      "refresh": "Aktualisieren",
      "refreshSessionTooltip": "Sitzung aktualisieren",
      "reject": "Ablehnen",
      "rejectAll": "Alle ablehnen",
      "relationPlaceholder": "Relationstyp",
      "reviewerNotePlaceholder": "Notiz hinzufügen (optional)",
      "schemaLabel": "Schema",
      "schemaSidebarAriaLabel": "Graphschema",
      "sessionContextAriaLabel": "Sitzungskontext",
      "sessionSummary": "{{total}} insgesamt · {{pending}} ausstehend",
      "showSchemaPanelAriaLabel": "Schemabereich anzeigen",
      "showSchemaTooltip": "Schemabereich anzeigen",
      "stageAllApproveTooltip": "Genehmigung für alle ausstehenden Elemente vormerken",
      "stageAllRejectTooltip": "Ablehnung für alle ausstehenden Elemente vormerken",
      "stageFilteredApproveTooltip_one": "Genehmigung für {{count}} sichtbares Element vormerken",
      "stageFilteredApproveTooltip_other": "Genehmigung für {{count}} sichtbare Elemente vormerken",
      "stageFilteredRejectTooltip_one": "Ablehnung für {{count}} sichtbares Element vormerken",
      "stageFilteredRejectTooltip_other": "Ablehnung für {{count}} sichtbare Elemente vormerken",
      "stageModification": "Änderung vormerken",
      "stagedApprove": "Genehmigen",
      "stagedCount_one": "{{count}} Änderung vorgemerkt",
      "stagedCount_other": "{{count}} Änderungen vorgemerkt",
      "stagedModify": "Ändern",
      "stagedReject": "Ablehnen",
      "unappliedCount_one": "{{count}} genehmigte Änderung noch nicht geschrieben",
      "unappliedCount_other": "{{count}} genehmigte Änderungen noch nicht geschrieben",
      "undo": "Rückgängig",
      "undoAll": "Alles rückgängig machen",
      "undoAllTooltip": "Alle vorgemerkten Entscheidungen verwerfen"
    },
    "graphApprovals": {
      "auditLog": "Prüfprotokoll",
      "auditTrailTitle": "Prüfpfad",
      "backToGraphAriaLabel": "Zurück zum Graphen",
      "columnAction": "Aktion",
      "columnActions": "Aktionen",
      "columnActor": "Akteur",
      "columnChangeRun": "Änderungslauf",
      "columnCommit": "Commit",
      "columnCreatedAt": "Erstellt",
      "columnCreatedBy": "Erstellt von",
      "columnMessage": "Nachricht",
      "columnMode": "Modus",
      "columnPending": "Ausstehend",
      "columnSource": "Quelle",
      "columnStatus": "Status",
      "columnTriplet": "Tripel",
      "columnUpdatedAt": "Aktualisiert",
      "columnVersion": "Version",
      "columnWhen": "Wann",
      "commitHistoryTitle": "Commit-Verlauf",
      "commits": "Commits",
      "emptyAuditMessage": "Noch keine Prüfeinträge.",
      "emptyCommitsMessage": "Noch keine Commits.",
      "emptyRunsMessage": "Noch keine Änderungsläufe.",
      "exportAuditAriaLabel": "Prüfprotokoll als CSV exportieren",
      "exportCsv": "CSV exportieren",
      "filterAll": "Alle",
      "filterModeLabel": "Modus",
      "filterStatusLabel": "Status",
      "footnoteText": "Genehmigte Änderungen werden in den Live-Graphen geschrieben. ",
      "hideAudit": "Prüfprotokoll ausblenden",
      "hideCommits": "Commits ausblenden",
      "missingTableIdMessage": "Es wurde keine Graphtabelle angegeben.",
      "modeApprovalRequired": "Genehmigung erforderlich",
      "modeBypassed": "Umgangen",
      "openLivePreview": "Live-Vorschau öffnen",
      "openSession": "Sitzung öffnen",
      "pageSubtitle": "Prüfwarteschlange für {{name}}",
      "pageTitle": "Graph-Genehmigungen",
      "refresh": "Aktualisieren",
      "review": "Prüfen",
      "runCount_one": "{{count}} Lauf",
      "runCount_other": "{{count}} Läufe",
      "searchAuditPlaceholder": "Prüfprotokoll durchsuchen …",
      "searchChangeRunsPlaceholder": "Änderungsläufe durchsuchen …",
      "searchCommitsPlaceholder": "Commits durchsuchen …",
      "statusApplied": "Angewendet",
      "statusAutoApplied": "Automatisch angewendet",
      "statusPartiallyApplied": "Teilweise angewendet",
      "statusPending": "Ausstehend",
      "statusRejected": "Abgelehnt",
      "systemActor": "System",
      "unknownUser": "Unbekannter Benutzer",
      "wholeRun": "Gesamter Lauf"
    },
    "graphTablePreview": {
      "addedInVersionLegend": "Hinzugefügt in v{{version}}",
      "alreadyThereLegend": "Bereits vorhanden",
      "askTheGraphDescription": "Stellen Sie eine Frage in natürlicher Sprache — sie wird in eine Graphabfrage umgewandelt.",
      "askTheGraphTitle": "Den Graphen fragen",
      "back": "Zurück",
      "backToDataAriaLabel": "Zurück zu Daten",
      "chatAssistantAriaLabel": "Graph-Chat-Assistent",
      "chatDisabledLabel": "Chat nicht verfügbar",
      "chatDisabledTooltip": "Für diesen Mandanten sind keine LLM-Modelle konfiguriert, daher ist der Graph-Chat nicht verfügbar.",
      "chatInputPlaceholder": "Stellen Sie eine Frage zu diesem Graphen …",
      "chatWelcomeMessage": "Stellen Sie mir eine Frage zu diesem Graphen, und ich frage ihn für Sie ab.",
      "collapse": "Einklappen",
      "collapseChatAriaLabel": "Chat einklappen",
      "commitLegendAriaLabel": "Legende der Commit-Version",
      "commitOptionPlain": "v{{version}}{{whenSuffix}}",
      "commitOptionWithMessage": "v{{version}} — {{message}}{{whenSuffix}}",
      "commitVersionPlaceholder": "Version auswählen",
      "couldNotBuildQueryMessage": "Daraus konnte keine Graphabfrage erstellt werden. Formulieren Sie Ihre Frage um.",
      "defaultGraphTitle": "Graph-Vorschau",
      "expandChatAriaLabel": "Chat erweitern",
      "graphCanvasAriaLabel": "Graph-Zeichenfläche",
      "graphContextAriaLabel": "Graphkontext",
      "graphSchemaAriaLabel": "Graphschema",
      "highlightingMatchesMessage": "{{nodesPart}} und {{relsPart}} werden hervorgehoben.",
      "latestLiveOption": "Neueste (live)",
      "matchedNodesPart_one": "{{count}} passender Knoten",
      "matchedNodesPart_other": "{{count}} passende Knoten",
      "matchedRelationshipsPart_one": "{{count}} passende Beziehung",
      "matchedRelationshipsPart_other": "{{count}} passende Beziehungen",
      "missingTableIdMessage": "Es wurde keine Graphtabelle angegeben.",
      "modelLabel": "Modell",
      "modelLabelLoading": "Modelle werden geladen …",
      "newestCommitMatchesLatestNotice": "Version {{version}} ist der neueste Commit, daher entspricht diese Ansicht dem Live-Graphen.",
      "noCommitStampsNotice": "Dieser Graph hat keine Commit-Versionsmarkierungen, daher kann keine Versionsfilterung angewendet werden.",
      "noModelsConfiguredPlaceholder": "Keine Modelle konfiguriert",
      "noNodesMatchedMessage": "Keine Knoten entsprachen Ihrer Frage.",
      "nothingToResetTooltip": "Nichts zurückzusetzen",
      "reset": "Zurücksetzen",
      "resetViewTooltip": "Auf die vollständige Graphansicht zurücksetzen",
      "schemaLabel": "Schema",
      "searchModelsPlaceholder": "Modelle durchsuchen …",
      "selectModelPlaceholder": "Modell auswählen",
      "send": "Senden",
      "showSchemaPanelAriaLabel": "Schemabereich anzeigen",
      "showSchemaTooltip": "Schemabereich anzeigen",
      "statusAsOfVersion": "Stand v{{version}}",
      "statusHighlighted": "Hervorgehoben",
      "statusSample": "Stichprobe",
      "thinking": "Denkt nach …",
      "unexpectedResponseMessage": "Diese Abfrage lieferte keine Graphdaten. Formulieren Sie Ihre Frage um.",
      "updatedGraphFallbackMessage": "Hier ist der aktualisierte Graph.",
      "viewCommitVersionTooltip": "Eine bestimmte Commit-Version anzeigen",
      "wrongTableTypeError": "Diese Tabelle ist keine Graphtabelle."
    },
    "graphSchemaPanel": {
      "collapseAriaLabel": "Schemabereich einklappen",
      "collapseTooltip": "Schemabereich einklappen",
      "defaultEngineName": "Graphdatenbank",
      "deselectAll": "Alle abwählen",
      "edgesLabel": "Kanten",
      "emptyLabelTooltip": "Keine {{label}}-Knoten in dieser Version",
      "engineLabel": "Engine",
      "graphDetailsTitle": "Graphdetails",
      "labelCountTooltip_one": "{{count}} {{label}}-Knoten",
      "labelCountTooltip_other": "{{count}} {{label}}-Knoten",
      "labelsTitle": "Labels",
      "nodesLabel": "Knoten",
      "notAvailable": "Nicht verfügbar",
      "relationshipsTitle_one": "Beziehungen ({{count}})",
      "relationshipsTitle_other": "Beziehungen ({{count}})",
      "schemaTitle": "Schema",
      "selectAll": "Alle auswählen",
      "selectLabelsEmptyState": "Wählen Sie mindestens ein Label aus, um dessen Beziehungen zu sehen.",
      "snapshotLabel": "Snapshot"
    },
    "graphWebglCanvas": {
      "layingOutGraphAriaLabel": "Graph wird angeordnet …"
    },
    "neo4jGraphView": {
      "canvasControlsAriaLabel": "Steuerelemente der Zeichenfläche",
      "clearSearchAriaLabel": "Suche löschen",
      "closeDetailsAriaLabel": "Details schließen",
      "closeDetailsKeepHighlightTooltip": "Schließen (Hervorhebung bleibt erhalten)",
      "closeDetailsTooltip": "Schließen",
      "fitToViewTooltip": "An Ansicht anpassen",
      "focusHintAfter": "um den Fokus zurückzusetzen.",
      "focusHintBefore": "Fokus auf einem Knoten — verwenden Sie",
      "genericNodeLabel": "Knoten",
      "hiddenPropertiesFoot_one": "{{count}} weitere Eigenschaft nicht angezeigt",
      "hiddenPropertiesFoot_other": "{{count}} weitere Eigenschaften nicht angezeigt",
      "lodHintDefault": "Zum Vergrößern hineinzoomen",
      "noMatchingNodes": "Keine passenden Knoten",
      "nodeDetailsAriaLabel": "Details zu {{name}}",
      "relationshipDetailsAriaLabel": "Beziehungsdetails",
      "resetFocusTooltip": "Fokus zurücksetzen",
      "searchAriaLabel": "Knoten durchsuchen",
      "searchPlaceholder": "Knoten durchsuchen …",
      "searchingEllipsis": "Suche läuft …",
      "zoomInTooltip": "Vergrößern",
      "zoomOutTooltip": "Verkleinern"
    },
    "vectorTab": {
      "actionDelete": "Löschen",
      "actionEdit": "Bearbeiten",
      "actionPreviewData": "Daten anzeigen",
      "actionRemoveAsDefault": "Als Standard entfernen",
      "actionSetAsDefault": "Als Standard festlegen",
      "actionSync": "Synchronisieren",
      "actionVectorSearch": "Vektorsuche",
      "actionViewDetails": "Details anzeigen",
      "addVectorDbTableButton": "Vektor-DB-Tabelle hinzufügen",
      "allLabel": "Alle",
      "andOthersLabel_one": "{{names}} und {{count}} weitere",
      "andOthersLabel_other": "{{names}} und {{count}} weitere",
      "bulkActionDeleteSelected": "Auswahl löschen",
      "bulkActionSyncMetadata": "Metadaten synchronisieren",
      "bulkDeletePartialWarning": "{{deleted}} gelöscht, {{skipped}} übersprungen: {{errors}}",
      "bulkDeleteSuccessToast_one": "{{count}} Tabelle gelöscht",
      "bulkDeleteSuccessToast_other": "{{count}} Tabellen gelöscht",
      "bulkSyncStartedRequeuedToast_one": "Metadatensynchronisierung für {{count}} Tabelle neu eingereiht",
      "bulkSyncStartedRequeuedToast_other": "Metadatensynchronisierung für {{count}} Tabellen neu eingereiht",
      "bulkSyncStartedToast_one": "Metadatensynchronisierung für {{count}} Tabelle gestartet",
      "bulkSyncStartedToast_other": "Metadatensynchronisierung für {{count}} Tabellen gestartet",
      "clearDefaultErrorToast": "{{name}} konnte nicht als Standard entfernt werden",
      "collectionViewTooltip": "Sammlungsansicht",
      "columnActions": "Aktionen",
      "columnCreator": "Ersteller",
      "columnDatabase": "Datenbank",
      "columnEmbeddingModel": "Embedding-Modell",
      "columnIntrospection": "Introspektion",
      "columnLogs": "Protokolle",
      "columnName": "Name",
      "columnStatus": "Status",
      "columnVectors": "Vektoren",
      "databaseViewTooltip": "Datenbankansicht",
      "defaultBadgeTooltip": "Standardtabelle",
      "defaultSchemaLabel": "Standard",
      "deleteConfirmLabel": "Löschen",
      "deleteNamespaceConfirmMessage_one": "Möchten Sie den Namespace {{schema}} und die darin registrierte {{count}} Tabelle wirklich löschen? Dies entfernt nur die {{brand}}-Metadaten und kann nicht rückgängig gemacht werden.",
      "deleteNamespaceConfirmMessage_other": "Möchten Sie den Namespace {{schema}} und die darin registrierten {{count}} Tabellen wirklich löschen? Dies entfernt nur die {{brand}}-Metadaten und kann nicht rückgängig gemacht werden.",
      "deleteNamespacePartialWarning": "{{deleted}} von {{schemaCount}} Namespaces gelöscht, {{skipped}} übersprungen",
      "deleteNamespaceSuccessToast_one": "Namespace gelöscht ({{count}} Tabelle entfernt)",
      "deleteNamespaceSuccessToast_other": "Namespace gelöscht ({{count}} Tabellen entfernt)",
      "deleteNamespaceSuccessToastNamed_one": "Namespace {{schema}} gelöscht ({{count}} Tabelle entfernt)",
      "deleteNamespaceSuccessToastNamed_other": "Namespace {{schema}} gelöscht ({{count}} Tabellen entfernt)",
      "deleteNamespaceTitle": "Namespace löschen",
      "deleteNamespacesConfirmMessage_one": "Möchten Sie {{namespaceCount}} Namespaces und die darin registrierte {{count}} Tabelle wirklich löschen? Dies entfernt nur die {{brand}}-Metadaten und kann nicht rückgängig gemacht werden.",
      "deleteNamespacesConfirmMessage_other": "Möchten Sie {{namespaceCount}} Namespaces und die darin registrierten {{count}} Tabellen wirklich löschen? Dies entfernt nur die {{brand}}-Metadaten und kann nicht rückgängig gemacht werden.",
      "deleteNamespacesCountLabel_one": "{{count}} Namespace löschen",
      "deleteNamespacesCountLabel_other": "{{count}} Namespaces löschen",
      "deleteNamespacesSuccessToast_one": "{{schemaCount}} Namespaces gelöscht ({{count}} Tabelle entfernt)",
      "deleteNamespacesSuccessToast_other": "{{schemaCount}} Namespaces gelöscht ({{count}} Tabellen entfernt)",
      "deleteNamespacesTitle": "Namespaces löschen",
      "deleteSelectedTablesConfirmMessage_one": "Möchten Sie die {{count}} ausgewählte Tabelle wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      "deleteSelectedTablesConfirmMessage_other": "Möchten Sie die {{count}} ausgewählten Tabellen wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      "deleteSelectedTablesTitle": "Ausgewählte Tabellen löschen",
      "deleteTableConfirmMessage": "Möchten Sie {{name}} wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      "deleteTableConfirmTitle": "Tabelle löschen",
      "deleteTablesCountLabel_one": "{{count}} Tabelle löschen",
      "deleteTablesCountLabel_other": "{{count}} Tabellen löschen",
      "deletingLabel": "Wird gelöscht…",
      "favoritesLabel": "Favoriten",
      "filterAllCreatorsPlaceholder": "Alle Ersteller",
      "filterAllEnginesPlaceholder": "Alle Engines",
      "filterCreatorLabel": "Ersteller",
      "filterEngineLabel": "Engine",
      "namespacesTitle": "Namespaces",
      "noConnectorsYet": "Noch keine Connectoren",
      "notConfigured": "Nicht konfiguriert",
      "setDefaultErrorToast": "{{name}} konnte nicht als Standard festgelegt werden",
      "syncMetadataErrorToast": "Metadaten für {{name}} konnten nicht synchronisiert werden",
      "syncStatus": {
        "active": "Aktiv",
        "failed": "Fehlgeschlagen",
        "inactive": "Inaktiv",
        "queued": "In Warteschlange",
        "running": "Läuft",
        "synced": "Synchronisiert"
      },
      "unknownConnectorType": "Unbekannt",
      "unknownCreator": "Unbekannt",
      "vectorDbExplorerAriaLabel": "Vektordatenbank-Explorer",
      "vectorTablesLeafTitle": "Vektortabellen",
      "vectorTablesLeafTitleWithSchema": "Vektortabellen — {{schema}}",
      "viewLink": "Anzeigen",
      "viewSyncLogsTooltip": "Sync-Protokolle anzeigen",
      "resourceVectorDatabases": "Vektordatenbanken",
      "resourceVectorDatabase": "Vektordatenbank"
    },
    "vectorSearchModal": {
      "advancedRagLabel": "Erweitertes RAG",
      "closeDialogAriaLabel": "Schließen",
      "contentLabel": "Inhalt",
      "coverageLabel": "Abdeckung",
      "embeddingModelLabel": "Embedding-Modell",
      "enhancementsLabel": "Erweiterungen",
      "foundResultsPrefix": "Gefunden:",
      "hideButton": "Ausblenden",
      "hydeEnhancementLabel": "HyDE (Hypothetical Document Embeddings)",
      "idFallbackLabel": "Ergebnis {{id}}",
      "latencyMs": "{{ms}} ms",
      "loadingOption": "Wird geladen…",
      "metadataLabel": "Metadaten",
      "missingAspectsLabel": "Fehlende Aspekte: {{aspects}}",
      "modelDefaultLabel": "{{name}} (Standard)",
      "modelLabel": "Modell: {{name}}",
      "modelsWordBold": "Modelle",
      "multiQueryExpansionLabel": "Multi-Query-Erweiterung",
      "noEmbeddingModelsOption": "Keine Embedding-Modelle verfügbar",
      "noModelRegisteredBody": "Um eine Vektorsuche für diese Tabelle auszuführen, registrieren Sie ein oder mehrere",
      "noModelRegisteredBold": "Kein Embedding-Modell registriert.",
      "noModelRegisteredSuffix": "für Embeddings oder wechseln Sie zu Advanced RAG.",
      "noResultsBasicHint": "Versuchen Sie eine andere Suchanfrage oder prüfen Sie Ihr Embedding-Modell.",
      "noResultsFoundTitle": "Keine Ergebnisse gefunden",
      "noResultsRagHint": "Formulieren Sie Ihre Anfrage um oder passen Sie die RAG-Strategie an.",
      "qualityLabel": "Qualität:",
      "ragSearchButton": "RAG-Suche",
      "ragSearchingButton": "Wird gesucht…",
      "ragStrategyConfigTitle": "RAG-Strategiekonfiguration",
      "registerModelFirstTooltip": "Registrieren Sie zuerst ein Embedding-Modell",
      "relevanceLabel": "Relevanz:",
      "rerankingLabel": "Reranking",
      "resultFallbackLabel": "Ergebnis {{index}}",
      "resultsInLatencyMiddle": "Ergebnisse in",
      "resultsLabel": "Ergebnisse:",
      "resultsSuffix": "Ergebnisse",
      "searchButton": "Suchen",
      "searchFailedTitle": "Suche fehlgeschlagen",
      "searchModelsPlaceholder": "Modelle suchen…",
      "searchPlaceholder": "Suchanfrage eingeben…",
      "searchingButton": "Wird gesucht…",
      "selfCorrectedBadge_one": "Selbstkorrigiert ({{count}} Versuch)",
      "selfCorrectedBadge_other": "Selbstkorrigiert ({{count}} Versuche)",
      "selfRagCorrectionLabel": "Self-RAG-Korrektur",
      "semanticSearchBody": "Geben Sie oben eine Anfrage ein, um die Vektor-Embeddings dieser Tabelle zu durchsuchen.",
      "semanticSearchTitle": "Semantische Suche",
      "settingsButton": "Einstellungen",
      "strategyAutoOption": "Automatisch",
      "strategyDecompositionOption": "Zerlegung",
      "strategyDescriptionAuto": "Wählt automatisch die beste Abrufstrategie für Ihre Anfrage.",
      "strategyDescriptionDecomposition": "Zerlegt komplexe Anfragen in Teilfragen und ruft für jede ab.",
      "strategyDescriptionDirect": "Sucht direkt mit dem unveränderten Anfragetext.",
      "strategyDescriptionHyde": "Erzeugt zunächst eine hypothetische Antwort und sucht dann mit deren Embedding.",
      "strategyDescriptionMultiQuery": "Erzeugt mehrere Anfragevarianten, um die Abdeckung zu verbreitern.",
      "strategyDirectOption": "Direkt",
      "strategyHydeOption": "HyDE",
      "strategyLabel": "Strategie",
      "strategyMultiQueryOption": "Multi-Query",
      "title": "Vektorsuche",
      "useDefaultOption": "Standard verwenden"
    },
    "storageTab": {
      "actionDelete": "Löschen",
      "actionExport": "Exportieren",
      "actionPreviewFiles": "Dateien anzeigen",
      "actionSetAsDefault": "Als Standard festlegen",
      "actionSync": "Synchronisieren",
      "actionSyncing": "Wird synchronisiert…",
      "actionViewDetails": "Details anzeigen",
      "addStorageButton": "Speicher hinzufügen",
      "allLabel": "Alle",
      "columnActions": "Aktionen",
      "columnConnector": "Connector",
      "columnContainer": "Container",
      "columnCreated": "Erstellt",
      "columnFolder": "Ordner",
      "columnLogs": "Protokolle",
      "columnStatus": "Status",
      "columnUpdated": "Aktualisiert",
      "defaultBadgeTooltip": "Standardordner",
      "defaultBucketLabel": "Standard",
      "defaultConnectorName": "Unbekannter Connector",
      "deleteConfirmLabel": "Löschen",
      "deleteConfirmMessage": "Möchten Sie {{name}} wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      "deleteConfirmTitle": "Speicherordner löschen",
      "emptyMessage": "Keine Speicherordner gefunden",
      "exportSelectedAction": "Auswahl exportieren",
      "favoritesLabel": "Favoriten",
      "filterAllCreatorsPlaceholder": "Alle Ersteller",
      "filterAllTypesPlaceholder": "Alle Typen",
      "filterCreatorLabel": "Ersteller",
      "filterStorageTypeLabel": "Speichertyp",
      "foldersLeafTitle": "Ordner",
      "foldersLeafTitleWithBucket": "Ordner — {{bucket}}",
      "listViewTooltip": "Listenansicht",
      "noConnectorsYet": "Noch keine Connectoren",
      "pendingBadge": "Ausstehend",
      "setDefaultErrorToast": "{{name}} konnte nicht als Standard festgelegt werden",
      "setDefaultSuccessToast": "{{name}} als Standard festgelegt",
      "splitViewTooltip": "Geteilte Ansicht",
      "statusActive": "Aktiv",
      "statusApproved": "Genehmigt",
      "statusRequested": "Angefragt",
      "statusUnknown": "Unbekannt",
      "storageExplorerAriaLabel": "Speicher-Explorer",
      "unknownConnectorType": "Unbekannt",
      "viewLink": "Anzeigen",
      "viewSyncLogsTooltip": "Sync-Protokolle anzeigen"
    },
    "storageViewModal": {
      "auditInformationSectionTitle": "Audit-Informationen",
      "basicInformationSectionTitle": "Grundlegende Informationen",
      "closeButton": "Schließen",
      "closeDialogAriaLabel": "Schließen",
      "errorInformationSectionTitle": "Fehlerinformationen",
      "fieldBucketName": "Bucket-Name",
      "fieldConnector": "Connector",
      "fieldCreatedAt": "Erstellt am",
      "fieldCreatedBy": "Erstellt von",
      "fieldErrorMessage": "Fehlermeldung",
      "fieldFileCount": "Dateianzahl",
      "fieldFolderPath": "Ordnerpfad",
      "fieldId": "ID",
      "fieldStatus": "Status",
      "fieldTotalSize": "Gesamtgröße",
      "fieldUpdatedAt": "Aktualisiert am",
      "fieldUpdatedBy": "Aktualisiert von",
      "metadataSectionTitle": "Metadaten",
      "noErrors": "Keine Fehler",
      "notAvailable": "N/V",
      "status": {
        "active": "Aktiv",
        "error": "Fehler",
        "syncing": "Wird synchronisiert",
        "unknown": "Unbekannt"
      },
      "storageInformationSectionTitle": "Speicherinformationen",
      "title": "Speicherordner-Details"
    },
    "storageFolderPreview": {
      "actionsTooltip": "Aktionen",
      "cancelButton": "Abbrechen",
      "clearSearchAriaLabel": "Suche löschen",
      "clearSelectionAriaLabel": "Auswahl aufheben",
      "closeDialogAriaLabel": "Schließen",
      "columnActions": "Aktionen",
      "columnModified": "Geändert",
      "columnName": "Name",
      "columnSize": "Größe",
      "columnType": "Typ",
      "downloadErrorToast": "Datei konnte nicht heruntergeladen werden",
      "downloadResultAllFailed": "Keine der ausgewählten Dateien konnte heruntergeladen werden.",
      "downloadResultAllSuccess": "Alle {{count}} Dateien wurden erfolgreich heruntergeladen.",
      "downloadResultOk": "OK",
      "downloadResultPartial": "{{successCount}} von {{total}} Dateien wurden erfolgreich heruntergeladen. Fehlgeschlagen: {{failedNames}}",
      "downloadResultTitleFailed": "Download fehlgeschlagen",
      "downloadResultTitlePartial": "Download unvollständig",
      "downloadResultTitleSuccess": "Download abgeschlossen",
      "downloadSelectedButton": "Auswahl herunterladen",
      "downloadSelectedTooltip": "Ausgewählte Dateien herunterladen",
      "downloadingSelectedButton": "Wird heruntergeladen…",
      "emptySearchState": "Keine Dateien entsprechen Ihrer Suche",
      "emptyState": "Dieser Ordner enthält keine Dateien",
      "exportAction": "Herunterladen",
      "firstPageTooltip": "Erste Seite",
      "lastPageTooltip": "Letzte Seite",
      "nextPageTooltip": "Nächste Seite",
      "openingFileLabel": "Datei wird geöffnet…",
      "paginationInfo": "{{from}}–{{to}} von {{total}} werden angezeigt",
      "previousPageTooltip": "Vorherige Seite",
      "searchPlaceholder": "Dateien suchen…",
      "selectAllAriaLabel": "Alle Dateien auswählen",
      "selectFileAriaLabel": "{{name}} auswählen",
      "selectedCount": "{{count}} ausgewählt",
      "selectionLimitWarning": "Sie können maximal 10 Dateien gleichzeitig auswählen.",
      "syncButtonLabel": "Synchronisieren",
      "syncButtonTooltip": "Dateien dieses Ordners synchronisieren",
      "syncingButtonLabel": "Wird synchronisiert…",
      "viewAction": "Vorschau"
    },
    "storageFilePreview": {
      "closeDialogAriaLabel": "Schließen",
      "downloadButton": "Herunterladen",
      "downloadErrorToast": "Datei konnte nicht heruntergeladen werden",
      "emptyTable": "Keine Zeilen zum Anzeigen",
      "imagePreviewAlt": "Bildvorschau",
      "loadErrorToast": "Dateivorschau fehlgeschlagen",
      "loadingDocument": "Dokument wird geladen…",
      "loadingPresentation": "Präsentation wird geladen…",
      "nullValueLabel": "NULL",
      "pdfPreviewTitle": "PDF-Vorschau",
      "pptxPreviewTitle": "PowerPoint-Vorschau",
      "rowsUnit": "Zeilen",
      "textPreviewAriaLabel": "Dateiinhalt",
      "tryAgainButton": "Erneut versuchen",
      "unableToLoadTitle": "Datei kann nicht angezeigt werden",
      "unsupportedHint": "Dieser Dateityp kann im Browser nicht angezeigt werden. Laden Sie die Datei herunter, um sie zu öffnen.",
      "unsupportedTitle": "Vorschau nicht verfügbar"
    },
    "groupedStorageView": {
      "bucketPathTooltip": "{{bucket}}/{{path}}",
      "createdTooltip": "Erstellt",
      "emptyState": "Keine Speicherordner gefunden",
      "emptyStateHint": "Versuchen Sie einen anderen Suchbegriff",
      "fileCount_one": "{{count}} Datei",
      "fileCount_other": "{{count}} Dateien",
      "folderCount_one": "{{count}} Ordner",
      "folderCount_other": "{{count}} Ordner",
      "loadingFolders": "Ordner werden geladen…",
      "unknownConnectorName": "Unbekannter Connector",
      "updatedTooltip": "Aktualisiert"
    },
    "metadataSyncLogsModal": {
      "bulkJobLabel": "Sammeljob",
      "closeAriaLabel": "Schließen",
      "collapseDetailAriaLabel": "Details einklappen",
      "columnMessage": "Meldung",
      "columnStatus": "Status",
      "columnWhen": "Zeitpunkt",
      "emptyState": "Keine Sync-Protokolle gefunden",
      "entryCount_one": "{{count}} Eintrag",
      "entryCount_other": "{{count}} Einträge",
      "expandDetailAriaLabel": "Details ausklappen",
      "loadingLogs": "Protokolle werden geladen…",
      "title": "Metadaten-Sync-Protokolle",
      "triggerLabel": "Auslöser:"
    },
    "bulkMetadataSyncModal": {
      "closeAriaLabel": "Schließen",
      "columnDetail": "Detail",
      "columnStatus": "Status",
      "columnTable": "Tabelle",
      "jobLabel": "Job",
      "loadingStatus": "Sync-Status wird geladen…",
      "noJobData": "Keine Jobdaten verfügbar",
      "requeuedToast_one": "{{count}} Eintrag zur Wiederholung eingereiht",
      "requeuedToast_other": "{{count}} Einträge zur Wiederholung eingereiht",
      "retryFailedButton_one": "{{count}} Fehlgeschlagenen wiederholen",
      "retryFailedButton_other": "{{count}} Fehlgeschlagene wiederholen",
      "title": "Bulk-Metadatensynchronisierung"
    },
    "tableDataPreview": {
      "loadErrorToast": "Tabellendaten konnten nicht geladen werden",
      "nullValueLabel": "NULL",
      "columnEdit": "Bearbeiten",
      "editGoldenAnswerAriaLabel": "Musterantwort bearbeiten",
      "csvExportedToast_other": "{{count}} Zeilen als CSV exportiert",
      "jsonExportedToast_other": "{{count}} Zeilen als JSON exportiert",
      "previewNotAvailable": "Für diese Datenquelle ist keine Vorschau verfügbar",
      "vertexAiDataStoreHint": "Diese Tabelle basiert auf einem Vertex-AI-Search-Datenspeicher. Rufen Sie die Vorschau ab, indem Sie den Datenspeicher direkt abfragen.",
      "vertexAiVectorSearchHint": "Diese Tabelle basiert auf einem Vertex-AI-Vector-Search-Index. Rufen Sie die Vorschau ab, indem Sie eine Vektorsuche ausführen.",
      "closeDialogAriaLabel": "Schließen",
      "unableToLoadTitle": "Daten konnten nicht geladen werden",
      "dataUnavailableTitle": "Keine Daten verfügbar",
      "syncingButton": "Wird synchronisiert…",
      "refreshMetadataButton": "Metadaten aktualisieren",
      "tryAgainButton": "Erneut versuchen",
      "documentsUnit": "Dokumente",
      "rowsUnit": "Zeilen",
      "elasticsearchSearchPlaceholder": "Mit Lucene-Abfragesyntax suchen…",
      "searchPlaceholder": "Suchen…",
      "clearSearchAriaLabel": "Suche löschen",
      "luceneQueryHintTitle": "Unterstützt Lucene-Abfragesyntax, z. B. feld:wert AND anderes:wert",
      "paginationFullTextSearchHint": "Die Volltextsuche wird auf alle Spalten angewendet",
      "tableViewTitle": "Tabellenansicht",
      "tableTab": "Tabelle",
      "graphViewTitle": "Diagrammansicht",
      "graphTab": "Diagramm",
      "documentViewJsonTitle": "Dokumentansicht (JSON)",
      "documentsTab": "Dokumente",
      "tabularViewTitle": "Tabellarische Ansicht",
      "exportJsonButton": "JSON exportieren",
      "exportingButton": "Wird exportiert…",
      "exportCsvButton": "CSV exportieren",
      "documentFallbackLabel": "Dokument {{index}}",
      "statusLabel": "Status: {{status}}",
      "hideJsonButton": "JSON ausblenden",
      "showJsonButton": "JSON anzeigen",
      "noPreviewFieldsHint": "Für dieses Dokument sind keine Vorschaufelder konfiguriert.",
      "pageOfLabel": "Seite {{page}} von {{totalPages}}",
      "pageSizeLabel": "Zeilen pro Seite",
      "previousButton": "Zurück",
      "nextButton": "Weiter",
      "noDataFoundEmptyMessage": "Keine Daten gefunden"
    },
    "ontology": {
      "retrievalConfigPanel": {
        "strategyAuto": "Automatisch",
        "strategyAutoDescription": "Wählt automatisch die beste Abrufstrategie basierend auf der Abfrage",
        "strategyVector": "Vektorsuche",
        "strategyVectorDescription": "Ergebnisse mittels semantischer Ähnlichkeitssuche über Embeddings abrufen",
        "strategySql": "SQL",
        "strategySqlDescription": "Ergebnisse durch Generieren und Ausführen von SQL-Abfragen gegen die Tabelle abrufen",
        "strategyHybrid": "Hybrid",
        "strategyHybridDescription": "Vektorsuche und Schlüsselwort-/SQL-Suche für genauere Ergebnisse kombinieren",
        "fusionMethodRrf": "Reciprocal Rank Fusion",
        "fusionMethodRrfDescription": "Kombiniert Ranglisten mittels Reciprocal Rank Fusion",
        "fusionMethodWeighted": "Gewichtete Summe",
        "fusionMethodWeightedDescription": "Kombiniert Bewertungen durch eine gewichtete Summe aus Vektor- und Schlüsselwortergebnissen",
        "fusionMethodCascade": "Kaskade",
        "fusionMethodCascadeDescription": "Führt zuerst eine Schlüsselwortsuche aus und ordnet dann mit Vektorsuche neu",
        "distanceMetricCosine": "Kosinus",
        "distanceMetricEuclidean": "Euklidisch",
        "distanceMetricDotProduct": "Skalarprodukt",
        "title": "Abrufkonfiguration",
        "resetToDefaultsTitle": "Auf Standardwerte zurücksetzen",
        "resetButton": "Zurücksetzen",
        "defaultStrategyLabel": "Standard-Abrufstrategie",
        "vectorSearchSettingsLabel": "Vektorsucheinstellungen",
        "idColumnLabel": "ID-Spalte",
        "autoDetectOption": "Automatisch erkennen",
        "contentColumnLabel": "Inhaltsspalte",
        "embeddingColumnLabel": "Embedding-Spalte",
        "distanceMetricLabel": "Distanzmetrik",
        "hybridFusionSettingsLabel": "Hybrid-Fusion-Einstellungen",
        "fusionMethodLabel": "Fusionsmethode",
        "weightDistributionLabel": "Gewichtungsverteilung",
        "vectorSliderLabel": "Vektorgewicht",
        "keywordSliderLabel": "Schlüsselwortgewicht",
        "sqlSettingsLabel": "SQL-Einstellungen",
        "maxRowsLabel": "Maximale Anzahl zurückgegebener Zeilen",
        "enableFullTextSearchLabel": "Volltextsuche aktivieren",
        "rerankingLabel": "Reranking",
        "enableCrossEncoderRerankingLabel": "Cross-Encoder-Reranking aktivieren",
        "rerankingModelLabel": "Reranking-Modell",
        "loadingModelsOption": "Modelle werden geladen…",
        "noRegisteredModelsOption": "Keine registrierten Modelle",
        "rerankTopKLabel": "Rerank Top K",
        "infoCardText": "Diese Einstellungen steuern, wie diese Tabelle bei RAG-Abfragen abgerufen wird. Änderungen gelten bei der nächsten Abfrage dieser Tabelle."
      },
      "columnEditor": {
        "semanticTypeId": "Kennung",
        "semanticTypeIdDescription": "Identifiziert einen Datensatz eindeutig (z. B. Primärschlüssel)",
        "semanticTypeEntity": "Entität",
        "semanticTypeEntityDescription": "Bezieht sich auf eine benannte Person, einen Ort oder eine Sache",
        "semanticTypeMetric": "Kennzahl",
        "semanticTypeMetricDescription": "Ein numerischer Wert für Aggregation oder Messung",
        "semanticTypeDimension": "Dimension",
        "semanticTypeDimensionDescription": "Ein kategoriales Attribut zur Gruppierung oder Filterung",
        "semanticTypeTimestamp": "Zeitstempel",
        "semanticTypeTimestampDescription": "Ein Datums- oder Zeitwert",
        "semanticTypeText": "Text",
        "semanticTypeTextDescription": "Freier Textinhalt",
        "closeEditorTitle": "Editor schließen",
        "businessNameLabel": "Geschäftsname",
        "businessNameHint": "Ein benutzerfreundlicher Name für diese Spalte",
        "businessNamePlaceholder": "z. B. Kundenname",
        "descriptionLabel": "Beschreibung",
        "descriptionHint": "Erklären Sie, wofür diese Spalte steht",
        "descriptionPlaceholder": "z. B. Der vollständige rechtliche Name des Kunden",
        "semanticTypeLabel": "Semantischer Typ",
        "semanticTypeHint": "Klassifizieren Sie, welche Art von Daten diese Spalte enthält",
        "exampleValuesLabel": "Beispielwerte",
        "exampleValuesHint": "Beispielwerte, die anderen helfen, diese Spalte zu verstehen",
        "addExamplePlaceholder": "Beispielwert hinzufügen",
        "constraintsLabel": "Einschränkungen",
        "constraintsHint": "Geschäftsregeln oder Validierungseinschränkungen für diese Spalte",
        "constraintsPlaceholder": "z. B. Darf nicht leer sein",
        "relationshipsLabel": "Beziehungen",
        "relationshipsHint": "Andere Tabellen oder Spalten, mit denen diese Spalte in Beziehung steht",
        "tableNamePlaceholder": "Tabellenname",
        "columnNamePlaceholder": "Spaltenname",
        "relationshipTypeForeignKey": "Fremdschlüssel",
        "relationshipTypeReference": "Referenz",
        "addRelationshipButton": "Beziehung hinzufügen",
        "searchSettingsLabel": "Sucheinstellungen",
        "searchSettingsHint": "Steuern Sie, wie diese Spalte bei Suche und Abruf verwendet wird",
        "searchableLabel": "Durchsuchbar",
        "searchableHint": "Diese Spalte in die Volltext- und Schlüsselwortsuche einbeziehen",
        "embedForVectorSearchLabel": "Für Vektorsuche einbetten",
        "embedForVectorSearchHint": "Embeddings für diese Spalte erzeugen, um die semantische Suche zu unterstützen"
      },
      "tableDescriptionEditor": {
        "tablePurposeLabel": "Zweck der Tabelle",
        "tablePurposeHelp": "Beschreiben Sie, wofür diese Tabelle verwendet wird",
        "tablePurposePlaceholder": "z. B. Speichert die Bestellhistorie von Kunden für Berichte",
        "businessContextLabel": "Geschäftskontext",
        "businessContextHelp": "Erklären Sie den Geschäftskontext und wie diese Tabelle in das größere Datenmodell passt",
        "businessContextPlaceholder": "z. B. Wird vom Vertriebsteam zur Nachverfolgung der Auftragsabwicklung verwendet",
        "sampleQuestionsLabel": "Beispielfragen",
        "sampleQuestionsHelp": "Beispielfragen, die diese Tabelle beantworten helfen kann",
        "removeQuestionTitle": "Frage entfernen",
        "addQuestionPlaceholder": "Beispielfrage hinzufügen",
        "addQuestionTitle": "Frage hinzufügen",
        "addButton": "Hinzufügen",
        "tipsTitle": "Tipps",
        "tip1": "Beschreiben Sie genau, was die Tabelle enthält und wer sie nutzt.",
        "tip2": "Fügen Sie Geschäftsbegriffe hinzu, nach denen Nutzer suchen könnten.",
        "tip3": "Fügen Sie Beispielfragen hinzu, damit das Abrufmodell relevante Anfragen besser zuordnen kann.",
        "tip4": "Halten Sie Beschreibungen kurz, aber informativ."
      },
      "schemaVisualizer": {
        "semanticTypeId": "Kennung",
        "semanticTypeTimestamp": "Zeitstempel",
        "semanticTypeMetric": "Kennzahl",
        "semanticTypeDimension": "Dimension",
        "semanticTypeEntity": "Entität",
        "semanticTypeText": "Text",
        "groupPrimaryKeys": "Primärschlüssel",
        "groupForeignKeys": "Fremdschlüssel",
        "groupTimestamps": "Zeitstempel",
        "groupMetrics": "Kennzahlen",
        "groupDimensions": "Dimensionen",
        "groupOther": "Sonstige",
        "subtitle": "Visuelle Übersicht der Tabellenspalten und ihrer Beziehungen",
        "columnCount": "{{count}} Spalte",
        "columnCount_other": "{{count}} Spalten",
        "hasOntologyLegend": "Ontologie definiert",
        "foreignKeyLegend": "Fremdschlüssel"
      }
    },
    "tableOntologyPage": {
      "noTableIdError": "Es wurde keine Tabellen-ID angegeben",
      "saveSuccessToast": "Ontologie erfolgreich gespeichert",
      "saveErrorToast": "Ontologie konnte nicht gespeichert werden: {{message}}",
      "unsavedChangesConfirm": "Sie haben nicht gespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?",
      "loadingMessage": "Tabellenontologie wird geladen…",
      "schemaEditorUnavailableTitle": "Schema-Editor nicht verfügbar",
      "schemaEditorUnavailableMessage": "Der Schema-Editor ist für den Connector-Typ dieser Tabelle nicht verfügbar.",
      "failedToLoadTitle": "Tabelle konnte nicht geladen werden",
      "tableNotFoundMessage": "Die angeforderte Tabelle wurde nicht gefunden.",
      "goBack": "Zurück",
      "backToKnowledgeTooltip": "Zurück zu Knowledge",
      "breadcrumbKnowledge": "Knowledge",
      "breadcrumbTables": "Tabellen",
      "breadcrumbOntology": "Ontologie",
      "vectorBadge": "Vektor",
      "unsavedChangesBadge": "Nicht gespeicherte Änderungen",
      "resetToSavedTooltip": "Auf zuletzt gespeicherte Version zurücksetzen",
      "reset": "Zurücksetzen",
      "saving": "Wird gespeichert…",
      "saveChanges": "Änderungen speichern",
      "schemaPanelTitle": "Schema",
      "databaseLabel": "Datenbank",
      "schemaLabel": "Schema",
      "tableLabel": "Tabelle",
      "rowsLabel": "Zeilen",
      "embeddingModelTitle": "Embedding-Modell",
      "loadingModels": "Modelle werden geladen…",
      "noEmbeddingModelsWarning": "Es sind keine Embedding-Modelle registriert. Registrieren Sie eines, um die Vektorsuche für diese Tabelle zu aktivieren.",
      "selectModelOption": "Modell auswählen",
      "modelOptionDefaultLabel": "{{name}} (Standard)",
      "modelOptionLabel": "{{name}}",
      "noModelSelectedWarning": "Kein Embedding-Modell ausgewählt. Die Vektorsuche ist für diese Tabelle nicht verfügbar.",
      "columnsHeader": "Spalten",
      "hasOntologyDefinedTooltip": "Ontologie für diese Spalte definiert",
      "tabDescription": "Beschreibung",
      "tabRetrieval": "Abruf",
      "tabTest": "Test",
      "queryTestingTitle": "Abfragetest",
      "queryTestingDescription": "Testen Sie, wie Abfragen anhand der Konfiguration dieser Tabelle abgerufen werden.",
      "comingSoon": "Demnächst verfügbar"
    },
    "mongoCompassDocumentView": {
      "documentViewTitle": "Dokumentansicht",
      "documentsTab": "Dokumente",
      "tabularViewTitle": "Tabellarische Ansicht",
      "tableTab": "Tabelle",
      "exportDataButton": "Daten exportieren",
      "closeAriaLabel": "Schließen",
      "filterLabel": "Filter",
      "filterPlaceholder": "z. B. { status: \"active\" }",
      "filterInputAriaLabel": "Filterabfrage",
      "clearFilterAriaLabel": "Filter löschen",
      "applyFilterTitle": "Filter anwenden",
      "findButton": "Suchen",
      "queryHint": "Geben Sie einen MongoDB-Abfragefilter als JSON ein",
      "documentCountLabel": "{{count}} Dokument",
      "documentCountLabel_other": "{{count}} Dokumente",
      "zeroResults": "Keine Ergebnisse",
      "pageRangeHint": "{{from}}–{{to}} von {{total}}",
      "documentFallbackLabel": "Dokument {{index}}",
      "hideDocumentAriaLabel": "Dokument ausblenden",
      "showDocumentAriaLabel": "Dokument anzeigen",
      "skipLimitLabel": "Übersprungen: {{skip}}, Limit: {{limit}}",
      "pageSizeLabel": "Seitengröße",
      "pageSizeSelectAriaLabel": "Seitengröße auswählen",
      "previousButton": "Zurück",
      "nextButton": "Weiter"
    }
  },
  "accessRequests": {
    "manageAccessTitle": "{{assetLabel}}-Zugriff verwalten",
    "assetTypeLabels": {
      "models": "Modelle",
      "tools": "Tools",
      "knowledge": "Wissen",
      "storage": "Speicher",
      "skills": "Skills",
      "orchestrators": "Orchestratoren",
      "default": "Assets"
    },
    "statusLabels": {
      "requested": "Ausstehend",
      "approved": "Genehmigt",
      "open": "Widerrufen"
    },
    "loadingRequests": "Zugriffsanfragen werden geladen...",
    "clearSearch": "Suche löschen",
    "emptyStateAll": "Keine Zugriffsanfragen für {{assetType}}.",
    "emptyStateFiltered": "Keine {{status}}en Zugriffsanfragen für {{assetType}}.",
    "selectedCount": "{{count}} ausgewählt",
    "selectAll": "Alle auswählen",
    "deselectAll": "Alle abwählen",
    "approveSelected": "Auswahl genehmigen ({{count}})",
    "rejectSelected": "Auswahl ablehnen ({{count}})",
    "columnAssetName": "Asset-Name",
    "columnProject": "Projekt",
    "columnRequestedBy": "Angefordert von",
    "columnStatus": "Status",
    "columnCreated": "Erstellt",
    "columnLastUpdated": "Zuletzt aktualisiert",
    "columnActions": "Aktionen",
    "approve": "Genehmigen",
    "reject": "Ablehnen",
    "reApprove": "Erneut genehmigen",
    "revokeAccess": "Zugriff widerrufen",
    "rowsPerPage": "Zeilen pro Seite:",
    "showingRange": "{{start}}-{{end}} von {{total}} werden angezeigt",
    "goToFirstPage": "Zur ersten Seite gehen",
    "goToPreviousPage": "Zur vorherigen Seite gehen",
    "goToPage": "Zu Seite {{page}} gehen",
    "goToNextPage": "Zur nächsten Seite gehen",
    "goToLastPage": "Zur letzten Seite gehen",
    "firstPage": "Erste Seite",
    "previousPage": "Vorherige Seite",
    "nextPage": "Nächste Seite",
    "lastPage": "Letzte Seite",
    "endOfTableReached": "Ende der Tabelle erreicht",
    "statusFilterLabel": "Status",
    "statusFilterPlaceholder": "Status",
    "projectFilterLabel": "Projekt",
    "projectFilterPlaceholder": "Projekt",
    "requestedByFilterLabel": "Angefordert von",
    "requestedByFilterPlaceholder": "Angefordert von",
    "bulkApprovePartial": "{{processed}} genehmigt; {{skipped}} fehlgeschlagen: {{errors}}",
    "bulkRejectPartial": "{{processed}} abgelehnt; {{skipped}} fehlgeschlagen: {{errors}}"
  },
  "skills": {
    "title": "Fähigkeiten (Skills)",
    "subtitle": "Fähigkeiten sind modulare Anweisungspakete, die die Fähigkeiten von Agenten erweitern.",
    "list": {
      "columns": {
        "name": "Name der Fähigkeit",
        "category": "Kategorie",
        "type": "Typ",
        "model": "Modell",
        "visibility": "Sichtbarkeit",
        "version": "Version",
        "access": "Zugriff",
        "updated": "Aktualisiert",
        "actions": "Aktionen"
      },
      "actions": {
        "view": "Anzeigen",
        "edit": "Bearbeiten",
        "delete": "Löschen",
        "export": "Exportieren",
        "clone": "In Projekt klonen",
        "manageAccess": "Zugriff verwalten",
        "exportSelected": "Ausgewählte exportieren",
        "deleteSelected": "Ausgewählte löschen"
      },
      "badges": {
        "builtin": "Integriert",
        "platform": "Plattform",
        "allModels": "Alle Modelle"
      },
      "bulkDelete": {
        "title": "Ausgewählte Fähigkeiten löschen",
        "noSelection": "Keine Fähigkeiten ausgewählt",
        "cannotDeleteBuiltin": "Integrierte Plattform-Fähigkeiten können nicht gelöscht werden",
        "skippedBuiltin": "{{count}} integrierte Fähigkeit(en) wird/werden übersprungen.",
        "success": "{{count}} Fähigkeit(en) erfolgreich gelöscht",
        "partial": "{{deleted}} Fähigkeit(en) gelöscht, {{skipped}} fehlgeschlagen: {{errors}}",
        "error": "Löschen der Fähigkeiten fehlgeschlagen"
      }
    },
    "categories": {
      "data_processing": "Datenverarbeitung",
      "data_analysis": "Datenanalyse",
      "reasoning": "Schlussfolgern",
      "code_generation": "Code-Generierung",
      "document_analysis": "Dokumentenanalyse",
      "web_interaction": "Web-Interaktion",
      "communication": "Kommunikation",
      "research": "Recherche",
      "automation": "Automatisierung",
      "custom": "Benutzerdefiniert"
    },
    "types": {
      "behavioral": "Verhalten",
      "procedural": "Prozedural",
      "knowledge": "Wissen",
      "guardrail": "Leitplanke",
      "custom": "Benutzerdefiniert"
    },
    "visibility": {
      "project": "Projekt",
      "tenant": "Organisation",
      "public": "Plattform"
    },
    "filters": {
      "category": "Kategorie",
      "type": "Typ",
      "visibility": "Sichtbarkeit",
      "project": "Projekt",
      "all": "Alle",
      "favorites": "Favoriten"
    },
    "newSkill": "Neue Fähigkeit",
    "loading": "Fähigkeiten werden geladen...",
    "empty": {
      "message": "Keine Fähigkeiten gefunden. Erstellen Sie Ihre erste Fähigkeit, um die Agentenfunktionen zu erweitern."
    },
    "delete": {
      "title": "Fähigkeit löschen",
      "message": "Sind Sie sicher, dass Sie \"{{name}}\" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
      "bulkMessage": "Sind Sie sicher, dass Sie {{count}} Fähigkeit(en) löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
      "bulkConfirm": "{{count}} Fähigkeit(en) löschen",
      "bulkDepsOthers": "{{names}} und {{count}} weitere"
    },
    "messages": {
      "dependencyCheckFailed": "Überprüfung der Abhängigkeiten fehlgeschlagen",
      "deleteFailed": "Löschen der Fähigkeit fehlgeschlagen"
    },
    "edit": {
      "subtitle": {
        "new": "Modulare Funktion erstellen",
        "readonly": "Skill-Konfiguration (Schreibgeschützt)",
        "edit": "Skill-Konfiguration bearbeiten"
      },
      "sidebar": {
        "settings": "Skill-Einstellungen",
        "tags": "Tags",
        "loadingQuota": "Kontingent wird geladen..."
      },
      "placeholders": {
        "name": "Skill-Name",
        "description": "Kurze Beschreibung der Funktion dieses Skills",
        "instructions": "# Skill-Anweisungen\nBeschreiben Sie die spezifische Funktion, die dieser Skill bietet.\n\n## Grundregeln\n1. Definieren Sie das Verhalten des Agenten\n2. Listen Sie schrittweise Verfahren auf\n3. Geben Sie eventuelle Einschränkungen an\n\n## Beispiele\nStellen Sie Beispiele für die erwartete Ausgabe bereit...",
        "project": "Projekt auswählen",
        "modelAgnostic": "Modellunabhängig (alle Modelle)"
      },
      "hints": {
        "targetModel": "Markieren Sie diesen Skill optional für ein bestimmtes Modell. Nicht markierte Skills sind mit allen Modellen kompatibel.",
        "visibilityProject": "Der Skill ist nur für das ausgewählte Projekt verfügbar.",
        "visibilityPlatform": "Der Skill ist über einen Genehmigungsworkflow für alle Projekte verfügbar."
      },
      "editor": {
        "instructions": "Anweisungen (SKILL.md)",
        "markdownSupported": "Markdown unterstützt",
        "noInstructions": "Noch keine Anweisungen zur Vorschau vorhanden."
      },
      "header": {
        "quotaExceeded": "Skill-Kontingent überschritten",
        "createSkill": "Skill erstellen",
        "saveChanges": "Änderungen speichern"
      }
    }
  },
  "agentAutoTune": {
    "meta": {
      "breadcrumb": "Brotkrümelnavigation",
      "agentStudio": "Agent Studio",
      "autoTuneRunsList": "Auto-Tune Ausführungsliste",
      "metaDashboard": "Meta-Dashboard"
    },
    "compare": {
      "phaseStep": "Phase / Schritt",
      "score": "Punktzahl",
      "metric": "Metrik",
      "baselineScore": "Basis-Punktzahl",
      "optimizedScore": "Optimierte Punktzahl",
      "improvementPct": "Verbesserung %",
      "holdoutScore": "Holdout-Punktzahl",
      "costUsd": "Kosten (USD)",
      "iterations": "Iterationen",
      "nodesOptimized": "Optimierte Knoten",
      "nodesTotal": "Knoten gesamt",
      "version": "Version",
      "node": "Knoten",
      "loadingSessions": "Sitzungen zum Vergleich laden...",
      "selectSessions": "Wählen Sie mindestens 2 Sitzungen zum Vergleichen.",
      "backToRuns": "Zurück zu Ausführungen",
      "runComparisonTitle": "Ausführungsvergleich",
      "comparingSessions": "Vergleiche {{count}} Auto-Tune-Sitzungen",
      "summaryComparison": "Zusammenfassender Vergleich",
      "noDataToCompare": "Keine Daten zum Vergleichen",
      "scoreTrajectoryOverlay": "Punktzahl-Verlauf überlagert",
      "comparingRuns": "Ausführungen vergleichen",
      "chartExplainer1": "nicht für die Zuweisung auf Knotenebene. Die Serien sind mit Lücken gefüllt.",
      "chartExplainer2": "Die Verlaufslängen stimmen nach Index überein.",
      "labelsMatch": "Etiketten entsprechen der längsten Sitzung",
      "phasesBaseline": "Phasen, sodass Baseline /",
      "validationLinesUp": "Validierung über Ausführungen hinweg übereinstimmt.",
      "notEnoughTrajectory": "Nicht genügend Verlaufsdaten (mindestens 2 Punkte erforderlich).",
      "nodeLevelScore": "Knoten-Ebene Punktzahl Vergleich",
      "noNodeDataToCompare": "Keine Knotendaten zum Vergleichen",
      "overlayExplainer": "Überlagert die Verbundpunktzahlen der ausgewählten Ausführungen."
    },
    "runs": {
      "title": "Agent Auto-Tuner",
      "subtitle": "End-to-End-Optimierungsläufe für Ihre Agenten",
      "newAutoTune": "Neues Auto-Tune",
      "newAutoTuneButton": "Neues Auto-Tune",
      "selectProjectAgent": "Wählen Sie ein Projekt und einen Agenten aus, um die Optimierung zu starten",
      "project": "Projekt",
      "agent": "Agent",
      "proceed": "Fortfahren",
      "proceedButton": "Fortfahren",
      "startAutoTune": "Auto-Tune starten",
      "metaDashboard": "Meta-Dashboard",
      "metaDashboardButton": "Meta-Dashboard",
      "compareSelected": "Ausgewählte vergleichen",
      "status": "Status",
      "approval": "Freigabe",
      "optimizer": "Optimierer",
      "searchPlaceholder": "Sitzungen suchen...",
      "backToAgentsAria": "Zurück zu Agenten",
      "loadingMessage": "Auto-Tune-Läufe werden geladen...",
      "emptyMessage": "Noch keine Auto-Tune-Läufe vorhanden. Klicken Sie auf 'Neues Auto-Tune', um zu starten.",
      "statuses": {
        "all": "Alle Status",
        "queued": "Warteschlange",
        "running": "Aktiv",
        "baseline_running": "Baseline",
        "optimizing": "Optimierung",
        "validating": "Validierung",
        "completed": "Abgeschlossen",
        "completed_partial": "Teilweise",
        "failed": "Fehlgeschlagen",
        "cancelled": "Abgebrochen"
      },
      "approvals": {
        "all": "Alle Freigaben",
        "pending": "Ausstehend",
        "approved": "Freigegeben",
        "rejected": "Abgelehnt"
      },
      "optimizers": {
        "all": "Alle Optimierer"
      },
      "picker": {
        "loadingProjects": "Projekte werden geladen…",
        "selectProject": "Projekt auswählen…",
        "selectAgent": "Agent auswählen…",
        "selectProjectFirst": "Zuerst Projekt auswählen…",
        "loadingAgents": "Agenten werden geladen…",
        "noAgents": "Keine Agenten in diesem Projekt"
      },
      "columns": {
        "agentName": "Agentenname",
        "dataset": "Datensatz",
        "optimizer": "Optimierer",
        "version": "Version",
        "status": "Status",
        "approval": "Freigabe",
        "baselineScore": "Baseline-Score",
        "postTuneScore": "Post-Tune-Score",
        "holdout": "Holdout",
        "improvement": "Verbesserung",
        "trajectory": "Verlauf",
        "cost": "Kosten",
        "nodes": "Knoten",
        "healing": "Heilung",
        "duration": "Dauer",
        "createdBy": "Erstellt von",
        "createdAt": "Erstellt am",
        "actions": "Aktionen",
        "optimizedNodes": "{{optimized}}/{{total}} optimiert"
      },
      "actions": {
        "compareSelected": "Ausgewählte vergleichen",
        "retry": "Wiederholen",
        "stopRun": "Lauf stoppen",
        "delete": "Löschen",
        "stopConfirm": "Auto-Tune für \"{{label}}\" abbrechen? Dies stoppt die Pipeline (Temporal-Workflow) sofort.",
        "cancelSuccess": "Auto-Tune abgebrochen.",
        "cancelError": "Fehler beim Abbrechen des Auto-Tunes. Bitte versuchen Sie es erneut.",
        "deleteConfirm": "Auto-Tune-Sitzung für \"{{label}}\" löschen? Dies kann nicht rückgängig gemacht werden.",
        "deleteSuccess": "Auto-Tune-Sitzung gelöscht.",
        "deleteError": "Fehler beim Löschen der Sitzung."
      },
      "retryDialog": {
        "title": "Auto-Tune wiederholen",
        "message": "Neues Auto-Tune starten für",
        "messageSuffix": " mit demselben Datensatz und denselben Optionen wie bei diesem Lauf?",
        "confirmLabel": "Wiederholen",
        "successToast": "Neuer Auto-Tune-Lauf gestartet.",
        "errorToast": "Auto-Tune konnte nicht wiederholt werden."
      }
    },
    "detail": {
      "agentStudio": "Agent Studio",
      "autoTuneRunsList": "Auto-Tune Ausführungsliste",
      "backToList": "Zurück zur Liste",
      "sessionOverview": "Sitzungsübersicht",
      "configuration": "Konfiguration",
      "evaluationDetail": "Bewertungsdetails",
      "nodeFeedback": "Knoten-Feedback",
      "nodeComparison": "Knotenvergleich",
      "iterationHistory": "Iterationsverlauf",
      "approveDeploy": "Genehmigen & Bereitstellen",
      "applyChanges": "Änderungen anwenden",
      "rejectOptimization": "Optimierung ablehnen",
      "sessionStatus": "Sitzungsstatus",
      "optimizerConfig": "Optimiererkonfiguration",
      "evaluation": "Bewertung",
      "originalSystemPrompt": "Ursprünglicher System-Prompt",
      "optimizedSystemPrompt": "Optimierter System-Prompt",
      "loading": {
        "opening": "Auto-Tune-Läufe werden geöffnet…",
        "session": "Optimierungssitzung wird geladen..."
      },
      "notFound": {
        "message": "Auto-Tune-Sitzung nicht gefunden",
        "backButton": "Zurück zu Auto-Tune-Läufen"
      },
      "header": {
        "defaultTitle": "Optimierungs-Intelligenzzentrum",
        "workflow": "Workflow",
        "created": "Erstellt",
        "backToRunsAria": "Zurück zu Läufen"
      },
      "banner": {
        "failedTitle": "Optimierung fehlgeschlagen",
        "rejectedTitle": "Optimierter Prompt abgelehnt",
        "noReason": "Es wurde kein Ablehnungsgrund angegeben."
      },
      "tabs": {
        "overview": "Übersicht",
        "objectives": "Zielfunktionen",
        "nodes": "Knotenanalyse",
        "prompts": "Prompt-Labor",
        "regression": "Regressionsanalyse",
        "execution": "Ausführungsverläufe",
        "audit": "Audit & Heilung"
      },
      "applyPanel": {
        "title": "Strategie anwenden",
        "applyCurrent": "Auf aktuellen Agenten anwenden",
        "newVersion": "Als neue Version speichern",
        "previewOnly": "Nur Vorschau",
        "versionBump": "Versionserhöhung:",
        "saveAsNewProject": "Als neues Projekt speichern",
        "projectName": "Projektname",
        "placeholderReason": "Optionaler Grund...",
        "reject": "Ablehnen",
        "approveApply": "Genehmigen & Anwenden",
        "noPermission": "Sie haben keine Berechtigung, Projekte zu erstellen.",
        "previewUnavailable": "Nicht nur für die Vorschau verfügbar — wählen Sie zuerst eine Anwendungsstrategie."
      },
      "overview": {
        "pairedBaseline": "Gepaarte Baseline (Training)",
        "pairedPostMean": "Gepaarter Post-Mittelwert",
        "evalAccuracyImprovement": "Verbesserung der Evaluierungsgenauigkeit",
        "baselineTrain": "Baseline (Training)",
        "baselineHoldout": "Baseline (Holdout)",
        "optimizedScoreTrain": "Optimierter Score (Training)",
        "optimizedScoreHoldout": "Optimierter Score (Holdout)",
        "improvementTrain": "Verbesserung (Training)",
        "improvementHoldout": "Verbesserung (Holdout)",
        "estimatedCost": "Geschätzte Kosten",
        "duration": "Dauer",
        "totalIterations": "Iterationen Gesamt",
        "optimizer": "Optimierer",
        "nodesTotal": "Knoten Gesamt",
        "tokensSession": "Tokens (Sitzung)",
        "metricsUsed": "Verwendete Metriken",
        "orchestrator": "Orchestrator",
        "openWorkflowRun": "Workflow-Lauf öffnen",
        "lightningRuns": "Agent Lightning-Graph Läufe",
        "runId": "Lauf-ID",
        "start": "Start",
        "end": "Ende",
        "optimizedScore": "Optimierter Score",
        "improvement": "Verbesserung",
        "iterations": "Iterationen",
        "holdoutPostTune": "Holdout (Post-Tune)",
        "cost": "Kosten",
        "version": "Version",
        "configurationSummary": "Konfigurationsübersicht",
        "runTimeline": "Ablauf-Zeitplan",
        "timeline": {
          "created": "Erstellt",
          "started": "Gestartet",
          "completed": "Abgeschlossen",
          "approvedBy": "Freigegeben von {{user}}"
        },
        "noMetricBreakdown": "Für diese Sitzung ist keine Aufschlüsselung pro Metrik verfügbar (z. B. wurden die Scores nicht pro Metrik gespeichert). Öffnen Sie die Bewertungsdetails (Info-Symbol), um zu sehen, wie die Haupt-Scores definiert sind.",
        "metricBreakdownTitle": "Aufschlüsselung der Metriken",
        "columnMetric": "Metrik",
        "columnBaseline": "Baseline",
        "columnOptimized": "Optimiert",
        "columnDelta": "Delta",
        "columnChange": "Änderung",
        "explainerLead": "Scores sind eine einzige Zusammensetzung im Bereich von 0–1, die aus Ihren Evaluierungsmetriken erstellt und dann über Benchmark-Zeilen aggregiert wird.",
        "explainerStep1Title": "Zeilenweise Zusammensetzung (Ziel)",
        "explainerStep1Desc": "Für jede Datensatzzeile führt das System die konfigurierten Evaluatoren aus (siehe Metriken unten) und erzeugt einen Score pro Metrik. Metriken, bei denen niedrigere Rohwerte besser sind (z. B. Toxizität), werden so zugeordnet, dass höhere Werte vor dem Mischen immer besser bedeuten.",
        "explainerWeightedSumPrefix": "Der Zeilenscore ist eine",
        "explainerWeightedSum": "gewichtete Summe",
        "explainerWeightedSumMid": "dieser angepassten Scores:",
        "explainerWeightedSumSuffix1": ", unter Verwendung von",
        "explainerWeightedSumSuffix2": "aus dieser Sitzung (normalisiert auf eine Summe von 1).",
        "explainerUnweightedPrefix": "Keine",
        "explainerUnweightedMid": "sind festgelegt, daher ist der Zeilenscore der",
        "explainerUnweighted": "ungewichtete Durchschnitt",
        "explainerUnweightedSuffix": "der angepassten Metrik-Scores für diese Zeile.",
        "explainerStep2Title": "Baseline-Score (Trainings-Split)",
        "explainerStep2Desc": "Die Headline-Baseline ist das arithmetische Mittel der pro-Zeile zusammengesetzten Scores im Trainings-Split (Holdout-Zeilen ausgeschlossen), wobei nur konfigurierte Sitzungsmetriken über Zeilen verwendet werden, die ohne Ausführungsfehler abgeschlossen wurden:",
        "explainerStep3Title": "Optimierter Score und Verlauf",
        "explainerStep3Desc": "Die gleiche Definition der Zusammensetzung wird verwendet, wenn der Agent nach Prompt-Änderungen bewertet wird; der optimierte Headline-Score und die Iterationskurve verwenden dieselbe Skala.",
        "explainerMultiObjEnabled": "Multi-Objektiv-Modus ist aktiviert.",
        "explainerMultiObjMid": "(unten) kann die Multi-Objektiv-Optimierung steuern; Baseline und Zeilenzusammensetzungen folgen weiterhin",
        "explainerMultiObjSuffix": "wenn festgelegt, ansonsten gleiche Gewichtung wie oben beschrieben.",
        "explainerMetricsEvaluated": "In dieser Sitzung evaluierte Metriken",
        "explainerRowWeights": "Zeilen-Zusammensetzungsgewichtungen",
        "explainerMultiObjWeights": "Multi-Objektiv-Gewichtungen",
        "columnRawWeight": "Rohgewicht",
        "columnNormalized": "Normalisiert",
        "columnMetricObjective": "Metrik / Ziel",
        "explainerThisSession": "Diese Sitzung:",
        "explainerBaselineTrain": "Baseline (Training) =",
        "explainerOptimizedEquals": "Optimiert ="
      },
      "objectives": {
        "noObjectives": "Keine Ziele definiert",
        "columnName": "Zielname",
        "columnWeight": "Gewichtung",
        "columnFormula": "Formel",
        "columnDescription": "Beschreibung"
      },
      "nodes": {
        "noNodes": "Keine Knotenergebnisse verfügbar",
        "columnId": "Knoten-ID",
        "columnOptimizer": "Optimierer",
        "columnBaseline": "Baseline-Score",
        "columnOptimized": "Optimierter Score",
        "columnImprovement": "Verbesserung",
        "columnTrajectory": "Verlauf",
        "columnHoldout": "Holdout-Score",
        "columnHoldoutImp": "Holdout-Verbesserung",
        "customPrompt": "Benutzerdefinierter System-Prompt",
        "modelOverride": "Modell-Override",
        "instructionsOverride": "DSPy-Anweisungs-Override",
        "columnNode": "Knoten",
        "columnIter": "Iter",
        "columnBlame": "Schuld",
        "columnOriginalTrain": "Original (Training)",
        "columnOptimizedTrain": "Optimiert (Training)",
        "columnHealing": "Heilung",
        "columnCost": "Kosten",
        "collapse": "Einklappen",
        "showConfig": "Konfigurations- / Optimiererdetails anzeigen",
        "noNodeAnalysisData": "Für diese Sitzung sind keine Knotenanalysedaten verfügbar."
      },
      "prompts": {
        "nodeLabel": "Knoten:",
        "selectNode": "Wählen Sie einen Knoten aus, um seine Prompts zu untersuchen...",
        "originalSystemPrompt": "Originaler System-Prompt",
        "optimizedSystemPrompt": "Optimierter System-Prompt",
        "originalInstructions": "Originale Anweisungen (DSPy)",
        "optimizedInstructions": "Optimierte Anweisungen (DSPy)",
        "versionBase": "Basis",
        "versionLatest": "Zuletzt optimiert",
        "selectVersion": "Version auswählen",
        "fallbackLeft": "Links",
        "fallbackRight": "Rechts",
        "noData": "Für diese Sitzung sind keine Prompt- oder Parameterdaten verfügbar."
      },
      "regression": {
        "noData": "Keine Regressionsanalysedaten verfügbar.",
        "columnRowIndex": "Zeilenindex",
        "columnBaseline": "Baseline",
        "columnOptimized": "Optimiert",
        "columnChange": "Änderung",
        "columnInput": "Eingabevorschau",
        "columnError": "Fehler",
        "columnOutput": "Ausgabevorschau",
        "improvedRows": "Verbesserte Zeilen",
        "degradedRows": "Verschlechterte Zeilen",
        "quarantinedRows": "Quarantänisierte Zeilen",
        "columnRowNumber": "Zeile #",
        "columnQuestionInput": "Frage / Eingabe",
        "columnDelta": "Delta",
        "columnWhatChanged": "Was hat sich geändert",
        "columnInputPreview": "Eingabevorschau",
        "columnOutputPreview": "Ausgabevorschau",
        "metricNetImprovement": "Nettoverbesserung",
        "metricImprovedRows": "Verbesserte Zeilen",
        "metricDegradedRows": "Verschlechterte Zeilen",
        "metricUnchangedRows": "Unveränderte Zeilen",
        "metricTotalRows": "Gesamtzeilen",
        "metricHoldoutEvaluated": "Holdout-Zeilen ausgewertet",
        "noDegradedRows": "Keine verschlechterten Zeilen",
        "noImprovedRows": "Keine verbesserten Zeilen",
        "noQuarantinedRows": "Keine quarantänisierten Zeilen",
        "noReport": "Kein Regressionsbericht oder in Quarantäne befindliche Zeilen für diese Sitzung."
      },
      "execution": {
        "title": "Pipeline-Ausführungszeitplan",
        "noData": "Keine Ausführungszeitplandaten verfügbar.",
        "columnTask": "Aufgabe / Phase",
        "columnDuration": "Dauer",
        "columnStatus": "Status",
        "columnDetails": "Details / Ausgabe",
        "activeRun": "Aktiver Lauf",
        "currentProcess": "Aktueller Prozess",
        "activeNode": "Aktiver Knoten",
        "optimizingNode": "Knoten optimieren: {{node}}",
        "nodeId": "Knoten-ID",
        "lastProcess": "Letzter Prozess",
        "phaseDurationWaterfall": "Phasendauer-Wasserfall",
        "phaseDurationDesc": "Abgeschlossene Laufphasendauern in Sekunden (chronologisch).",
        "phaseDurationExplainer": "Jeder Balken ist eine abgeschlossene Workflow-Phase (Baseline, Joint/Lightning, Knoten-Optimierung, Validierung). Die Höhen sind die Dauer in Sekunden; der finale Gesamtknoten summiert alle abgeschlossenen Phasen.",
        "phaseDurationsPending": "Phasendauern werden hier angezeigt, sobald die Stufen abgeschlossen sind.",
        "phaseDurationsEmpty": "Für diesen Lauf wurde kein Phasendauer-Verlauf aufgezeichnet.",
        "phaseLog": "Phasenprotokoll",
        "fallbackPhase": "Phase {{num}}"
      },
      "audit": {
        "healingEvents": "Heilungsereignisse",
        "auditTrail": "Audit-Trail",
        "noData": "Keine Audit- oder Heilungsdaten für diese Sitzung verfügbar.",
        "auditTrailCount": "Audit-Trail"
      },
      "charts": {
        "scoreTrajectory": "Punkteverlauf",
        "baselineObjective": "Baseline- & Zielbewertung",
        "metricComparison": "Metrikvergleich: Baseline vs Optimiert",
        "convergenceAnalysis": "Konvergenzanalyse",
        "blameWaterfall": "Schuld-Wasserfall",
        "costTokenBreakdown": "Kosten- & Token-Aufschlüsselung pro Knoten",
        "scatterBaselineOpt": "Baseline vs Optimiert Scatter (Trainingszeilen)",
        "phaseDuration": "Phasendauer-Wasserfall",
        "howToRead": "So lesen Sie dieses Diagramm",
        "xAxisPhase": "Phase",
        "yAxisDuration": "Dauer (Sekunden)",
        "summaryScoreTrajectory": "Zusammengesetzter Score bei jedem Meilenstein (Baseline, optionales Lightning, Optimierungsiterationen, Validierung), mit Schritt-für-Schritt-Deltas auf der zweiten Achse.",
        "summaryBaselineObjective": "Zusammengesetzte 0–1 Scores Ihrer Metriken; Baseline-Durchschnitte über erfolgreiche Zeilen. Verwenden Sie das Info-Symbol für Formeln, Gewichtungen und die Werte dieser Sitzung.",
        "summaryMetricComparison": "Gruppierte Balken vergleichen den Baseline-Wert jeder konfigurierten Metrik mit dem Durchschnitt nach der Abstimmung.",
        "summaryConvergenceAnalysis": "|Δ Score| zwischen aufeinanderfolgenden Verlaufspunkten – hilft zu erkennen, wann sich Verbesserungen verlangsamen oder abflachen.",
        "summaryBlameWaterfall": "Relative Schuldwerte pro Canvas-Knoten – höhere Balken weisen auf Knoten hin, die mehr zu schlechten Baseline-Ergebnissen beigetragen haben und in der Regel für die Optimierung priorisiert werden.",
        "summaryCostTokenBreakdown": "Gesamte Prompt- und Completion-Token (linke Achse) sowie geschätzte Kosten (rechte Achse), die jedem Knoten über alle Evaluierungen hinweg zugeschrieben werden.",
        "summaryScatterBaselineOpt": "Jeder Punkt ist eine Trainingszeile nach der Validierung: x = zusammengesetzter Score vor der Abstimmung, y = zusammengesetzter Score mit abgestimmten Prompts. Die gestrichelte Diagonale ist die Linie der Unveränderlichkeit (y = x)."
      }
    }
  },
  "aiTransparency": {
    "title": "KI-Transparenz",
    "loadingInventory": "KI-Transparenzinventar wird geladen...",
    "allSystemAgents": "Alle Systemagenten",
    "systemAgent": "Systemagent",
    "registeredBy": "Registriert von",
    "project": "Projekt",
    "agentSubAgent": "Agent / Unteragent",
    "env": "Umgebung",
    "subAgentCount": "Anzahl der Unteragenten",
    "actions": "Aktionen",
    "viewMetadata": "Metadaten anzeigen",
    "searchAgents": "Agenten suchen...",
    "emptyMessage": "Noch keine registrierten Agenten. Registrieren Sie veröffentlichte Agenten aus Agent Studio, um sie hier zu sehen.",
    "unknown": "Unbekannt",
    "status": "Status",
    "metadata": "Metadaten",
    "expandAgent": "{{name}} erweitern",
    "collapseAgent": "{{name}} einklappen",
    "subAgentFallback": "Unteragent {{index}}",
    "subAgentTypes": {
      "agent": "Unteragent",
      "supervisor": "Supervisor",
      "intent_classifier": "Intent-Klassifikator",
      "disambiguation": "Disambiguierung",
      "external_agent": "Externer Agent",
      "rlm": "RLM",
      "router": "Router",
      "hitl": "Menschliche Freigabe",
      "sub_agent": "Unteragent"
    }
  },
  "registry": {
    "agents": {
      "columnAgentName": "Agent Name",
      "registerAgent": "Agenten registrieren",
      "searchRegisteredAgents": "Registrierte Agenten suchen...",
      "searchArchivedAgents": "Archivierte Agenten suchen...",
      "emptyActiveAgentsDesc": "Noch keine Agenten registriert. Registrieren Sie veröffentlichte Agenten aus dem Agent Studio, um sie hier zu sehen.",
      "emptyArchivedAgentsDesc": "Keine archivierten Agenten. Agenten, die aus der Registrierung archiviert wurden, werden hier angezeigt.",
      "registeredAgentsTitle": "Registrierte Agenten",
      "archivedAgentsTitle": "Archivierte Agenten",
      "agentsLabel": "Agenten",
      "agentRegistryTitle": "Agenten-Registrierung",
      "filterSystemAgent": "System-Agent",
      "filterAllSystemAgents": "Alle System-Agenten",
      "loadingAgents": "Agenten werden geladen...",
      "searchAgents": "Agenten suchen...",
      "dynamicFilter_agent_type": "Typ",
      "columnAgent": "Agent",
      "editAgentTitle": "Edit Agent",
      "configureAgentTitle": "Configure {{platformName}}",
      "registerAgentBtn": "Register Agent",
      "selectAgentPlatformDesc": "Wählen Sie die Plattform aus, auf der Ihr Agent erstellt wurde",
      "importAgentsTitle": "Agenten aus CSV importieren",
      "importAgentsDesc": "Erstellt nur externe Agenten. Zeilen, die einem vorhandenen Namen + Version entsprechen, werden übersprungen. Anmeldeinformationen werden niemals aus der CSV gelesen.",
      "agentEntity": "agent"
    },
    "workflows": {
      "columnWorkflow": "Workflow-Name",
      "workflowsLabel": "Workflows",
      "searchRegisteredWorkflows": "Registrierte Workflows durchsuchen...",
      "searchArchivedWorkflows": "Archivierte Workflows durchsuchen...",
      "loadingRegisteredWorkflows": "Registrierte Workflows werden geladen...",
      "loadingArchivedWorkflows": "Archivierte Workflows werden geladen...",
      "emptyRegisteredWorkflows": "Noch keine Workflows registriert.",
      "emptyArchivedWorkflows": "Keine archivierten Workflows.",
      "bulkArchiveWorkflows": "Ausgewählte archivieren",
      "bulkRestoreWorkflows": "Ausgewählte wiederherstellen",
      "workflowRegistryTitle": "Workflow-Registrierung",
      "registeredWorkflowsTitle": "Registrierte Workflows",
      "archivedWorkflowsTitle": "Archivierte Workflows",
      "registerExternalWorkflowTitle": "Register External Workflow",
      "selectWorkflowPlatformDesc": "Wählen Sie die Plattform, auf der Ihr Workflow erstellt wurde. Diese Registrierung dient nur dem Katalog.",
      "importWorkflowsTitle": "Workflows aus CSV importieren",
      "importWorkflowsDesc": "Erstellen Sie nur Entwurfs-Workflows. Der Übereinstimmungsschlüssel ist Name + Version.",
      "workflowEntity": "workflow",
      "loading": "Workflows werden geladen..."
    },
    "guardrails": {
      "guardrailsLabel": "Guardrails",
      "actionGuardrails": "Guardrails",
      "guardrailsRepository": "Guardrail-Repository",
      "agentGuardrails": "Agenten-Guardrails",
      "guardrailsCoverage": "Abdeckung",
      "searchProfiles": "Profile suchen...",
      "newProfile": "Neues Profil",
      "noGuardrailsAccess": "Sie haben keinen Zugriff auf Guardrails-Unterfunktionen.",
      "loadingProfiles": "Profile werden geladen...",
      "columnAttachedProfiles": "Angehängte Profile",
      "coverageBanner": "Nur konfigurierte Abdeckung — ändert die Durchsetzung nicht. Lücken sind Inventarsignale.",
      "exportCoverageCsv": "CSV exportieren",
      "loadingCoverage": "Abdeckungskarte wird geladen...",
      "coverageCovered": "Abgedeckt",
      "coverageGap": "Lücke",
      "coverageNA": "N/A",
      "coverageUnknown": "Unbekannt",
      "createProfileBtn": "Profil erstellen",
      "savingProfileBtn": "Wird gespeichert...",
      "updateProfileBtn": "Profil aktualisieren",
      "editProfileTitle": "Profil bearbeiten",
      "newGuardrailProfileTitle": "Neues Guardrail-Profil",
      "profileNameLabel": "Profilname *",
      "profileNamePlaceholder": "z.B. PII Schutzstandard",
      "profileNameHint": "Nur Buchstaben, Zahlen, Leerzeichen, Bindestriche und Unterstriche",
      "profileDescLabel": "Beschreibung",
      "profileDescPlaceholder": "Beschreiben Sie dieses Guardrail-Profil...",
      "profileDescHint": "Nur reiner Text — keine Emojis oder Sonderzeichen",
      "guardrailsEnabled": "Guardrails aktiviert",
      "guardrailsDisabled": "Guardrails deaktiviert",
      "noEnginesConfigured": "Keine Guardrail-Engines konfiguriert",
      "enginesActive": "{{enabledCount}}/{{totalCount}} Engines aktiv",
      "inactiveDeploymentBanner": "Die Bereitstellung dieses Agenten ist inaktiv. Die Konfiguration ist eingeschränkt.",
      "devFrozenBanner": "Dieser Agent ist veröffentlicht. DEV-Guardrails sind eingefroren — bearbeiten Sie stattdessen die QA/UAT/PROD-Bereitstellungs-Guardrails.",
      "adminOnlyBanner": "Deployment guardrails can only be modified by administrators.",
      "recentViolations": "Recent Violations",
      "metricsSummaryTitle": "Metriken-Zusammenfassung",
      "metricTotalChecks": "GESAMTPRÜFUNGEN",
      "metricBlocked": "BLOCKIERT",
      "metricWarned": "WARNUNGEN",
      "metricPassed": "BESTANDEN",
      "metricErrors": "FEHLER",
      "metricLatency": "LATENZ",
      "searchViolationsPlaceholder": "Verstöße suchen...",
      "noRecentViolations": "Keine aktuellen Verstöße",
      "violationTimestamp": "Zeitstempel",
      "violationUser": "Benutzer",
      "violationEngine": "Engine",
      "violationStatus": "Status",
      "violationDetails": "Details",
      "violationAction": "Aktion",
      "violationRule": "Regel",
      "columnEngines": "Engines",
      "loading": "Guardrails werden geladen...",
      "configMode": "MODUS",
      "configExecution": "AUSFÜHRUNG",
      "configTimeout": "STANDARD-TIMEOUT (SEKUNDEN)",
      "configSafeMessage": "SICHERE NACHRICHT",
      "configCircuitBreaker": "SCHUTZSCHALTER",
      "configFailureThreshold": "FEHLERSCHWELLENWERT",
      "configCooldown": "ABKÜHLZEIT (SEKUNDEN)",
      "modeBlock": "Blockieren — Markierte Inhalte blockieren",
      "modeObserve": "Beobachten — Nur protokollieren, nicht blockieren",
      "execSequential": "Sequentiell",
      "execParallel": "Parallel",
      "safeMessagePlaceholder": "Ich kann diese Anfrage aufgrund von Inhaltsrichtlinien nicht bearbeiten.",
      "mode_block": "Blockieren — Markierte Inhalte blockieren",
      "mode_warn": "Warnen — Warnung protokollieren, Inhalte zulassen",
      "mode_shadow": "Beobachten — Nur protokollieren, nicht blockieren",
      "exec_sequential": "Sequentiell",
      "exec_parallel": "Parallel"
    },
    "common": {
      "columnProject": "Projekt",
      "columnVersion": "Version",
      "exportCsvTitle": "CSV exportieren (inklusive Spaltenkonfiguration)",
      "exportCsvAria": "CSV exportieren",
      "importCsvTitle": "CSV importieren",
      "importCsvAria": "CSV importieren",
      "columnEnv": "Umgebung",
      "columnOrchestrator": "Orchestrator",
      "columnFramework": "Framework",
      "columnRegisteredBy": "Registriert von",
      "columnRegisteredAt": "Registriert am",
      "columnArchivedAt": "Archiviert am",
      "columnActions": "Aktionen",
      "columnStatus": "Status",
      "filterBarTitle": "Filter",
      "filterAll": "Alle",
      "filterFavorites": "Favoriten",
      "filterFramework": "Framework",
      "filterProject": "Projekt",
      "filterRegisteredBy": "Registriert von",
      "filterType": "Typ",
      "filterStatus": "Status",
      "loadingRegistered": "Registrierte Agenten werden geladen...",
      "loadingArchived": "Archivierte Agenten werden geladen...",
      "bulkArchive": "Ausgewählte archivieren",
      "bulkRestore": "Ausgewählte wiederherstellen",
      "bulkDelete": "Ausgewählte löschen",
      "deleteSelected": "Ausgewählte löschen",
      "showLess": "Weniger",
      "actionTest": "Testen",
      "actionExecute": "Ausführen",
      "actionEdit": "Edit",
      "actionViewMetadata": "Metadaten anzeigen",
      "actionEditMetadata": "Metadaten bearbeiten",
      "actionEvaluate": "Bewerten",
      "actionViewEvalRuns": "Bewertungsläufe anzeigen",
      "actionTraces": "Traces",
      "actionLogs": "Logs",
      "actionApiDocs": "API-Dokumentation",
      "actionClone": "Klonen",
      "actionDeploy": "Bereitstellen",
      "actionDelete": "Delete",
      "actionArchive": "Aus Registrierung archivieren",
      "actionRestore": "In Registrierung wiederherstellen",
      "actionOpen": "Öffnen",
      "actionPromoteToStore": "Im Store bewerben",
      "actionRuns": "Läufe",
      "actionOpenCanvas": "Canvas öffnen",
      "registerExternal": "Extern registrieren",
      "allCreators": "Alle Ersteller",
      "searchCreators": "Ersteller suchen...",
      "creatorLabel": "Ersteller",
      "tableRows": "Zeilen:",
      "tableShowing": "Zeige {{startItem}}-{{endItem}} von {{totalItems}}",
      "filterResultsOf": "{{resultCount}} von {{totalCount}}",
      "filterResultsCount": "{{count}} Ergebnisse",
      "filterLess": "Weniger",
      "filterMore": "mehr",
      "filterClearAll": "Alle Filter löschen",
      "filterClear": "Löschen",
      "filterSavePreset": "Filter-Voreinstellung speichern",
      "noDataAvailable": "Keine Daten verfügbar",
      "actionView": "View",
      "filterAllEnvironments": "Alle Umgebungen",
      "dynamicFilter_status": "Status",
      "dynamicFilter_catalog_status": "Status",
      "dynamicFilter_type": "Typ",
      "columnEnvShort": "Umgebung",
      "columnChat": "Chat",
      "columnAPI": "API",
      "columnVoice": "Stimme",
      "columnRAG": "RAG",
      "columnTools": "Werkzeuge",
      "columnEnabled": "Aktiviert",
      "columnMode": "Modus",
      "columnContentSafety": "Inhaltssicherheit",
      "columnJailbreak": "Jailbreak / Prompt Shields",
      "columnDLP": "DLP / PII",
      "columnProfileAttached": "Profil zugeordnet",
      "columnWorkflowChannel": "Workflow",
      "cancelBtn": "Abbrechen",
      "globalSettings": "Globale Einstellungen",
      "architectureTitle": "Architecture",
      "reviewSaveTitle": "Review & Save",
      "reviewRegisterTitle": "Review & Register",
      "stepReview": "Überprüfung",
      "stepPlatform": "Plattform",
      "stepConfigure": "Konfigurieren",
      "stepArchitecture": "Architektur",
      "savingBtn": "Saving...",
      "registeringBtn": "Registering...",
      "saveChangesBtn": "Save changes",
      "statusActive": "active",
      "statusInactive": "inactive",
      "statusPublished": "PUBLISHED",
      "actionDeleteSelected": "Delete Selected",
      "columnName": "Name",
      "columnDescription": "Description",
      "expectedColumns": "ERWARTETE SPALTEN",
      "platformAdminConfigureFields": "Konfigurationsfelder des Plattformadministrators",
      "downloadTemplate": "Vorlage herunterladen",
      "chooseCsv": "CSV auswählen",
      "importBtn": "Importieren",
      "importingBtn": "Importiere...",
      "dynamicOption_agent": "Agent",
      "dynamicOption_sub-agent": "Unteragent",
      "closeBtn": "Schließen",
      "statRows": "Zeilen",
      "statCreated": "Erstellt",
      "statDuplicates": "Duplikate",
      "statErrors": "Fehler",
      "viewDuplicates": "Duplikate anzeigen",
      "dupTitle": "Import-Duplikate übersprungen",
      "dupRowsProcessed": "Verarbeitete Zeilen",
      "dupCreated": "Erstellt",
      "dupSkipped": "Übersprungene Duplikate",
      "dupHint2": "haben diesen Namen bereits in der Datenbank, wurden aber nicht in der Registrierung angezeigt; umbenennen oder erhöhen",
      "dupNoMatch": "Keine Duplikate entsprechen diesem Filter.",
      "dupSearchPlaceholder": "Duplikate suchen...",
      "dupRowsPerPage": "Zeilen pro Seite:",
      "hideAll": "Alle ausblenden",
      "showAll": "Alle anzeigen",
      "loading": "Wird geladen..."
    }
  },
  "exportImport": {
    "import": {
      "dialogTitle": "YAML importieren",
      "bulkDialogTitle": "Massenimport",
      "filesCount": "{{count}} Datei",
      "filesCount_plural": "{{count}} Dateien",
      "validFilesCount": "{{count}} gültige Datei",
      "validFilesCount_plural": "{{count}} gültige Dateien",
      "withErrorsCount": "{{count}} mit Fehler",
      "withErrorsCount_plural": "{{count}} mit Fehlern",
      "switchToSingle": "Zu Einzeldatei wechseln",
      "switchToBulk": "Zu Massenimport wechseln",
      "targetProject": "Zielprojekt",
      "optional": "(optional)",
      "selectTargetProject": "Zielprojekt auswählen...",
      "selectProjectOptional": "Projekt auswählen (optional)...",
      "selectProjectWarning": "Bitte wählen Sie ein Projekt aus, um {{entity}} zu importieren",
      "thisEntity": "diese Entität",
      "dropzoneBulk": "YAML-Dateien ablegen oder klicken zum Durchsuchen (mehrere erlaubt)",
      "dropzoneSingle": "YAML-Datei ablegen oder klicken zum Durchsuchen",
      "fileTypes": ".yaml, .yml",
      "importingProgress": "Importiere {{current}} von {{total}}...",
      "yamlContentLabel": "YAML-Inhalt",
      "yamlPlaceholderComment": "YAML-Inhalt hier einfügen oder bearbeiten",
      "importBehavior": "Importverhalten",
      "matchOrCreate": "Abgleichen oder erstellen",
      "matchOrCreateDesc": "Mit vorhandenen Entitäten verknüpfen, neu erstellen falls nicht gefunden",
      "matchOnly": "Nur abgleichen",
      "matchOnlyDesc": "Nur mit vorhandenen verknüpfen, überspringen falls nicht gefunden",
      "createNew": "Neu erstellen",
      "createNewDesc": "Immer neu erstellen, fehlschlagen wenn bereits vorhanden",
      "previewResults": "Vorschauergebnisse",
      "newBadge": "+{{count}} neu",
      "skippedBadge": "{{count}} übersprungen",
      "failedBadge": "{{count}} fehlgeschlagen",
      "createdBadge": "+{{count}} erstellt",
      "moreEntities": "+{{count}} weitere Entitäten",
      "moreErrors": "+{{count}} weitere Fehler",
      "moreWarnings": "+{{count}} weitere",
      "importSuccessful": "Import erfolgreich",
      "bulkImportComplete": "Massenimport abgeschlossen",
      "importFailed": "Import fehlgeschlagen",
      "bulkImportCompletedWithErrors": "Massenimport mit Fehlern abgeschlossen",
      "notes": "Hinweise:",
      "errors": "Fehler:",
      "done": "Fertig",
      "cancel": "Abbrechen",
      "preview": "Vorschau",
      "import": "Importieren",
      "importing": "Importiere...",
      "importAll": "Alle importieren ({{count}})",
      "removeFile": "Datei entfernen",
      "buttonTitle": "YAML importieren",
      "buttonAria": "YAML importieren",
      "buttonLabel": "Importieren",
      "failedToReadFile": "Datei konnte nicht gelesen werden",
      "invalidYaml": "Ungültiges YAML",
      "importFailedGeneric": "Import fehlgeschlagen",
      "typeMismatchError": "Diese Datei enthält ein(e) {{detectedName}}, aber Sie befinden sich auf der Seite {{expectedName}}s. Bitte importieren Sie diese Datei von der richtigen Seite."
    },
    "configWarnings": {
      "title": "Konfiguration erforderlich",
      "subtitle": "Die importierte Entität funktioniert möglicherweise erst ordnungsgemäß, wenn die folgenden Punkte konfiguriert sind:",
      "actionRequired": "Aktion erforderlich:",
      "actionRequiredDesc": "{{criticalCount}} kritische(s) {{criticalLabel}} und {{warningCount}} {{warningLabel}} gefunden. Der Agent funktioniert möglicherweise nicht ohne Behebung der kritischen Probleme.",
      "actionRequiredOnlyCritical": "{{criticalCount}} kritische(s) {{criticalLabel}} gefunden. Der Agent funktioniert möglicherweise nicht ohne Behebung der kritischen Probleme.",
      "issue": "Problem",
      "issues": "Probleme",
      "warning": "Warnung",
      "warnings": "Warnungen",
      "critical": "Kritisch",
      "categories": {
        "model": "KI-Modelle",
        "models": "KI-Modelle",
        "prompt": "Prompts",
        "prompts": "Prompts",
        "tool": "Tools",
        "tools": "Tools",
        "knowledge": "Wissensquellen",
        "skill": "Skills",
        "skills": "Skills",
        "connector": "Konnektoren",
        "connectors": "Konnektoren",
        "iam": "IAM-Konfigurationen",
        "other": "Sonstiges"
      }
    },
    "export": {
      "export": "Exportieren",
      "exportSelected": "Ausgewählte exportieren",
      "exportYaml": "YAML exportieren",
      "exportAgent": "Agent exportieren",
      "agentAlwaysIncluded": "Agent (immer enthalten)",
      "included": "Enthalten",
      "dependencies": "Abhängigkeiten",
      "selectedOf": "{{selected}} von {{total}} ausgewählt",
      "selectAll": "Alle auswählen",
      "deselectAll": "Alle abwählen",
      "loadingDeps": "Lade Abhängigkeiten...",
      "noDeps": "Keine Abhängigkeiten gefunden. Nur der Agent wird exportiert.",
      "permissionDenied": "Sie haben keine Berechtigung zum Exportieren dieses Agenten. Bitte wenden Sie sich an Ihren Administrator.",
      "failedToLoadDeps": "Fehler beim Laden der Abhängigkeiten",
      "filesWillBeExported": "{{count}} YAML-Datei wird exportiert",
      "filesWillBeExported_plural": "{{count}} YAML-Dateien werden exportiert",
      "cancel": "Abbrechen",
      "confirmExport": "Export bestätigen",
      "exporting": "Exportiere..."
    },
    "entityTypes": {
      "model": "Modell",
      "tool": "Tool",
      "prompt": "Prompt",
      "skill": "Skill",
      "agent": "Agent",
      "knowledge": "Wissensquelle",
      "storage_folder": "Speicherordner",
      "connector": "Konnektor",
      "iam": "IAM-Konfiguration",
      "bundle": "Paket",
      "workflow": "Workflow"
    }
  }
}